var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--floor--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-73",
    d: "M77.66,242.7c-95.18,54.95-95.17,144,0,199s249.49,54.95,344.67,0,95.17-144,0-199S172.84,187.75,77.66,242.7Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.5,227.62l6.84,3.94-15.75,9.1-15.75-9.1,14-8.09-1-.38-13.84,8L350.26,222l9.48-5.48-1.09-.32-9.21,5.32-15.75-9.09,3.05-1.77-1.19-.26L332.87,212l-5.6-3.23-2.46-.47,7.24,4.18-15.76,9.09-15.75-9.09L311.6,206l-1.3-.19L299.72,212,284,202.86h0l-1.9-.14.26.15L266.58,212l-15.76-9.09,2.35-1.36h-1.63l-1.54.89-1.54-.89h-1.62l2.34,1.36L233.43,212l-15.76-9.09.26-.15-1.9.14h0L200.28,212l-10.58-6.11-1.31.2,11.07,6.39-15.75,9.09L168,212.43l7.25-4.19-2.46.48L167.13,212l-2.68-1.55-1.19.26,3.05,1.77-15.75,9.09-9.22-5.32-1.08.32,9.48,5.48L134,231.09l-13.86-8-1,.37,14,8.1-15.75,9.1-15.75-9.1,6.86-4q-3.17,1.31-6.28,2.68L56.15,256.89c-1.7,1.28-3.35,2.58-5,3.89l15.69,9.06-15.75,9.09-12.26-7.07-.6.6,12,7L34.54,288.5l-6.9-4-.51.65L33.72,289l-14.91,8.61c-.28.48-.56,1-.83,1.44l15.74,9.08L18,317.21l-6.55-3.78c-.1.26-.19.52-.28.78l6,3.47-8.5,4.91c-.09.36-.16.73-.25,1.09L18,318.16l15.75,9.09L18,336.35,7.19,330.12c0,.29-.09.58-.13.88l10.09,5.82L6.3,343.09c0,.31,0,.62,0,.93L18,337.29l15.75,9.1L18,355.48,6.56,348.89c0,.34.07.68.1,1L17.15,356l-8.69,5c.07.28.13.56.2.84L18,356.43l15.75,9.1L18,374.62l-6.61-3.81c.14.39.28.79.43,1.19l5.36,3.1L13.84,377l.33.75,3.8-2.19,15.75,9.09-12,6.93.45.69,12.36-7.14,15.76,9.09-15.76,9.1-7.64-4.41,1.34,1.72,5.48,3.16-1.94,1.13.55.62,2.21-1.27,15.76,9.09-6.59,3.8.64.58,6.77-3.91,15.75,9.1-9.49,5.48c.23.18.48.35.72.53l9.59-5.54,15.75,9.1-10.76,6.21.8.49L84.26,433l15.76,9.1-10.45,6,.87.44,10.4-6,15.75,9.1L108,456.58l.95.4,8.42-4.86,15.75,9.09-5,2.88,1,.35,4.77-2.75,14.78,8.54,3,.77-.37-.22,15.75-9.09,15.75,9.09L174,475.91l1.23.24,8.47-4.89,14.67,8.46c1,.14,2.11.26,3.16.38l15.32-8.84,15.76,9.09-3.52,2,1.52.07,2.82-1.62,3.22,1.86,1.74.06-4.14-2.4L250,471.26l15.75,9.09-4.14,2.4,1.74-.06,3.22-1.86,2.82,1.62,1.52-.07-3.52-2,15.76-9.09,15.32,8.84,3.15-.37,14.67-8.47,8.48,4.89,1.23-.24-8.89-5.13,15.76-9.09,15.75,9.09-.38.22,3-.77L366,461.69l4.77,2.75,1.05-.35-5-2.88,15.76-9.09L391,457l.95-.4-8.55-4.93,15.75-9.1,10.4,6,.88-.45-10.46-6,15.75-9.1,10.8,6.23.79-.49-10.76-6.21,15.75-9.1L441.9,429l.73-.53-9.5-5.48,15.75-9.1,6.77,3.91.64-.58-6.59-3.8,15.76-9.1,2.21,1.28.56-.62-2-1.13,5.49-3.17,1.34-1.72-7.65,4.42-15.76-9.1,15.76-9.09,12.36,7.14.45-.69-12-6.93L482,375.57l3.8,2.19c.11-.25.22-.5.34-.75l-3.32-1.91,5.36-3.1c.15-.4.29-.8.43-1.2L482,374.62l-15.75-9.09,15.75-9.1,9.32,5.38c.06-.28.12-.56.19-.84l-8.69-5,10.49-6.06c0-.34.08-.67.11-1L482,355.48l-15.75-9.09,15.75-9.1L493.68,344c0-.31,0-.62,0-.93l-10.85-6.27L492.94,331c0-.3-.09-.59-.13-.88L482,336.35l-15.75-9.1L482,318.16l9.57,5.52c-.09-.36-.17-.73-.25-1.09l-8.5-4.91,6-3.47c-.09-.26-.18-.52-.28-.78L482,317.21l-15.75-9.1L482,299c-.27-.49-.56-1-.83-1.45L466.28,289l6.59-3.81-.51-.65-6.9,4-15.76-9.09,12-7-.6-.6-12.26,7.07-15.75-9.09,15.68-9.06c-1.62-1.31-3.28-2.62-5-3.91l-46-26.58C395.71,229.38,393.61,228.49,391.5,227.62Zm6.84,23.08-15.75,9.1-15.75-9.1,15.75-9.09Zm-65.47,95.22-15.76-9.1,15.76-9.09,15.75,9.09Zm16.57-8.63,15.75,9.1-15.75,9.09-15.75-9.09Zm-198.06-.47,15.75-9.09,15.76,9.09-15.76,9.1Zm14.93,9.57-15.75,9.09-15.75-9.09,15.75-9.1Zm17.4-9.1,15.75,9.1-15.75,9.09L168,346.39Zm99.44-.94-15.76-9.1,15.76-9.09,15.75,9.09Zm16.57-8.62,15.75,9.09-15.75,9.1L284,336.82Zm-17.39,9.09-15.76,9.1-15.75-9.1,15.75-9.09ZM250,336.35l-15.75-9.1L250,318.16l15.75,9.09Zm-.82.47-15.75,9.1-15.76-9.1,15.76-9.09Zm-32.33-.47-15.75-9.1,15.75-9.09,15.76,9.09Zm-.82.47-15.75,9.1-15.75-9.1,15.75-9.09Zm-15.75,10L216,356l-15.75,9.09L184.53,356Zm.82-.47,15.75-9.1,15.76,9.1-15.76,9.09Zm32.33.47,15.75,9.1-15.75,9.09L217.67,356Zm.82-.47,15.75-9.1,15.75,9.1L250,355.48Zm32.32.47,15.76,9.1-15.76,9.09L250.82,356Zm.82-.47,15.76-9.1,15.75,9.1-15.75,9.09Zm32.33.47,15.75,9.1-15.75,9.09L284,356Zm.82-.47,15.75-9.1,15.76,9.1-15.76,9.09Zm16.57-28.71,15.76-9.09,15.75,9.09-15.75,9.1Zm14.94,9.57-15.76,9.1-15.75-9.1,15.75-9.09Zm-32.33-.47L284,317.68l15.75-9.09,15.75,9.09Zm-16.57-9.57-15.76-9.1L283.15,299l15.75,9.09Zm-.82.47-15.76,9.1-15.75-9.1,15.75-9.09ZM250,317.21l-15.75-9.1L250,299l15.75,9.09Zm-.82.47-15.75,9.1-15.76-9.1,15.76-9.09Zm-32.33-.47-15.75-9.1L216.85,299l15.76,9.09Zm-.82.47-15.75,9.1-15.75-9.1,15.75-9.09Zm-16.57,9.57-15.75,9.1L168,327.25l15.76-9.09Zm-32.33-.47-15.75-9.1,15.75-9.09,15.76,9.09Zm-.82.47-15.75,9.1-15.75-9.1,15.75-9.09Zm-16.57,9.57L134,345.92l-15.76-9.1L134,327.73Zm0,19.14L134,365.05,118.23,356l15.76-9.1Zm.82.47,15.75,9.1-15.75,9.09-15.75-9.09Zm.82-.47,15.75-9.1,15.75,9.1-15.75,9.09Zm32.33.47,15.75,9.1-15.75,9.09L168,365.53ZM200.28,366,216,375.1l-15.75,9.09-15.75-9.09Zm.82-.47,15.75-9.1,15.76,9.1-15.76,9.09Zm32.33.47,15.75,9.1-15.75,9.09-15.76-9.09Zm.82-.47,15.75-9.1,15.75,9.1L250,374.62Zm32.32.47,15.76,9.1-15.76,9.09-15.75-9.09Zm.82-.47,15.76-9.1,15.75,9.1-15.75,9.09Zm32.33.47,15.75,9.1-15.75,9.09L284,375.1Zm.82-.47,15.75-9.1,15.76,9.1-15.76,9.09ZM317.11,356l15.76-9.1,15.75,9.1-15.75,9.09Zm32.33.47,15.75,9.1-15.75,9.09-15.75-9.09Zm.82-.47,15.75-9.1,15.76,9.1L366,365.05Zm0-19.14L366,327.73l15.75,9.09L366,345.91Zm-.82-.47-15.75-9.1,15.75-9.09,15.75,9.09Zm-15.75-28.24L349.44,299l15.75,9.09-15.75,9.1Zm-.82-.47-15.75-9.09,15.75-9.1,15.75,9.1Zm-.82.47-15.76,9.1-15.75-9.1L316.29,299Zm-32.33-.47L284,298.55l15.75-9.1,15.75,9.1Zm-16.57-9.57L267.39,289l15.76-9.1L298.9,289Zm-.82.48-15.76,9.09-15.75-9.09,15.75-9.1ZM250,298.07,234.25,289l15.75-9.1,15.75,9.1Zm-.82.48-15.75,9.09-15.76-9.09,15.76-9.1Zm-32.33-.48L201.1,289l15.75-9.1,15.76,9.1Zm-.82.48-15.75,9.09-15.75-9.09,15.75-9.1Zm-16.57,9.56-15.75,9.1L168,308.11,183.71,299Zm-32.33-.47-15.75-9.09,15.75-9.1,15.76,9.1Zm-.82.47-15.75,9.1-15.75-9.1L150.56,299Zm-16.57,9.57L134,326.78l-15.75-9.1L134,308.59Zm-16.58,9.57-15.75,9.1-15.75-9.1,15.75-9.09Zm-16.57,9.57-15.75,9.1-15.75-9.1,15.75-9.09Zm.82.47,15.75,9.1-15.75,9.09-15.75-9.09Zm15.75,28.24-15.75,9.09-15.75-9.09,15.75-9.1Zm.83.47,15.75,9.1L134,384.19l-15.75-9.09Zm16.57,9.57,15.75,9.09-15.75,9.1-15.75-9.1Zm.82-.47,15.75-9.1,15.76,9.1-15.76,9.09Zm32.33.47,15.75,9.09-15.75,9.1L168,384.66Zm16.57,9.57L216,394.23l-15.75,9.1-15.75-9.1Zm.82-.48,15.75-9.09,15.76,9.09-15.76,9.1Zm32.33.48,15.75,9.09-15.75,9.1-15.76-9.1Zm.82-.48L250,375.57l15.75,9.09L250,393.76Zm32.32.48,15.76,9.09-15.76,9.1-15.75-9.1Zm.82-.48,15.76-9.09,15.75,9.09-15.75,9.1Zm32.33.48,15.75,9.09-15.75,9.1L284,394.23Zm.82-.48,15.75-9.09,15.76,9.09-15.76,9.1Zm16.57-9.56,15.76-9.1,15.75,9.1-15.75,9.09Zm32.33.47,15.75,9.09-15.75,9.1-15.75-9.1Zm.82-.47L366,366l15.76,9.1L366,384.19Zm16.58-9.57,15.75-9.1,15.75,9.1-15.75,9.09Zm0-19.14,15.75-9.1,15.75,9.1-15.75,9.09Zm16.57-9.57,15.75-9.09,15.75,9.09-15.75,9.1Zm-.82-.47-15.75-9.1,15.75-9.09,15.75,9.09ZM366,326.78l-15.76-9.1L366,308.59l15.76,9.09Zm-15.76-28.23,15.76-9.1,15.75,9.1L366,307.64Zm-.82-.48L333.69,289l15.75-9.1,15.75,9.1Zm-16.57-9.57-15.76-9.09,15.76-9.1,15.75,9.1Zm-.82.48-15.76,9.09L300.54,289l15.75-9.1Zm-32.33-.48L284,279.41l15.75-9.1,15.75,9.1Zm-16.57-9.57-15.75-9.09,15.75-9.1,15.75,9.1Zm-.82.48-15.76,9.09-15.75-9.09,15.75-9.1ZM250,278.93l-15.75-9.09,15.75-9.1,15.75,9.1Zm-.82.48-15.75,9.09-15.76-9.09,15.76-9.1Zm-32.33-.48-15.75-9.09,15.75-9.1,15.76,9.1Zm-.82.48-15.75,9.09-15.75-9.09,15.75-9.1ZM199.46,289l-15.75,9.09L168,289l15.76-9.1Zm-32.33-.48-15.75-9.09,15.75-9.1,15.76,9.1Zm-.82.48-15.75,9.09L134.81,289l15.75-9.1Zm-16.57,9.57L134,307.64l-15.76-9.09,15.76-9.1Zm-16.58,9.56-15.75,9.1-15.75-9.1L117.41,299Zm-16.57,9.57-15.75,9.1-15.75-9.1,15.75-9.09ZM100,327.25l-15.76,9.1-15.75-9.1,15.75-9.09Zm0,19.14-15.76,9.09-15.75-9.09,15.75-9.1Zm.82.47,15.75,9.1-15.75,9.09L85.09,356Zm15.75,28.24-15.75,9.09L85.09,375.1l15.75-9.1Zm.82.47,15.75,9.09-15.75,9.1-15.75-9.1ZM134,385.14l15.76,9.09L134,403.33l-15.76-9.1Zm16.58,9.57,15.75,9.09-15.75,9.1-15.75-9.1Zm.82-.48,15.75-9.09,15.76,9.09-15.76,9.1Zm32.33.48,15.75,9.09-15.75,9.1L168,403.8Zm16.57,9.57L216,413.37l-15.75,9.1-15.75-9.1Zm.82-.48,15.75-9.09,15.76,9.09-15.76,9.1Zm32.33.48,15.75,9.09-15.75,9.1-15.76-9.1Zm.82-.48L250,394.71l15.75,9.09L250,412.9Zm32.32.48,15.76,9.09-15.76,9.1-15.75-9.1Zm.82-.48,15.76-9.09,15.75,9.09-15.75,9.1Zm32.33.48,15.75,9.09-15.75,9.1L284,413.37Zm.82-.48,15.75-9.09,15.76,9.09-15.76,9.1Zm16.57-9.57,15.76-9.09,15.75,9.09-15.75,9.1Zm32.33.48,15.75,9.09-15.75,9.1-15.75-9.1Zm.82-.48L366,385.14l15.76,9.09L366,403.33Zm16.58-9.57,15.75-9.09,15.75,9.09-15.75,9.1Zm16.57-9.56,15.75-9.1,15.75,9.1-15.75,9.09Zm0-19.14,15.75-9.1,15.75,9.1-15.75,9.09ZM400,346.39l15.76-9.1,15.75,9.1-15.75,9.09Zm0-19.14,15.76-9.09,15.75,9.09-15.75,9.1Zm-.82-.47-15.75-9.1,15.75-9.09,15.75,9.09Zm-16.57-9.57-15.75-9.1L382.59,299l15.75,9.09ZM366.84,289l15.75-9.1,15.75,9.1-15.75,9.09Zm-.82-.48-15.76-9.09,15.76-9.1,15.75,9.1Zm-16.58-9.57-15.75-9.09,15.75-9.1,15.75,9.1Zm-16.57-9.57-15.75-9.09,15.75-9.09,15.75,9.09Zm-.82.48-15.76,9.09-15.75-9.09,15.75-9.1Zm-32.33-.47L284,260.27l15.75-9.09,15.75,9.09Zm-16.57-9.57-15.76-9.1,15.76-9.09,15.75,9.09Zm-.82.47-15.76,9.1-15.75-9.1,15.75-9.09ZM250,259.8l-15.75-9.1L250,241.61l15.75,9.09Zm-.82.47-15.75,9.1-15.76-9.1,15.76-9.09Zm-32.33-.47-15.75-9.1,15.75-9.09,15.76,9.09Zm-.82.47-15.75,9.1-15.75-9.1,15.75-9.09Zm-16.57,9.57-15.75,9.09L168,269.84l15.76-9.1Zm-32.33-.47-15.75-9.1,15.75-9.09,15.76,9.09Zm-.82.47-15.75,9.09-15.75-9.09,15.75-9.1Zm-16.57,9.57L134,288.5l-15.76-9.09,15.76-9.1ZM133.16,289l-15.75,9.09L101.66,289l15.75-9.1Zm-32.32-.48-15.75-9.09,15.75-9.1,15.75,9.1Zm15.75,10.05-15.75,9.09-15.75-9.09,15.75-9.1ZM100,308.11l-15.76,9.1-15.75-9.1L84.26,299Zm-16.58,9.57-15.75,9.1-15.75-9.1,15.75-9.09Zm0,19.14-15.75,9.1-15.75-9.1,15.75-9.09Zm0,19.14-15.75,9.09L51.94,356l15.75-9.1Zm.82.47,15.76,9.1-15.76,9.09-15.75-9.09ZM100,384.66l-15.76,9.1-15.75-9.1,15.75-9.09Zm.82.48,15.75,9.09-15.75,9.1-15.75-9.1Zm16.57,9.57,15.75,9.09-15.75,9.1-15.75-9.1ZM134,404.28l15.75,9.09L134,422.47l-15.75-9.1Zm16.57,9.56,15.75,9.1L150.56,432l-15.75-9.09Zm.82-.47,15.75-9.09,15.75,9.09-15.75,9.1Zm32.33.47,15.75,9.1L183.71,432,168,422.94Zm16.57,9.57,15.75,9.1-15.75,9.09-15.75-9.09Zm.82-.47,15.75-9.1,15.76,9.1L216.85,432Zm32.33.47,15.75,9.1-15.75,9.09-15.76-9.09Zm.82-.47,15.75-9.1,15.75,9.1L250,432Zm32.32.47,15.76,9.1-15.76,9.09-15.75-9.09Zm.82-.47,15.76-9.1,15.75,9.1L283.15,432Zm32.33.47,15.75,9.1-15.75,9.09L284,432.51Zm.82-.47,15.75-9.1,15.76,9.1L316.29,432Zm16.57-9.57,15.76-9.09,15.75,9.09-15.75,9.1Zm32.33.47,15.75,9.1L349.44,432l-15.75-9.09Zm.82-.47L366,404.28l15.76,9.09L366,422.47Zm16.58-9.57,15.75-9.09,15.75,9.09-15.75,9.1Zm16.57-9.57,15.75-9.09,15.75,9.09-15.75,9.1ZM400,384.66l15.76-9.09,15.75,9.09-15.75,9.1Zm0-19.13,15.76-9.1,15.75,9.1-15.75,9.09ZM416.56,356l15.75-9.1,15.75,9.1-15.75,9.09Zm0-19.14,15.75-9.09,15.75,9.09-15.75,9.1Zm0-19.14,15.75-9.09,15.75,9.09-15.75,9.1Zm-.82-.47L400,308.11,415.74,299l15.75,9.09Zm-16.58-9.57-15.75-9.09,15.75-9.1,15.76,9.1Zm-15.75-28.23,15.75-9.1,15.75,9.1-15.75,9.09Zm-.82-.48-15.75-9.09,15.75-9.1,15.75,9.1ZM366,269.37l-15.76-9.1L366,251.18l15.76,9.09Zm-16.58-9.57-15.75-9.1,15.75-9.09,15.75,9.09Zm-16.57-9.57-15.75-9.1L332.87,232l15.75,9.09Zm-.82.47-15.76,9.1-15.75-9.1,15.76-9.09Zm-32.33-.47L284,241.13,299.72,232l15.75,9.09Zm-16.57-9.57-15.76-9.1,15.76-9.09,15.75,9.09Zm-.82.47-15.76,9.1-15.75-9.1L266.57,232ZM250,240.66l-15.75-9.1L250,222.47l15.75,9.09Zm-.82.47-15.75,9.1-15.76-9.1L233.43,232Zm-32.33-.47-15.75-9.1,15.75-9.09,15.76,9.09Zm-.82.47-15.75,9.1-15.75-9.1L200.28,232Zm-16.57,9.57-15.75,9.1L168,250.7l15.76-9.09Zm-32.33-.47-15.75-9.1L167.13,232l15.76,9.09Zm-.82.47-15.75,9.1-15.75-9.1,15.75-9.09Zm-16.57,9.57L134,269.37l-15.76-9.1L134,251.18Zm-16.57,9.57-15.76,9.09-15.75-9.09,15.75-9.1Zm-32.33-.47-15.75-9.1,15.75-9.09,15.75,9.09Zm-.82.47-15.76,9.09-15.75-9.09,15.75-9.1ZM100,289l-15.76,9.09L68.51,289l15.75-9.1Zm-16.58,9.57-15.75,9.09-15.75-9.09,15.75-9.1Zm-16.57,9.56-15.75,9.1-15.75-9.1L51.12,299Zm0,19.14-15.75,9.1-15.76-9.1,15.76-9.09Zm0,19.14-15.75,9.09-15.76-9.09,15.76-9.1Zm0,19.14-15.75,9.09-15.76-9.09,15.76-9.1Zm.82.47,15.75,9.1-15.75,9.09L51.94,375.1Zm15.75,28.23-15.75,9.1-15.75-9.1,15.75-9.09Zm.82.48L100,403.8l-15.76,9.1-15.75-9.1Zm16.58,9.57,15.75,9.09-15.75,9.1-15.76-9.1Zm16.57,9.56,15.75,9.1L117.41,432l-15.75-9.09ZM134,423.41l15.76,9.1L134,441.6l-15.75-9.09ZM150.56,433l15.75,9.1-15.75,9.09-15.75-9.09Zm.82-.47,15.75-9.1,15.76,9.1-15.76,9.09Zm32.33.47,15.75,9.1-15.75,9.09L168,442.08Zm16.57,9.57,15.75,9.1-15.75,9.09-15.75-9.09Zm.82-.47,15.75-9.1,15.76,9.1-15.76,9.09Zm32.33.47,15.75,9.1-15.75,9.09-15.76-9.09Zm.82-.47L250,433l15.75,9.1L250,451.17Zm32.32.47,15.76,9.1-15.76,9.09-15.75-9.09Zm.82-.47,15.76-9.1,15.75,9.1-15.75,9.09Zm32.33.47,15.75,9.1-15.75,9.09L284,451.65Zm.82-.47,15.75-9.1,15.76,9.1-15.76,9.09Zm16.57-9.57,15.76-9.1,15.75,9.1-15.75,9.09Zm32.33.47,15.75,9.1-15.75,9.09-15.75-9.09Zm.82-.47,15.75-9.1,15.76,9.1L366,441.6Zm16.58-9.57,15.75-9.1,15.75,9.1L382.59,432Zm16.57-9.57,15.75-9.09,15.75,9.09-15.75,9.1ZM400,403.8l15.76-9.09,15.75,9.09-15.76,9.1Zm16.58-9.57,15.75-9.09,15.75,9.09-15.75,9.1Zm0-19.13,15.75-9.1,15.75,9.1-15.75,9.09Zm16.57-9.57,15.75-9.1,15.76,9.1-15.76,9.09Zm0-19.14,15.75-9.1,15.76,9.1-15.76,9.09Zm0-19.14,15.75-9.09,15.76,9.09-15.76,9.1Zm0-19.14L448.88,299l15.76,9.09-15.76,9.1Zm-.82-.47-15.75-9.09,15.75-9.1,15.75,9.1Zm-16.57-9.57L400,289l15.76-9.1,15.75,9.1ZM400,269.84l15.76-9.1,15.75,9.1-15.75,9.09Zm-.82-.47-15.75-9.1,15.75-9.09,15.76,9.09Zm-17.39-28.24L366,250.23l-15.75-9.1L366,232Zm-16.58-9.57-15.75,9.1-15.75-9.1,15.75-9.09ZM332.87,212.9l15.75,9.1-15.75,9.09L317.11,222Zm-.82,18.66-15.75,9.1-15.76-9.1,15.75-9.09ZM315.47,222l-15.75,9.09L284,222l15.75-9.1Zm-32.32-18.67,15.75,9.1-15.75,9.09-15.75-9.09ZM282.33,222l-15.76,9.09L250.82,222l15.76-9.1ZM250,203.33l15.75,9.1L250,221.52l-15.75-9.09ZM249.18,222l-15.75,9.09L217.67,222l15.76-9.1Zm-32.33-18.67,15.76,9.1-15.76,9.09-15.75-9.09Zm-16.57,9.57L216,222l-15.75,9.09L184.53,222Zm-.82,18.66-15.75,9.1L168,231.56l15.76-9.09ZM167.13,212.9l15.76,9.1-15.76,9.09L151.38,222Zm-16.57,9.57,15.75,9.09-15.75,9.1-15.75-9.1ZM134,232l15.75,9.09L134,250.23l-15.76-9.1Zm-.82,18.66-15.76,9.1-15.75-9.1,15.75-9.09ZM100.84,232l15.75,9.09-15.75,9.1-15.75-9.1Zm-16.57,9.57L100,250.7l-15.76,9.1-15.75-9.1ZM51.94,260.27l15.75-9.09,15.75,9.09-15.75,9.1Zm15.75,10,15.75,9.1L67.69,288.5l-15.75-9.09Zm-16.57,9.57L66.87,289l-15.75,9.09L35.36,289ZM18.79,298.55l15.75-9.1,15.76,9.1-15.76,9.09Zm0,19.13,15.75-9.09,15.76,9.09-15.76,9.1Zm0,19.14,15.75-9.09,15.76,9.09-15.76,9.1Zm0,19.14,15.75-9.1L50.3,356l-15.76,9.09Zm0,19.14L34.54,366l15.76,9.1-15.76,9.09Zm16.57,9.56,15.76-9.09,15.75,9.09-15.75,9.1Zm0,19.14,15.76-9.09,15.75,9.09-15.75,9.1Zm16.58,9.57,15.75-9.09,15.75,9.09-15.75,9.1Zm16.57,9.57,15.75-9.1,15.76,9.1L84.26,432Zm16.58,9.57,15.75-9.1,15.75,9.1-15.75,9.09Zm16.57,9.57,15.75-9.1,15.75,9.1-15.75,9.09Zm16.57,9.57,15.75-9.1,15.76,9.1L134,460.74Zm32.33,18.66-15.75-9.1,15.75-9.09,15.75,9.09Zm.82-18.66,15.75-9.1,15.75,9.1-15.75,9.09ZM168,461.21l15.76-9.09,15.75,9.09-15.76,9.1Zm32.33,18.67-15.75-9.1,15.75-9.09L216,470.78Zm.82-18.67,15.75-9.09,15.76,9.09-15.76,9.1Zm32.33,18.67-15.76-9.1,15.76-9.09,15.75,9.09Zm.82-18.67L250,452.12l15.75,9.09L250,470.31Zm32.32,18.67-15.75-9.1,15.75-9.09,15.76,9.09Zm.82-18.67,15.76-9.09,15.75,9.09-15.75,9.1Zm32.33,18.67L284,470.78l15.75-9.09,15.75,9.09Zm16.57-9.57-15.75-9.1,15.75-9.09,15.76,9.09Zm.82-18.66,15.76-9.1,15.75,9.1-15.75,9.09Zm32.33,18.66-15.75-9.1,15.75-9.09,15.75,9.09ZM366,460.74l-15.75-9.09,15.75-9.1,15.76,9.1Zm16.58-9.57-15.76-9.09,15.76-9.1,15.75,9.1Zm16.57-9.57-15.75-9.09,15.75-9.1,15.75,9.1ZM415.73,432,400,422.94l15.75-9.1,15.76,9.1Zm16.58-9.56-15.75-9.1,15.75-9.09,15.75,9.09Zm32.32-18.67-15.75,9.1-15.75-9.1,15.75-9.09Zm-15.75-10-15.75-9.1,15.75-9.09,15.76,9.09Zm32.33-18.66-15.75,9.09L449.7,375.1l15.76-9.1Zm0-19.14-15.75,9.09L449.7,356l15.76-9.1Zm0-19.14-15.75,9.09-15.76-9.09,15.76-9.09Zm0-19.14-15.75,9.1-15.76-9.1,15.76-9.09Zm0-19.13-15.75,9.09-15.76-9.09,15.76-9.1ZM464.64,289l-15.76,9.09L433.13,289l15.75-9.1Zm-16.58-9.57-15.75,9.09-15.75-9.09,15.75-9.1Zm0-19.14-15.75,9.09-15.75-9.09,15.75-9.09Zm-16.57-9.57-15.75,9.1L400,250.7l15.76-9.09Zm-16.58-9.57-15.75,9.1-15.75-9.1L399.16,232Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-73"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-73",
    cx: 99.76,
    cy: 440.92,
    rx: 43.66,
    ry: 25.21,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-73",
    d: "M203,468.24,160.29,443.6c-1.44-.83-1.44-2.17,0-3l79.59-45.88a5.74,5.74,0,0,1,5.2,0l42.73,24.76c1.43.82,1.43,2.17,0,3L208.2,468.23A5.77,5.77,0,0,1,203,468.24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-73",
    cx: 420.57,
    cy: 272.5,
    rx: 37.29,
    ry: 21.53,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-73",
    d: "M388.36,386.64a4.28,4.28,0,0,1-4.15-3.43l-.7-3.7a48.37,48.37,0,0,1-4.71-1.17l-7.19,3.33a5.07,5.07,0,0,1-4.49-.2l-7.36-4.25a3.65,3.65,0,0,1-.32-6.22l3.86-2.78c-.18-.26-.35-.53-.52-.8l-9-.57a4.1,4.1,0,0,1-3.83-4.08v-5.48a4.1,4.1,0,0,1,3.83-4.08l9-.57c.17-.27.34-.54.52-.8l-3.86-2.78a3.65,3.65,0,0,1,.32-6.22l7.36-4.25a5,5,0,0,1,2.46-.63,4.86,4.86,0,0,1,2,.43l7.19,3.33a48.37,48.37,0,0,1,4.71-1.17l.7-3.7a4.29,4.29,0,0,1,4.15-3.43h10.83a4.28,4.28,0,0,1,4.14,3.43l.7,3.7a47.87,47.87,0,0,1,4.72,1.17l7.19-3.33a4.82,4.82,0,0,1,2-.43,5,5,0,0,1,2.46.63l7.36,4.25a3.65,3.65,0,0,1,.31,6.22l-3.86,2.78c.19.26.36.53.53.8l9,.57a4.1,4.1,0,0,1,3.83,4.09v5.47a4.1,4.1,0,0,1-3.83,4.08l-9,.57c-.17.27-.34.54-.53.8L428.1,371a3.65,3.65,0,0,1-.31,6.22l-7.36,4.25a5,5,0,0,1-2.46.63h0a4.89,4.89,0,0,1-2-.43l-7.19-3.33a47.87,47.87,0,0,1-4.72,1.17l-.7,3.7a4.27,4.27,0,0,1-4.14,3.43ZM393.78,353a22.4,22.4,0,0,0-10.88,2.56c-2.29,1.32-3.6,2.95-3.6,4.48s1.31,3.17,3.6,4.48a24.38,24.38,0,0,0,21.75,0c2.29-1.31,3.6-2.95,3.6-4.48s-1.31-3.16-3.6-4.48A22.39,22.39,0,0,0,393.78,353Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-73",
    d: "M444,339.22l-.49,0-6.81-.71a4.53,4.53,0,0,1-4-5l.13-1.06c-.58-.21-1.14-.43-1.68-.67,0,0,0,0,0,0H431l-5.18,1.62a5.06,5.06,0,0,1-1.57.24,5.75,5.75,0,0,1-3.63-1.26l-3.48-2.9a4,4,0,0,1,.78-6.84l1.18-.59-3.19-.55a4.34,4.34,0,0,1-3.44-5.62l.94-3a5,5,0,0,1,4.69-3.44l5.79.23-.74-.79a4.08,4.08,0,0,1,1.48-6.69L430.1,300a5.39,5.39,0,0,1,2-.37,5.77,5.77,0,0,1,3.17.91l3.53,2.34h0c1-.17,2.06-.31,3.1-.41l1-2.05a5.25,5.25,0,0,1,4.57-2.76,3.91,3.91,0,0,1,.49,0l6.81.71a4.5,4.5,0,0,1,4,5l-.12,1.06c.57.21,1.14.43,1.68.67,0,0,0,0,0,0h.07l5.18-1.62a5,5,0,0,1,1.56-.24,5.71,5.71,0,0,1,3.64,1.27l3.48,2.89a4,4,0,0,1-.79,6.84l-1.18.59,3.2.55a4.35,4.35,0,0,1,3,2,4.41,4.41,0,0,1,.43,3.6l-.95,3a5,5,0,0,1-4.68,3.43l-5.8-.23.75.8a4.08,4.08,0,0,1-1.48,6.69l-5.45,2.18a5.39,5.39,0,0,1-2,.37,5.74,5.74,0,0,1-3.17-.91L452.72,334h0c-1,.18-2.05.31-3.1.41l-1.06,2A5.23,5.23,0,0,1,444,339.22Zm1.8-25a16.87,16.87,0,0,0-6.18,1.11c-2.39,1-3.38,2.18-3.5,2.93s.65,1.5,1.12,1.89c1.82,1.52,5.11,2.47,8.58,2.47a16.78,16.78,0,0,0,6.17-1.11c2.4-1,3.38-2.18,3.5-2.93s-.64-1.5-1.11-1.89C452.52,315.17,449.23,314.22,445.77,314.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-73",
    cx: 338.04,
    cy: 417.07,
    rx: 46.39,
    ry: 26.78,
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.61,376l6.21-3.59S58.51,357.1,57,343.29C55,323.87,42.19,316.57,37.33,318.24s-6.27,7.33,1.77,18.89C43.84,344,49.67,358.17,48.61,376Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.61,376l6.21-3.59S58.51,357.1,57,343.29C55,323.87,42.19,316.57,37.33,318.24s-6.27,7.33,1.77,18.89C43.84,344,49.67,358.17,48.61,376Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.18,368.5h-.06a.42.42,0,0,1-.34-.5c3.4-17.91-2.86-38-10.6-46.41a.43.43,0,0,1,.63-.59c7.89,8.53,14.27,29,10.81,47.16A.43.43,0,0,1,51.18,368.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,385.06c-.93.47-3.39-1.64-4.08-2.15a8.63,8.63,0,0,1-2.7-3.43,8.15,8.15,0,0,1-.47-4.88,20.49,20.49,0,0,1,.74-2.54l.85-2.46a6.23,6.23,0,0,0,.49-2.5c-.13-1.72-1.59-3-2.91-4.1s-3-2.81-2.87-4.86a7.26,7.26,0,0,1,2-4.22c1-1.19,2.27-2.23,3.22-3.5a5.06,5.06,0,0,0,1.2-3.15,5.23,5.23,0,0,0-.6-2,28.33,28.33,0,0,1-2-4.12,4,4,0,0,1,.91-4.22,4.68,4.68,0,0,1,3.58-.7,8.18,8.18,0,0,1,3.24,1.32c3.17,2,4.84,6,8.23,7.52A34.18,34.18,0,0,0,46,346.27a5.24,5.24,0,0,1,3.34,2.55c1.14,2.6-1.38,5.61-.62,8.36.67,2.42,2.94,3.45,4.14,5.67a5.11,5.11,0,0,1,.45,3.16,15,15,0,0,1-1.59,5.21A46.8,46.8,0,0,1,48.61,376Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33,385.06c-.93.47-3.39-1.64-4.08-2.15a8.63,8.63,0,0,1-2.7-3.43,8.15,8.15,0,0,1-.47-4.88,20.49,20.49,0,0,1,.74-2.54l.85-2.46a6.23,6.23,0,0,0,.49-2.5c-.13-1.72-1.59-3-2.91-4.1s-3-2.81-2.87-4.86a7.26,7.26,0,0,1,2-4.22c1-1.19,2.27-2.23,3.22-3.5a5.06,5.06,0,0,0,1.2-3.15,5.23,5.23,0,0,0-.6-2,28.33,28.33,0,0,1-2-4.12,4,4,0,0,1,.91-4.22,4.68,4.68,0,0,1,3.58-.7,8.18,8.18,0,0,1,3.24,1.32c3.17,2,4.84,6,8.23,7.52A34.18,34.18,0,0,0,46,346.27a5.24,5.24,0,0,1,3.34,2.55c1.14,2.6-1.38,5.61-.62,8.36.67,2.42,2.94,3.45,4.14,5.67a5.11,5.11,0,0,1,.45,3.16,15,15,0,0,1-1.59,5.21A46.8,46.8,0,0,1,48.61,376Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42,380.38h0a.4.4,0,0,1-.37-.44c1.48-16.11-5.22-34.31-10.49-39.77a.4.4,0,0,1,0-.58.41.41,0,0,1,.57,0c5.38,5.57,12.23,24.08,10.72,40.42A.42.42,0,0,1,42,380.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.37,360.51l-.12,0A53.81,53.81,0,0,0,28.63,358a.41.41,0,0,1-.37-.44.4.4,0,0,1,.45-.37,55.08,55.08,0,0,1,11.82,2.52.4.4,0,0,1,.24.52A.39.39,0,0,1,40.37,360.51Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gear--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.31,301.42a1.48,1.48,0,0,1-1-1.54l.32-2.59a1.18,1.18,0,0,0-1.06-1.32l-6.81-.72a1.89,1.89,0,0,0-1.76,1l-1.36,2.64a2.39,2.39,0,0,1-1.76,1.15,34.38,34.38,0,0,0-3.53.44,3.51,3.51,0,0,1-2.2-.44l-3.67-2.44a2.57,2.57,0,0,0-2.13-.22l-5.45,2.19a.78.78,0,0,0-.56.69h0v.06h0v5.57h0a.91.91,0,0,0,.26.61l.32.33a2.81,2.81,0,0,1-1.5.47l-6.23-.25a1.66,1.66,0,0,0-1.57,1.11l-.94,3a1.17,1.17,0,0,0,0,.37h0v5.62h0a1,1,0,0,0,.88,1l4.82.82-1.88.95a.78.78,0,0,0-.49.68h0v5.63h0a.82.82,0,0,0,.34.62l3.48,2.9a2.47,2.47,0,0,0,2.09.41l5.3-1.66a3.69,3.69,0,0,1,2.25.15c.91.39,1.86.74,2.84,1a1.38,1.38,0,0,1,.7.49v3.79h0A1.18,1.18,0,0,0,437,335.1l6.81.71a1.91,1.91,0,0,0,1.76-.95l1.35-2.64a2.38,2.38,0,0,1,1.77-1.15c1.18-.09,2.37-.24,3.53-.44a3.45,3.45,0,0,1,2.2.44l3.66,2.43a2.59,2.59,0,0,0,2.14.22l5.45-2.18a.8.8,0,0,0,.56-.73h0V325.2h0a.88.88,0,0,0-.27-.6l-.31-.34a2.88,2.88,0,0,1,1.5-.46l6.22.25a1.67,1.67,0,0,0,1.57-1.11l.95-3a1.4,1.4,0,0,0,.05-.34h0V314h0a1,1,0,0,0-.86-1l-4.83-.83,1.88-.94a.76.76,0,0,0,.49-.69h0v-5.59h0a.81.81,0,0,0-.34-.65l-3.47-2.89a2.48,2.48,0,0,0-2.09-.42l-5.3,1.66a3.8,3.8,0,0,1-2.26-.14A24.47,24.47,0,0,0,456.31,301.42Zm-22.6,14.11a10.07,10.07,0,0,1,4.65-3.37c5.9-2.36,14-1.52,18.11,1.89a7.83,7.83,0,0,1,1.39,1.47,10.12,10.12,0,0,1-4.66,3.38c-5.91,2.37-14,1.52-18.12-1.89A7.81,7.81,0,0,1,433.71,315.53Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.31,301.42a1.48,1.48,0,0,1-1-1.54l.32-2.59a1.18,1.18,0,0,0-1.06-1.32l-6.81-.72a1.89,1.89,0,0,0-1.76,1l-1.36,2.64a2.39,2.39,0,0,1-1.76,1.15,34.38,34.38,0,0,0-3.53.44,3.51,3.51,0,0,1-2.2-.44l-3.67-2.44a2.57,2.57,0,0,0-2.13-.22l-5.45,2.19a.78.78,0,0,0-.56.69h0v.06h0v5.57h0a.91.91,0,0,0,.26.61l.32.33a2.81,2.81,0,0,1-1.5.47l-6.23-.25a1.66,1.66,0,0,0-1.57,1.11l-.94,3a1.17,1.17,0,0,0,0,.37h0v5.62h0a1,1,0,0,0,.88,1l4.82.82-1.88.95a.78.78,0,0,0-.49.68h0v5.63h0a.82.82,0,0,0,.34.62l3.48,2.9a2.47,2.47,0,0,0,2.09.41l5.3-1.66a3.69,3.69,0,0,1,2.25.15c.91.39,1.86.74,2.84,1a1.38,1.38,0,0,1,.7.49v3.79h0A1.18,1.18,0,0,0,437,335.1l6.81.71a1.91,1.91,0,0,0,1.76-.95l1.35-2.64a2.38,2.38,0,0,1,1.77-1.15c1.18-.09,2.37-.24,3.53-.44a3.45,3.45,0,0,1,2.2.44l3.66,2.43a2.59,2.59,0,0,0,2.14.22l5.45-2.18a.8.8,0,0,0,.56-.73h0V325.2h0a.88.88,0,0,0-.27-.6l-.31-.34a2.88,2.88,0,0,1,1.5-.46l6.22.25a1.67,1.67,0,0,0,1.57-1.11l.95-3a1.4,1.4,0,0,0,.05-.34h0V314h0a1,1,0,0,0-.86-1l-4.83-.83,1.88-.94a.76.76,0,0,0,.49-.69h0v-5.59h0a.81.81,0,0,0-.34-.65l-3.47-2.89a2.48,2.48,0,0,0-2.09-.42l-5.3,1.66a3.8,3.8,0,0,1-2.26-.14A24.47,24.47,0,0,0,456.31,301.42Zm-22.6,14.11a10.07,10.07,0,0,1,4.65-3.37c5.9-2.36,14-1.52,18.11,1.89a7.83,7.83,0,0,1,1.39,1.47,10.12,10.12,0,0,1-4.66,3.38c-5.91,2.37-14,1.52-18.12-1.89A7.81,7.81,0,0,1,433.71,315.53Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.86,314.9a2,2,0,0,0-1.44-1.39l-5.93-1a1,1,0,0,1-.88-.92v5.55a1,1,0,0,0,.87,1l4.83.83,2.5-1.26a1.17,1.17,0,0,0,.49-1.6A8.52,8.52,0,0,1,423.86,314.9Zm1.45-9h0a.88.88,0,0,0,.26.61l.32.34a2.39,2.39,0,0,0,.52-.4,12.85,12.85,0,0,1,1.49-1.32,1.06,1.06,0,0,0,.15-1.6l-2.48-2.63a.84.84,0,0,1-.26-.6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.36,306.55c-5.1,2.05-6.89,5.81-4.65,9a10.14,10.14,0,0,1,4.65-3.37c5.91-2.36,14-1.52,18.12,1.89a8,8,0,0,1,1.37,1.47c1.58-2.26,1.22-4.92-1.37-7.08C452.38,305,444.27,304.19,438.36,306.55Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.51,326a1.93,1.93,0,0,0-.57.65l-1.36,2.65a1.9,1.9,0,0,1-1,.84v5.61a1.86,1.86,0,0,0,1-.84l1.37-2.65a1.94,1.94,0,0,1,.58-.64Zm18.73-.74h0a.79.79,0,0,1-.57.73l-5.44,2.18a2.46,2.46,0,0,1-1.43.06v5.61a2.46,2.46,0,0,0,1.43-.06l5.45-2.18a.8.8,0,0,0,.56-.72Zm-36.16-2.35-5.23,1.64a2.38,2.38,0,0,1-1.32,0v5.59a2.3,2.3,0,0,0,1.32,0l5.24-1.64ZM476,314a1.26,1.26,0,0,1-.05.33l-.94,3a1.67,1.67,0,0,1-1.57,1.11l-6.23-.25a2.69,2.69,0,0,0-1,.19V324a2.51,2.51,0,0,1,1-.19l6.22.25a1.7,1.7,0,0,0,1.58-1.11l.93-3a.84.84,0,0,0,.06-.34Zm-3.32-9.08a.67.67,0,0,1-.05.19.64.64,0,0,1-.19.29,1.17,1.17,0,0,1-.27.19l-4.37,2.2a.77.77,0,0,0-.27.19,1,1,0,0,0-.29.45,1.27,1.27,0,0,0-.07.44l0,.22c0,.1.06.2.1.3a9.36,9.36,0,0,1,.45,1.17,2,2,0,0,0,1.44,1.4l1.1.18,1.88-.94a.8.8,0,0,0,.49-.69h0Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.51,326a1.93,1.93,0,0,0-.57.65l-1.36,2.65a1.9,1.9,0,0,1-1,.84v5.61a1.86,1.86,0,0,0,1-.84l1.37-2.65a1.94,1.94,0,0,1,.58-.64Zm18.73-.74h0a.79.79,0,0,1-.57.73l-5.44,2.18a2.46,2.46,0,0,1-1.43.06v5.61a2.46,2.46,0,0,0,1.43-.06l5.45-2.18a.8.8,0,0,0,.56-.72Zm-36.16-2.35-5.23,1.64a2.38,2.38,0,0,1-1.32,0v5.59a2.3,2.3,0,0,0,1.32,0l5.24-1.64ZM476,314a1.26,1.26,0,0,1-.05.33l-.94,3a1.67,1.67,0,0,1-1.57,1.11l-6.23-.25a2.69,2.69,0,0,0-1,.19V324a2.51,2.51,0,0,1,1-.19l6.22.25a1.7,1.7,0,0,0,1.58-1.11l.93-3a.84.84,0,0,0,.06-.34Zm-3.32-9.08a.67.67,0,0,1-.05.19.64.64,0,0,1-.19.29,1.17,1.17,0,0,1-.27.19l-4.37,2.2a.77.77,0,0,0-.27.19,1,1,0,0,0-.29.45,1.27,1.27,0,0,0-.07.44l0,.22c0,.1.06.2.1.3a9.36,9.36,0,0,1,.45,1.17,2,2,0,0,0,1.44,1.4l1.1.18,1.88-.94a.8.8,0,0,0,.49-.69h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.71,301l-5.3,1.66a3.8,3.8,0,0,1-2.26-.14,24.47,24.47,0,0,0-2.84-1.05,1.48,1.48,0,0,1-1-1.54l.32-2.59a1.18,1.18,0,0,0-1.06-1.32l-6.81-.72a1.89,1.89,0,0,0-1.76,1l-1.36,2.64a2.39,2.39,0,0,1-1.76,1.15,34.38,34.38,0,0,0-3.53.44,3.51,3.51,0,0,1-2.2-.44l-3.67-2.44a2.57,2.57,0,0,0-2.13-.22l-5.45,2.19a.77.77,0,0,0-.29,1.33l2.47,2.63a1,1,0,0,1-.15,1.59,13.91,13.91,0,0,0-1.49,1.33,3,3,0,0,1-2,.86l-6.23-.25a1.66,1.66,0,0,0-1.57,1.11l-.94,3a1,1,0,0,0,.83,1.36l5.92,1a2,2,0,0,1,1.45,1.39,7.12,7.12,0,0,0,.45,1.18,1.19,1.19,0,0,1-.5,1.6l-4.38,2.2a.74.74,0,0,0-.15,1.32l3.48,2.89a2.47,2.47,0,0,0,2.09.41l5.3-1.66a3.69,3.69,0,0,1,2.25.15c.91.39,1.86.74,2.84,1.05a1.47,1.47,0,0,1,1,1.53l-.31,2.59a1.18,1.18,0,0,0,1.06,1.33l6.81.71a1.91,1.91,0,0,0,1.76-.95l1.36-2.64a2.35,2.35,0,0,1,1.76-1.15c1.19-.09,2.37-.24,3.53-.44a3.45,3.45,0,0,1,2.2.44l3.66,2.43a2.59,2.59,0,0,0,2.14.22l5.45-2.18a.77.77,0,0,0,.29-1.33L463.5,322a1.05,1.05,0,0,1,.15-1.6,12.91,12.91,0,0,0,1.49-1.33,3,3,0,0,1,2-.85l6.22.25a1.69,1.69,0,0,0,1.58-1.11l.94-3a1,1,0,0,0-.83-1.36l-5.93-1a2,2,0,0,1-1.44-1.38,8.93,8.93,0,0,0-.45-1.18,1.19,1.19,0,0,1,.5-1.61l4.37-2.19a.73.73,0,0,0,.15-1.32l-3.47-2.89A2.48,2.48,0,0,0,466.71,301Zm-10.24,7.49c4.1,3.42,2.63,8.1-3.27,10.46s-14,1.52-18.12-1.89-2.63-8.09,3.28-10.46S452.38,305,456.47,308.44Z",
    style: {
      fill: "#0C0C0C"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.71,301l-5.3,1.66a3.8,3.8,0,0,1-2.26-.14,24.47,24.47,0,0,0-2.84-1.05,1.48,1.48,0,0,1-1-1.54l.32-2.59a1.18,1.18,0,0,0-1.06-1.32l-6.81-.72a1.89,1.89,0,0,0-1.76,1l-1.36,2.64a2.39,2.39,0,0,1-1.76,1.15,34.38,34.38,0,0,0-3.53.44,3.51,3.51,0,0,1-2.2-.44l-3.67-2.44a2.57,2.57,0,0,0-2.13-.22l-5.45,2.19a.77.77,0,0,0-.29,1.33l2.47,2.63a1,1,0,0,1-.15,1.59,13.91,13.91,0,0,0-1.49,1.33,3,3,0,0,1-2,.86l-6.23-.25a1.66,1.66,0,0,0-1.57,1.11l-.94,3a1,1,0,0,0,.83,1.36l5.92,1a2,2,0,0,1,1.45,1.39,7.12,7.12,0,0,0,.45,1.18,1.19,1.19,0,0,1-.5,1.6l-4.38,2.2a.74.74,0,0,0-.15,1.32l3.48,2.89a2.47,2.47,0,0,0,2.09.41l5.3-1.66a3.69,3.69,0,0,1,2.25.15c.91.39,1.86.74,2.84,1.05a1.47,1.47,0,0,1,1,1.53l-.31,2.59a1.18,1.18,0,0,0,1.06,1.33l6.81.71a1.91,1.91,0,0,0,1.76-.95l1.36-2.64a2.35,2.35,0,0,1,1.76-1.15c1.19-.09,2.37-.24,3.53-.44a3.45,3.45,0,0,1,2.2.44l3.66,2.43a2.59,2.59,0,0,0,2.14.22l5.45-2.18a.77.77,0,0,0,.29-1.33L463.5,322a1.05,1.05,0,0,1,.15-1.6,12.91,12.91,0,0,0,1.49-1.33,3,3,0,0,1,2-.85l6.22.25a1.69,1.69,0,0,0,1.58-1.11l.94-3a1,1,0,0,0-.83-1.36l-5.93-1a2,2,0,0,1-1.44-1.38,8.93,8.93,0,0,0-.45-1.18,1.19,1.19,0,0,1,.5-1.61l4.37-2.19a.73.73,0,0,0,.15-1.32l-3.47-2.89A2.48,2.48,0,0,0,466.71,301Zm-10.24,7.49c4.1,3.42,2.63,8.1-3.27,10.46s-14,1.52-18.12-1.89-2.63-8.09,3.28-10.46S452.38,305,456.47,308.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.59,295.92h.08l6.81.71a.49.49,0,0,1,.35.19.51.51,0,0,1,.1.38l-.31,2.59a2.18,2.18,0,0,0,1.49,2.27,26.51,26.51,0,0,1,2.77,1,4.41,4.41,0,0,0,1.68.31,3.71,3.71,0,0,0,1.05-.14l5.3-1.66a1.4,1.4,0,0,1,.38-.05,1.8,1.8,0,0,1,1.07.34l3.48,2.89c.07.06.09.1.1.1s0,.05-.12.09l-4.37,2.2a1.85,1.85,0,0,0-.81,2.49,9,9,0,0,1,.41,1.09,2.69,2.69,0,0,0,2,1.86l5.92,1a.34.34,0,0,1,.3.49l-.94,3a1,1,0,0,1-.9.63h0l-6.23-.25h-.09a3.71,3.71,0,0,0-2.43,1.06,13.61,13.61,0,0,1-1.43,1.27,1.8,1.8,0,0,0-.7,1.27,1.69,1.69,0,0,0,.48,1.32l2.47,2.63a.46.46,0,0,1,.09.14.3.3,0,0,1-.15.1L460,327.48a1.42,1.42,0,0,1-.54.09,1.84,1.84,0,0,1-1-.24l-3.67-2.44a4.22,4.22,0,0,0-2.15-.58,3.12,3.12,0,0,0-.54,0c-1.12.2-2.29.34-3.46.43a3.06,3.06,0,0,0-2.32,1.52L445,328.94a1.26,1.26,0,0,1-1,.59h-.08l-6.81-.71a.58.58,0,0,1-.35-.19.54.54,0,0,1-.11-.39l.32-2.58a2.18,2.18,0,0,0-1.5-2.27,27.37,27.37,0,0,1-2.77-1,4.37,4.37,0,0,0-1.68-.32,3.3,3.3,0,0,0-1,.15l-5.3,1.66a1.46,1.46,0,0,1-.38.05,1.85,1.85,0,0,1-1.08-.34l-3.47-2.9a.6.6,0,0,1-.11-.1.79.79,0,0,1,.13-.09l4.37-2.19a1.86,1.86,0,0,0,.81-2.5,7.47,7.47,0,0,1-.41-1.08,2.72,2.72,0,0,0-2-1.87l-5.93-1a.37.37,0,0,1-.27-.17.39.39,0,0,1,0-.32l.95-3a1,1,0,0,1,.9-.63h0l6.22.25h.09a3.73,3.73,0,0,0,2.44-1.07,15.91,15.91,0,0,1,1.42-1.26,1.8,1.8,0,0,0,.71-1.28,1.67,1.67,0,0,0-.48-1.31l-2.47-2.63c-.08-.09-.09-.14-.09-.15s0-.05.14-.1l5.45-2.18a1.51,1.51,0,0,1,.55-.09,1.84,1.84,0,0,1,1,.25l3.67,2.43a4.09,4.09,0,0,0,2.14.59,3.12,3.12,0,0,0,.55,0c1.12-.19,2.28-.34,3.46-.43a3,3,0,0,0,2.31-1.51l1.36-2.64a1.26,1.26,0,0,1,1-.6m-1.8,25a20.8,20.8,0,0,0,7.66-1.39c3.4-1.36,5.57-3.55,6-6,.32-2-.57-4-2.5-5.59-2.55-2.12-6.72-3.39-11.14-3.39a21,21,0,0,0-7.66,1.39c-3.4,1.37-5.58,3.56-6,6a6,6,0,0,0,2.5,5.59c2.55,2.12,6.71,3.39,11.14,3.39m1.8-25.67a1.9,1.9,0,0,0-1.61,1l-1.36,2.64a2.39,2.39,0,0,1-1.76,1.15,34.38,34.38,0,0,0-3.53.44,2.9,2.9,0,0,1-.43,0,3.56,3.56,0,0,1-1.77-.47l-3.67-2.44a2.49,2.49,0,0,0-1.33-.35,2.24,2.24,0,0,0-.8.13l-5.45,2.19a.77.77,0,0,0-.29,1.33l2.47,2.63a1,1,0,0,1-.15,1.59,13.91,13.91,0,0,0-1.49,1.33,3.09,3.09,0,0,1-2,.86h-.06l-6.23-.25h-.05a1.67,1.67,0,0,0-1.52,1.11l-.94,3a1,1,0,0,0,.83,1.36l5.92,1a2,2,0,0,1,1.45,1.39,7.12,7.12,0,0,0,.45,1.18,1.19,1.19,0,0,1-.5,1.6l-4.38,2.2a.74.74,0,0,0-.15,1.32l3.48,2.89a2.48,2.48,0,0,0,1.51.49,1.81,1.81,0,0,0,.58-.08l5.3-1.66a3.11,3.11,0,0,1,.84-.11,3.65,3.65,0,0,1,1.41.26c.91.39,1.86.74,2.84,1.05a1.47,1.47,0,0,1,1,1.53l-.31,2.59a1.18,1.18,0,0,0,1.06,1.33l6.81.71H444a1.92,1.92,0,0,0,1.61-1l1.36-2.64a2.35,2.35,0,0,1,1.76-1.15c1.19-.09,2.37-.24,3.53-.44a2.72,2.72,0,0,1,.42,0,3.48,3.48,0,0,1,1.78.48l3.66,2.43a2.55,2.55,0,0,0,1.34.36,2.07,2.07,0,0,0,.8-.14l5.45-2.18a.77.77,0,0,0,.29-1.33L463.5,322a1.05,1.05,0,0,1,.15-1.6,12.91,12.91,0,0,0,1.49-1.33,3.09,3.09,0,0,1,1.95-.86h.07l6.22.25h.06a1.69,1.69,0,0,0,1.52-1.11l.94-3a1,1,0,0,0-.83-1.36l-5.93-1a2,2,0,0,1-1.44-1.38,8.93,8.93,0,0,0-.45-1.18,1.19,1.19,0,0,1,.5-1.61l4.37-2.19a.74.74,0,0,0,.16-1.32l-3.48-2.89a2.45,2.45,0,0,0-1.51-.5,2.08,2.08,0,0,0-.58.08l-5.3,1.66a2.82,2.82,0,0,1-.85.12,3.85,3.85,0,0,1-1.41-.26,24.47,24.47,0,0,0-2.84-1.05,1.48,1.48,0,0,1-1-1.54l.32-2.59a1.18,1.18,0,0,0-1.06-1.32l-6.81-.72Zm-1.8,25c-4.12,0-8.18-1.12-10.71-3.23-4.09-3.41-2.63-8.09,3.28-10.46a20.3,20.3,0,0,1,7.41-1.34c4.12,0,8.18,1.13,10.7,3.23,4.1,3.42,2.63,8.1-3.27,10.46a20.09,20.09,0,0,1-7.41,1.34Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M447.59,295.77h.09l6.81.71a.69.69,0,0,1,.46.24.69.69,0,0,1,.14.5l-.32,2.59a2,2,0,0,0,1.39,2.1,26.71,26.71,0,0,1,2.78,1,4.33,4.33,0,0,0,1.62.3,3.35,3.35,0,0,0,1-.14l5.31-1.66a1.67,1.67,0,0,1,.42-.05,2,2,0,0,1,1.17.37l3.48,2.89a.41.41,0,0,1,.16.25s-.07.13-.21.2l-4.37,2.2a1.69,1.69,0,0,0-.74,2.29,7.76,7.76,0,0,1,.42,1.1,2.52,2.52,0,0,0,1.86,1.76l5.92,1a.56.56,0,0,1,.38.24.54.54,0,0,1,0,.45l-.94,3a1.17,1.17,0,0,1-1,.74h0l-6.22-.25h-.09a3.57,3.57,0,0,0-2.32,1,16.38,16.38,0,0,1-1.44,1.28,1.66,1.66,0,0,0-.65,1.17,1.58,1.58,0,0,0,.44,1.2l2.47,2.63a.36.36,0,0,1,.13.28.39.39,0,0,1-.24.2L460,327.63a1.75,1.75,0,0,1-.6.1,2.06,2.06,0,0,1-1.05-.27L454.72,325a4,4,0,0,0-2.07-.56,2.78,2.78,0,0,0-.51,0c-1.13.2-2.3.34-3.48.43a2.93,2.93,0,0,0-2.19,1.44L445.11,329a1.39,1.39,0,0,1-1.14.67h-.09l-6.82-.71a.66.66,0,0,1-.45-.25.67.67,0,0,1-.14-.5l.31-2.58a2,2,0,0,0-1.38-2.1c-1-.31-1.91-.65-2.79-1a4.24,4.24,0,0,0-1.61-.3,3.44,3.44,0,0,0-1,.13l-5.3,1.66a1.33,1.33,0,0,1-.42.06,2,2,0,0,1-1.17-.37l-3.48-2.9a.33.33,0,0,1-.16-.24c0-.05.06-.13.21-.2l4.37-2.2a1.71,1.71,0,0,0,.74-2.3,7.76,7.76,0,0,1-.42-1.1A2.56,2.56,0,0,0,422.5,313l-5.92-1a.51.51,0,0,1-.42-.69l.94-3a1.16,1.16,0,0,1,1-.74h0l6.23.25h.08a3.57,3.57,0,0,0,2.33-1,12.75,12.75,0,0,1,1.44-1.28,1.68,1.68,0,0,0,.65-1.17,1.57,1.57,0,0,0-.44-1.2L426,300.5a.34.34,0,0,1-.13-.28.34.34,0,0,1,.24-.21l5.44-2.18a1.85,1.85,0,0,1,.61-.1,2,2,0,0,1,1,.27l3.67,2.43a4,4,0,0,0,2.06.57,2.78,2.78,0,0,0,.52-.05c1.13-.19,2.3-.34,3.48-.43a2.89,2.89,0,0,0,2.19-1.43l1.35-2.64a1.39,1.39,0,0,1,1.15-.68m-1.8,25a20.68,20.68,0,0,0,7.6-1.38c3.35-1.34,5.49-3.49,5.87-5.9a5.9,5.9,0,0,0-2.45-5.45c-2.52-2.1-6.65-3.35-11-3.35a20.53,20.53,0,0,0-7.61,1.38c-3.34,1.34-5.48,3.49-5.86,5.9-.31,1.94.56,3.87,2.45,5.44,2.52,2.1,6.65,3.36,11,3.36m1.8-25.52a1.9,1.9,0,0,0-1.61,1l-1.36,2.64a2.39,2.39,0,0,1-1.76,1.15,34.38,34.38,0,0,0-3.53.44,2.9,2.9,0,0,1-.43,0,3.56,3.56,0,0,1-1.77-.47l-3.67-2.44a2.49,2.49,0,0,0-1.33-.35,2.24,2.24,0,0,0-.8.13l-5.45,2.19a.77.77,0,0,0-.29,1.33l2.47,2.63a1,1,0,0,1-.15,1.59,15.1,15.1,0,0,0-1.5,1.33,3,3,0,0,1-2,.86h-.06l-6.23-.25h-.05a1.67,1.67,0,0,0-1.52,1.11l-.94,3a1,1,0,0,0,.83,1.36l5.92,1a2,2,0,0,1,1.45,1.39,7.12,7.12,0,0,0,.45,1.18,1.19,1.19,0,0,1-.5,1.6l-4.38,2.2a.74.74,0,0,0-.15,1.32l3.48,2.89a2.48,2.48,0,0,0,1.51.49,1.81,1.81,0,0,0,.58-.08l5.3-1.66a3.13,3.13,0,0,1,.85-.11,3.64,3.64,0,0,1,1.4.26c.91.39,1.86.74,2.84,1.05a1.47,1.47,0,0,1,1,1.53l-.31,2.59a1.18,1.18,0,0,0,1.06,1.33l6.81.71H444a1.92,1.92,0,0,0,1.61-1l1.36-2.64a2.35,2.35,0,0,1,1.76-1.15c1.19-.09,2.37-.24,3.53-.44a2.72,2.72,0,0,1,.42,0,3.48,3.48,0,0,1,1.78.48l3.66,2.43a2.55,2.55,0,0,0,1.34.36,2.07,2.07,0,0,0,.8-.14l5.45-2.18a.77.77,0,0,0,.29-1.33L463.5,322a1.05,1.05,0,0,1,.15-1.6,12.91,12.91,0,0,0,1.49-1.33,3.09,3.09,0,0,1,1.95-.86h.07l6.22.25h.06a1.69,1.69,0,0,0,1.52-1.11l.94-3a1,1,0,0,0-.83-1.36l-5.93-1a2,2,0,0,1-1.44-1.38,8.93,8.93,0,0,0-.45-1.18,1.19,1.19,0,0,1,.5-1.61l4.37-2.19a.73.73,0,0,0,.15-1.32l-3.47-2.89a2.45,2.45,0,0,0-1.51-.5,2.08,2.08,0,0,0-.58.08l-5.3,1.66a2.82,2.82,0,0,1-.85.12,3.85,3.85,0,0,1-1.41-.26,24.47,24.47,0,0,0-2.84-1.05,1.48,1.48,0,0,1-1-1.54l.32-2.59a1.18,1.18,0,0,0-1.06-1.32l-6.81-.72Zm-1.8,25c-4.12,0-8.18-1.12-10.71-3.23-4.09-3.41-2.63-8.09,3.28-10.46a20.3,20.3,0,0,1,7.41-1.34c4.12,0,8.18,1.13,10.7,3.23,4.1,3.42,2.63,8.1-3.27,10.46a20.09,20.09,0,0,1-7.41,1.34Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.24,339.16l-7.36-4.25a2,2,0,0,0-1.63-.08l-7.46,3.46a2.78,2.78,0,0,1-1.71.1,43.24,43.24,0,0,0-5.79-1.37,1.41,1.41,0,0,1-1.08-1l-.94-4.92a1.14,1.14,0,0,0-1.09-.9H388.36a1.16,1.16,0,0,0-1.09.9l-.93,4.92a1.43,1.43,0,0,1-1.08,1,43.24,43.24,0,0,0-5.79,1.37,2.78,2.78,0,0,1-1.71-.1l-7.46-3.46a2,2,0,0,0-1.63.08l-7.36,4.25a.58.58,0,0,0-.34.5h0l0,6.38h0a.63.63,0,0,0,.29.49l3.39,2.44a1.67,1.67,0,0,1-.83.35l-9.81.62a1,1,0,0,0-.92,1v4.17h0l0,7.68a1,1,0,0,0,.92,1l9.81.62a1.63,1.63,0,0,1,.85.36l-3.37,2.43a.62.62,0,0,0-.29.48h0l0,6.38h0a.6.6,0,0,0,.34.5l7.36,4.25a2,2,0,0,0,1.63.07l7.46-3.45a2.64,2.64,0,0,1,1.71-.1,44.83,44.83,0,0,0,5.79,1.37,1.41,1.41,0,0,1,1.08,1l.94,4.92a1.14,1.14,0,0,0,1.09.9h10.82a1.16,1.16,0,0,0,1.09-.9l.93-4.92a1.41,1.41,0,0,1,1.08-1,44.83,44.83,0,0,0,5.79-1.37,2.64,2.64,0,0,1,1.71.1l7.46,3.45a2,2,0,0,0,1.63-.07l7.36-4.25a.59.59,0,0,0,.34-.49h0l0-6.4h0a.62.62,0,0,0-.29-.48l-3.39-2.44a1.64,1.64,0,0,1,.83-.35l9.81-.62a1,1,0,0,0,.92-1v-6.36s0,0,0,0v-5.47a1,1,0,0,0-.92-1l-9.81-.62a1.72,1.72,0,0,1-.85-.36l3.37-2.43a.62.62,0,0,0,.29-.49h0l0-6.39h0A.6.6,0,0,0,426.24,339.16Zm-49.69,16.53c.53-1.77,2.1-3.49,4.79-5,6.86-4,18-4,24.87,0,2.51,1.45,4.16,3.05,4.9,4.69-.59,2-2.22,3.94-4.9,5.49-6.87,4-18,4-24.87,0A10.16,10.16,0,0,1,376.55,355.69Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.24,339.16l-7.36-4.25a2,2,0,0,0-1.63-.08l-7.46,3.46a2.78,2.78,0,0,1-1.71.1,43.24,43.24,0,0,0-5.79-1.37,1.41,1.41,0,0,1-1.08-1l-.94-4.92a1.14,1.14,0,0,0-1.09-.9H388.36a1.16,1.16,0,0,0-1.09.9l-.93,4.92a1.43,1.43,0,0,1-1.08,1,43.24,43.24,0,0,0-5.79,1.37,2.78,2.78,0,0,1-1.71-.1l-7.46-3.46a2,2,0,0,0-1.63.08l-7.36,4.25a.58.58,0,0,0-.34.5h0l0,6.38h0a.63.63,0,0,0,.29.49l3.39,2.44a1.67,1.67,0,0,1-.83.35l-9.81.62a1,1,0,0,0-.92,1v4.17h0l0,7.68a1,1,0,0,0,.92,1l9.81.62a1.63,1.63,0,0,1,.85.36l-3.37,2.43a.62.62,0,0,0-.29.48h0l0,6.38h0a.6.6,0,0,0,.34.5l7.36,4.25a2,2,0,0,0,1.63.07l7.46-3.45a2.64,2.64,0,0,1,1.71-.1,44.83,44.83,0,0,0,5.79,1.37,1.41,1.41,0,0,1,1.08,1l.94,4.92a1.14,1.14,0,0,0,1.09.9h10.82a1.16,1.16,0,0,0,1.09-.9l.93-4.92a1.41,1.41,0,0,1,1.08-1,44.83,44.83,0,0,0,5.79-1.37,2.64,2.64,0,0,1,1.71.1l7.46,3.45a2,2,0,0,0,1.63-.07l7.36-4.25a.59.59,0,0,0,.34-.49h0l0-6.4h0a.62.62,0,0,0-.29-.48l-3.39-2.44a1.64,1.64,0,0,1,.83-.35l9.81-.62a1,1,0,0,0,.92-1v-6.36s0,0,0,0v-5.47a1,1,0,0,0-.92-1l-9.81-.62a1.72,1.72,0,0,1-.85-.36l3.37-2.43a.62.62,0,0,0,.29-.49h0l0-6.39h0A.6.6,0,0,0,426.24,339.16Zm-49.69,16.53c.53-1.77,2.1-3.49,4.79-5,6.86-4,18-4,24.87,0,2.51,1.45,4.16,3.05,4.9,4.69-.59,2-2.22,3.94-4.9,5.49-6.87,4-18,4-24.87,0A10.16,10.16,0,0,1,376.55,355.69Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.12,358.86a1.79,1.79,0,0,0-1.33-.88l-9.81-.62a1,1,0,0,1-.91-1v-1.3l0,7.67a1,1,0,0,0,.92,1l9.81.62a1.66,1.66,0,0,1,.86.36L367.1,363a.78.78,0,0,0,.1-1.2A14.79,14.79,0,0,1,365.12,358.86ZM361,346h0a.63.63,0,0,0,.29.49l3.39,2.44a1.88,1.88,0,0,0,.49-.53,14.79,14.79,0,0,1,2.08-2.89.77.77,0,0,0-.11-1.2l-5.83-4.2a.72.72,0,0,1-.3-.42Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.21,346.47c-6.87-4-18-4-24.87,0-4.34,2.5-5.94,6-4.79,9.22.51-1.76,2.1-3.49,4.79-5,6.87-4,18-4,24.86,0,2.52,1.45,4.17,3.05,4.91,4.69C412,352.21,410.38,348.89,406.21,346.47Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.47,356.51a1,1,0,0,1-.91.85l-9.8.62a1.48,1.48,0,0,0-.5.13v6.39a1.53,1.53,0,0,1,.48-.14l9.81-.62a1,1,0,0,0,.92-1Zm-7.89-16.86h0a.36.36,0,0,1,0,.2.5.5,0,0,1-.12.19.69.69,0,0,1-.13.11l-5.84,4.2a.57.57,0,0,0-.14.13.69.69,0,0,0-.18.36.65.65,0,0,0,0,.24l0,.13a.92.92,0,0,0,.19.33l.11.13a14.56,14.56,0,0,1,2,2.76,1.91,1.91,0,0,0,.46.53l3.38-2.42a.65.65,0,0,0,.29-.49h0Zm0,28a.64.64,0,0,1-.34.45l-7.37,4.25a1.87,1.87,0,0,1-1.14.2V379a2,2,0,0,0,1.14-.2l7.36-4.25a.59.59,0,0,0,.34-.48Zm-48.08,1.14a2.24,2.24,0,0,0-.74.17l-7.46,3.46a1.42,1.42,0,0,1-.66.14l0,6.37a1.82,1.82,0,0,0,.67-.13l7.46-3.45a2,2,0,0,1,.73-.17Zm21.59,7.83a1.13,1.13,0,0,1-.9.49H388.36a1.07,1.07,0,0,1-.66-.24v6.38a1.07,1.07,0,0,0,.66.24h10.81a1.16,1.16,0,0,0,.95-.54Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.47,356.51a1,1,0,0,1-.91.85l-9.8.62a1.48,1.48,0,0,0-.5.13v6.39a1.53,1.53,0,0,1,.48-.14l9.81-.62a1,1,0,0,0,.92-1Zm-7.89-16.86h0a.36.36,0,0,1,0,.2.5.5,0,0,1-.12.19.69.69,0,0,1-.13.11l-5.84,4.2a.57.57,0,0,0-.14.13.69.69,0,0,0-.18.36.65.65,0,0,0,0,.24l0,.13a.92.92,0,0,0,.19.33l.11.13a14.56,14.56,0,0,1,2,2.76,1.91,1.91,0,0,0,.46.53l3.38-2.42a.65.65,0,0,0,.29-.49h0Zm0,28a.64.64,0,0,1-.34.45l-7.37,4.25a1.87,1.87,0,0,1-1.14.2V379a2,2,0,0,0,1.14-.2l7.36-4.25a.59.59,0,0,0,.34-.48Zm-48.08,1.14a2.24,2.24,0,0,0-.74.17l-7.46,3.46a1.42,1.42,0,0,1-.66.14l0,6.37a1.82,1.82,0,0,0,.67-.13l7.46-3.45a2,2,0,0,1,.73-.17Zm21.59,7.83a1.13,1.13,0,0,1-.9.49H388.36a1.07,1.07,0,0,1-.66-.24v6.38a1.07,1.07,0,0,0,.66.24h10.81a1.16,1.16,0,0,0,.95-.54Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.25,334.83l-7.46,3.46a2.78,2.78,0,0,1-1.71.1,43.24,43.24,0,0,0-5.79-1.37,1.41,1.41,0,0,1-1.08-1l-.94-4.92a1.14,1.14,0,0,0-1.09-.9H388.36a1.16,1.16,0,0,0-1.09.9l-.93,4.92a1.43,1.43,0,0,1-1.08,1,43.24,43.24,0,0,0-5.79,1.37,2.78,2.78,0,0,1-1.71-.1l-7.46-3.46a2,2,0,0,0-1.63.08l-7.36,4.25a.54.54,0,0,0-.05,1l5.84,4.2a.78.78,0,0,1,.1,1.2,14.79,14.79,0,0,0-2.08,2.89,1.85,1.85,0,0,1-1.32.88l-9.81.62a1,1,0,0,0-.92,1v5.48a1,1,0,0,0,.92,1l9.8.62a1.82,1.82,0,0,1,1.33.88,14.79,14.79,0,0,0,2.08,2.89.78.78,0,0,1-.1,1.2l-5.84,4.2a.54.54,0,0,0,.05,1l7.36,4.25a2,2,0,0,0,1.63.07l7.46-3.45a2.64,2.64,0,0,1,1.71-.1,44.83,44.83,0,0,0,5.79,1.37,1.43,1.43,0,0,1,1.08,1.05l.93,4.92a1.16,1.16,0,0,0,1.09.9h10.82a1.14,1.14,0,0,0,1.09-.9l.94-4.92a1.41,1.41,0,0,1,1.08-1.05,44.83,44.83,0,0,0,5.79-1.37,2.64,2.64,0,0,1,1.71.1l7.46,3.45a2,2,0,0,0,1.63-.07l7.36-4.25a.55.55,0,0,0,.05-1l-5.84-4.2a.78.78,0,0,1-.11-1.2,14.44,14.44,0,0,0,2.09-2.89,1.82,1.82,0,0,1,1.32-.88l9.81-.62a1,1,0,0,0,.92-1v-5.47a1,1,0,0,0-.92-1l-9.81-.62a1.85,1.85,0,0,1-1.32-.88,14.44,14.44,0,0,0-2.09-2.89.78.78,0,0,1,.11-1.2l5.84-4.2a.55.55,0,0,0-.05-1l-7.36-4.25A2,2,0,0,0,417.25,334.83Zm-11,11.64c6.87,4,6.87,10.39,0,14.36s-18,4-24.87,0-6.87-10.4,0-14.36S399.34,342.51,406.21,346.47Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.25,334.83l-7.46,3.46a2.78,2.78,0,0,1-1.71.1,43.24,43.24,0,0,0-5.79-1.37,1.41,1.41,0,0,1-1.08-1l-.94-4.92a1.14,1.14,0,0,0-1.09-.9H388.36a1.16,1.16,0,0,0-1.09.9l-.93,4.92a1.43,1.43,0,0,1-1.08,1,43.24,43.24,0,0,0-5.79,1.37,2.78,2.78,0,0,1-1.71-.1l-7.46-3.46a2,2,0,0,0-1.63.08l-7.36,4.25a.54.54,0,0,0-.05,1l5.84,4.2a.78.78,0,0,1,.1,1.2,14.79,14.79,0,0,0-2.08,2.89,1.85,1.85,0,0,1-1.32.88l-9.81.62a1,1,0,0,0-.92,1v5.48a1,1,0,0,0,.92,1l9.8.62a1.82,1.82,0,0,1,1.33.88,14.79,14.79,0,0,0,2.08,2.89.78.78,0,0,1-.1,1.2l-5.84,4.2a.54.54,0,0,0,.05,1l7.36,4.25a2,2,0,0,0,1.63.07l7.46-3.45a2.64,2.64,0,0,1,1.71-.1,44.83,44.83,0,0,0,5.79,1.37,1.43,1.43,0,0,1,1.08,1.05l.93,4.92a1.16,1.16,0,0,0,1.09.9h10.82a1.14,1.14,0,0,0,1.09-.9l.94-4.92a1.41,1.41,0,0,1,1.08-1.05,44.83,44.83,0,0,0,5.79-1.37,2.64,2.64,0,0,1,1.71.1l7.46,3.45a2,2,0,0,0,1.63-.07l7.36-4.25a.55.55,0,0,0,.05-1l-5.84-4.2a.78.78,0,0,1-.11-1.2,14.44,14.44,0,0,0,2.09-2.89,1.82,1.82,0,0,1,1.32-.88l9.81-.62a1,1,0,0,0,.92-1v-5.47a1,1,0,0,0-.92-1l-9.81-.62a1.85,1.85,0,0,1-1.32-.88,14.44,14.44,0,0,0-2.09-2.89.78.78,0,0,1,.11-1.2l5.84-4.2a.55.55,0,0,0-.05-1l-7.36-4.25A2,2,0,0,0,417.25,334.83Zm-11,11.64c6.87,4,6.87,10.39,0,14.36s-18,4-24.87,0-6.87-10.4,0-14.36S399.34,342.51,406.21,346.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.19,330.83h0a.47.47,0,0,1,.43.35l.93,4.91a2.08,2.08,0,0,0,1.63,1.59,44.54,44.54,0,0,1,5.71,1.36,3,3,0,0,0,.88.12,3.12,3.12,0,0,0,1.31-.26l7.46-3.45a1.12,1.12,0,0,1,.44-.08,1.34,1.34,0,0,1,.57.12l7.24,4.19-5.72,4.12a1.45,1.45,0,0,0-.62,1,1.53,1.53,0,0,0,.4,1.16,13.62,13.62,0,0,1,2,2.76,2.44,2.44,0,0,0,1.88,1.23l9.81.62a.31.31,0,0,1,.28.3v5.47a.31.31,0,0,1-.28.31l-9.81.62a2.44,2.44,0,0,0-1.88,1.23,13.29,13.29,0,0,1-2,2.75,1.57,1.57,0,0,0-.4,1.17,1.47,1.47,0,0,0,.62,1l5.72,4.12-7.24,4.18a1.2,1.2,0,0,1-.57.13,1.12,1.12,0,0,1-.44-.08l-7.46-3.46a3.29,3.29,0,0,0-1.31-.25,3,3,0,0,0-.88.12,43.3,43.3,0,0,1-5.71,1.35,2.11,2.11,0,0,0-1.63,1.59l-.93,4.92a.47.47,0,0,1-.43.35H388.36a.47.47,0,0,1-.42-.35L387,371.2a2.08,2.08,0,0,0-1.63-1.59,43.15,43.15,0,0,1-5.7-1.35,3,3,0,0,0-.88-.12,3.26,3.26,0,0,0-1.31.25L370,371.85a1.12,1.12,0,0,1-.44.08,1.17,1.17,0,0,1-.57-.13l-7.24-4.18,5.72-4.12a1.46,1.46,0,0,0,.61-1,1.49,1.49,0,0,0-.4-1.17,13.61,13.61,0,0,1-2-2.75,2.47,2.47,0,0,0-1.88-1.23l-9.81-.62a.31.31,0,0,1-.28-.3v-5.48a.31.31,0,0,1,.28-.3l9.81-.62a2.47,2.47,0,0,0,1.88-1.23,14,14,0,0,1,2-2.76,1.46,1.46,0,0,0,.4-1.16,1.44,1.44,0,0,0-.61-1l-5.72-4.12,7.24-4.19a1.3,1.3,0,0,1,.57-.12,1.12,1.12,0,0,1,.44.08l7.46,3.45a3.09,3.09,0,0,0,1.31.26,3,3,0,0,0,.88-.12,44.79,44.79,0,0,1,5.7-1.36,2.05,2.05,0,0,0,1.63-1.59l.94-4.91a.47.47,0,0,1,.42-.35h10.83m-5.42,33.65a26,26,0,0,0,12.78-3.07c3.54-2,5.49-4.8,5.49-7.76s-2-5.72-5.49-7.77a28.2,28.2,0,0,0-25.55,0c-3.54,2.05-5.49,4.8-5.49,7.77s1.95,5.72,5.49,7.76a25.91,25.91,0,0,0,12.77,3.07m5.42-34.33H388.36a1.16,1.16,0,0,0-1.09.9l-.93,4.92a1.43,1.43,0,0,1-1.08,1,43.24,43.24,0,0,0-5.79,1.37,2.43,2.43,0,0,1-.68.09,2.56,2.56,0,0,1-1-.19l-7.46-3.46a1.81,1.81,0,0,0-.72-.14,1.91,1.91,0,0,0-.91.22l-7.36,4.25a.54.54,0,0,0-.05,1l5.84,4.2a.78.78,0,0,1,.1,1.2,14.79,14.79,0,0,0-2.08,2.89,1.85,1.85,0,0,1-1.32.88l-9.81.62a1,1,0,0,0-.92,1v5.48a1,1,0,0,0,.92,1l9.8.62a1.82,1.82,0,0,1,1.33.88,14.79,14.79,0,0,0,2.08,2.89.78.78,0,0,1-.1,1.2l-5.84,4.2a.54.54,0,0,0,.05,1l7.36,4.25a1.91,1.91,0,0,0,.91.21,1.65,1.65,0,0,0,.72-.14l7.46-3.45a2.56,2.56,0,0,1,1-.2,2.11,2.11,0,0,1,.68.1,44.83,44.83,0,0,0,5.79,1.37,1.43,1.43,0,0,1,1.08,1.05l.93,4.92a1.16,1.16,0,0,0,1.09.9h10.82a1.14,1.14,0,0,0,1.09-.9l.94-4.92a1.41,1.41,0,0,1,1.08-1.05,44.83,44.83,0,0,0,5.79-1.37,2,2,0,0,1,.68-.1,2.56,2.56,0,0,1,1,.2l7.46,3.45a1.65,1.65,0,0,0,.72.14,1.91,1.91,0,0,0,.91-.21l7.36-4.25a.55.55,0,0,0,.05-1l-5.84-4.2a.78.78,0,0,1-.11-1.2,14.44,14.44,0,0,0,2.09-2.89,1.82,1.82,0,0,1,1.32-.88l9.81-.62a1,1,0,0,0,.92-1v-5.47a1,1,0,0,0-.92-1l-9.81-.62a1.85,1.85,0,0,1-1.32-.88,14.44,14.44,0,0,0-2.09-2.89.78.78,0,0,1,.11-1.2l5.84-4.2a.55.55,0,0,0-.05-1l-7.36-4.25a1.91,1.91,0,0,0-.91-.22,1.81,1.81,0,0,0-.72.14l-7.46,3.46a2.56,2.56,0,0,1-1,.19,2.33,2.33,0,0,1-.68-.09,43.24,43.24,0,0,0-5.79-1.37,1.41,1.41,0,0,1-1.08-1l-.94-4.92a1.14,1.14,0,0,0-1.08-.9Zm-5.42,33.65a25.42,25.42,0,0,1-12.43-3c-6.87-4-6.87-10.4,0-14.36a27.52,27.52,0,0,1,24.87,0c6.87,4,6.87,10.39,0,14.36a25.48,25.48,0,0,1-12.44,3Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.18,330.67h0a.64.64,0,0,1,.58.48l.93,4.92a1.93,1.93,0,0,0,1.51,1.46,44.7,44.7,0,0,1,5.72,1.36,2.7,2.7,0,0,0,.84.12,3.2,3.2,0,0,0,1.25-.24l7.46-3.46a1.21,1.21,0,0,1,.5-.09,1.32,1.32,0,0,1,.64.14l7.36,4.25.08.05h0l-.07.07-5.83,4.19a1.27,1.27,0,0,0-.55.93,1.35,1.35,0,0,0,.36,1,14.43,14.43,0,0,1,2,2.79,2.33,2.33,0,0,0,1.75,1.15l9.81.62a.46.46,0,0,1,.42.45v5.47a.47.47,0,0,1-.42.46l-9.81.62a2.33,2.33,0,0,0-1.75,1.15,14.74,14.74,0,0,1-2,2.79,1.31,1.31,0,0,0-.36,1.05,1.24,1.24,0,0,0,.55.92l5.83,4.2.07.06h0a.19.19,0,0,1-.08.07l-7.36,4.25a1.32,1.32,0,0,1-.64.14,1.21,1.21,0,0,1-.5-.09L410,368.53a3.2,3.2,0,0,0-1.25-.24,2.7,2.7,0,0,0-.84.12,45.11,45.11,0,0,1-5.72,1.36,1.93,1.93,0,0,0-1.51,1.46l-.93,4.92a.64.64,0,0,1-.58.48H388.36a.64.64,0,0,1-.57-.48l-.94-4.92a1.91,1.91,0,0,0-1.5-1.46,43.61,43.61,0,0,1-5.73-1.37,3,3,0,0,0-.83-.11,3.16,3.16,0,0,0-1.25.24L370.08,372a1.24,1.24,0,0,1-.5.09,1.39,1.39,0,0,1-.65-.14l-7.36-4.25-.07-.05h0l.07-.07,5.83-4.2a1.27,1.27,0,0,0,.55-.92,1.35,1.35,0,0,0-.36-1.05,14.31,14.31,0,0,1-2-2.79,2.35,2.35,0,0,0-1.75-1.15l-9.81-.62a.47.47,0,0,1-.43-.45v-5.48a.47.47,0,0,1,.43-.45l9.81-.62a2.35,2.35,0,0,0,1.75-1.15,14,14,0,0,1,2-2.79,1.35,1.35,0,0,0,.36-1,1.3,1.3,0,0,0-.55-.93l-5.83-4.19-.07-.06h0l.08-.06,7.36-4.25a1.39,1.39,0,0,1,.65-.14,1.24,1.24,0,0,1,.5.09l7.46,3.46a3.16,3.16,0,0,0,1.25.24,2.7,2.7,0,0,0,.84-.12,44.7,44.7,0,0,1,5.72-1.36,1.91,1.91,0,0,0,1.5-1.46l.94-4.92a.64.64,0,0,1,.57-.48h10.82m-5.41,33.66a25.85,25.85,0,0,0,12.7-3.05c3.49-2,5.41-4.72,5.41-7.63S410,348,406.47,346a27.95,27.95,0,0,0-25.39,0c-3.49,2-5.42,4.72-5.42,7.63s1.93,5.62,5.42,7.63a25.84,25.84,0,0,0,12.69,3.05m5.41-34.18H388.36a1.16,1.16,0,0,0-1.09.9l-.93,4.92a1.43,1.43,0,0,1-1.08,1,43.24,43.24,0,0,0-5.79,1.37,2.43,2.43,0,0,1-.68.09,2.56,2.56,0,0,1-1-.19l-7.46-3.46a1.81,1.81,0,0,0-.72-.14,1.91,1.91,0,0,0-.91.22l-7.36,4.25a.54.54,0,0,0-.05,1l5.84,4.2a.78.78,0,0,1,.1,1.2,14.79,14.79,0,0,0-2.08,2.89,1.85,1.85,0,0,1-1.32.88l-9.81.62a1,1,0,0,0-.92,1v5.48a1,1,0,0,0,.92,1l9.8.62a1.82,1.82,0,0,1,1.33.88,14.79,14.79,0,0,0,2.08,2.89.78.78,0,0,1-.1,1.2l-5.84,4.2a.54.54,0,0,0,.05,1l7.36,4.25a1.91,1.91,0,0,0,.91.21,1.65,1.65,0,0,0,.72-.14l7.46-3.45a2.56,2.56,0,0,1,1-.2,2.11,2.11,0,0,1,.68.1,44.83,44.83,0,0,0,5.79,1.37,1.43,1.43,0,0,1,1.08,1.05l.93,4.92a1.16,1.16,0,0,0,1.09.9h10.82a1.14,1.14,0,0,0,1.09-.9l.94-4.92a1.41,1.41,0,0,1,1.08-1.05,44.83,44.83,0,0,0,5.79-1.37,2,2,0,0,1,.68-.1,2.56,2.56,0,0,1,1,.2l7.46,3.45a1.65,1.65,0,0,0,.72.14,1.91,1.91,0,0,0,.91-.21l7.36-4.25a.55.55,0,0,0,.05-1l-5.84-4.2a.78.78,0,0,1-.11-1.2,14.44,14.44,0,0,0,2.09-2.89,1.82,1.82,0,0,1,1.32-.88l9.81-.62a1,1,0,0,0,.92-1v-5.47a1,1,0,0,0-.92-1l-9.81-.62a1.85,1.85,0,0,1-1.32-.88,14.44,14.44,0,0,0-2.09-2.89.78.78,0,0,1,.11-1.2l5.84-4.2a.55.55,0,0,0-.05-1l-7.36-4.25a1.91,1.91,0,0,0-.91-.22,1.81,1.81,0,0,0-.72.14l-7.46,3.46a2.56,2.56,0,0,1-1,.19,2.33,2.33,0,0,1-.68-.09,43.24,43.24,0,0,0-5.79-1.37,1.41,1.41,0,0,1-1.08-1l-.94-4.92a1.14,1.14,0,0,0-1.09-.9Zm-5.41,33.65a25.42,25.42,0,0,1-12.43-3c-6.87-4-6.87-10.4,0-14.36a27.52,27.52,0,0,1,24.87,0c6.87,4,6.87,10.39,0,14.36a25.48,25.48,0,0,1-12.44,3Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tab-2--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.47,18.87a2,2,0,0,0-.06-.35.08.08,0,0,0,0-.08,1.13,1.13,0,0,0-.09-.34,1.52,1.52,0,0,0-.23-.5.63.63,0,0,0-.12-.21.81.81,0,0,0-.12-.14,1.48,1.48,0,0,0-.25-.25l0,0a2.17,2.17,0,0,0-.33-.19,2.85,2.85,0,0,0-2.62.33L106.16,146.36c-2.14,1.24-3.89,4.26-3.89,8.59V343a2.63,2.63,0,0,0,1.4,2.33l.17.11.2.12a1.35,1.35,0,0,0,.34.11,2.07,2.07,0,0,0,.49.07,2.55,2.55,0,0,0,1.29-.37l.11-.06h0l3.71-2.15L330.6,216a8.59,8.59,0,0,0,3.9-6.74V19.36C334.5,19.19,334.48,19,334.47,18.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.33,17.7a1,1,0,0,1,.44.1l.07,0,0,0,.06,0,.1.13h0v0l.09.13a.46.46,0,0,1,.07.16l0,0,.1.31v0l0,0,0,.06s0,.08,0,.11,0,.26,0,.39V209.29a7.51,7.51,0,0,1-3.33,5.77L109.43,342.17l-3.62,2.08h0l-.1.05-.1.06a1.53,1.53,0,0,1-.68.22h-.06l-.25,0-.08,0-.1-.06-.1-.06,0,0,0,0,0,0a1.51,1.51,0,0,1-.81-1.35V155c0-4.2,1.73-6.69,3.34-7.63L331.15,18.08a2.48,2.48,0,0,1,1.18-.38m0-1.11a3.58,3.58,0,0,0-1.73.52L106.16,146.36c-2.14,1.24-3.89,4.26-3.89,8.59V343a2.63,2.63,0,0,0,1.4,2.33l.17.11.2.12a1.35,1.35,0,0,0,.34.11,2.07,2.07,0,0,0,.49.07h.06a2.55,2.55,0,0,0,1.23-.37l.11-.06h0l3.71-2.15L330.6,216a8.59,8.59,0,0,0,3.9-6.74V19.36c0-.17,0-.33,0-.49a2,2,0,0,0-.06-.35.08.08,0,0,0,0-.08,1.13,1.13,0,0,0-.09-.34,1.52,1.52,0,0,0-.23-.5.63.63,0,0,0-.12-.21.81.81,0,0,0-.12-.14,1.48,1.48,0,0,0-.25-.25l0,0a2.17,2.17,0,0,0-.33-.19,2,2,0,0,0-.89-.19Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.22,16.78a2.85,2.85,0,0,0-2.62.33L106.16,146.36a8.63,8.63,0,0,0-3.89,6.74v7.54l-7.6-4.42v-7.46A8.6,8.6,0,0,1,98.55,142L323,12.79a2.69,2.69,0,0,1,2.82-.23C326.53,13,332.39,16.35,333.22,16.78Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.49,19.33c0-2.45-1.75-3.45-3.89-2.21L106.16,146.36a8.6,8.6,0,0,0-3.89,6.74v7.55L334.49,26.93Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.6,17.12,106.16,146.36a8,8,0,0,0-2.73,2.89l-7.58-4.38A7.81,7.81,0,0,1,98.56,142L323,12.78a2.78,2.78,0,0,1,2.83-.23c.7.43,6.55,3.78,7.37,4.22A2.79,2.79,0,0,0,330.6,17.12Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.67,156.23v-7.47a8,8,0,0,1,1.18-3.89l7.59,4.37a7.85,7.85,0,0,0-1.16,3.86v7.55Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.6,28.46A4,4,0,0,0,316,31.61c0,1.22.74,1.78,1.65,1.25a4,4,0,0,0,1.65-3.15C319.25,28.49,318.51,27.93,317.6,28.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.54,25a4,4,0,0,0-1.65,3.16c0,1.21.74,1.77,1.65,1.24a4,4,0,0,0,1.65-3.15C325.19,25.05,324.45,24.49,323.54,25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.48,21.58a4,4,0,0,0-1.65,3.16c0,1.21.74,1.77,1.65,1.25a4,4,0,0,0,1.66-3.16C331.14,21.62,330.4,21.06,329.48,21.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.67,345.32l-.2-.11-6.73-3.89a4.11,4.11,0,0,1-2-3,3.64,3.64,0,0,1,0-.57V156.22l7.6,4.43V343a2.55,2.55,0,0,0,1.21,2.21,1,1,0,0,0,.13.09l0,0Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.67,345.32l-.2-.11-6.73-3.89a4.11,4.11,0,0,1-2-3,3.64,3.64,0,0,1,0-.57V156.22l7.6,4.43V343a2.55,2.55,0,0,0,1.21,2.21,1,1,0,0,0,.13.09l0,0Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.21,284l60.35-34.84V173.24l-60.35,34.84Zm-74.77,43.17,60.35-34.85V216.41l-60.35,34.84ZM263,240.81,323.32,206V130.08L263,164.92ZM113.44,171.45v68.12L323.32,118.4V50.28Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tab-1--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.38,203.39,169.8,136.18c2.27-1.31,4.1-.25,4.1,2.37v76.71a9.06,9.06,0,0,1-4.1,7.11L53.38,289.59c-2.26,1.31-4.1.25-4.1-2.37V210.51A9.1,9.1,0,0,1,53.38,203.39Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.68,145.14a1.43,1.43,0,0,0-.06-.36.09.09,0,0,0,0-.07,1.53,1.53,0,0,0-.09-.34,1.75,1.75,0,0,0-.23-.5.63.63,0,0,0-.13-.2.49.49,0,0,0-.11-.14,1.18,1.18,0,0,0-.25-.25l0,0a1.77,1.77,0,0,0-.33-.19,2.79,2.79,0,0,0-2.58.33L61.1,208.3c-2.13,1.22-3.86,4.22-3.86,8.5v76.48c0-1.82,0-1.81,0-1.8v.84a2.6,2.6,0,0,0,1.38,2.31l.17.11.2.12a1.17,1.17,0,0,0,.33.11,2.05,2.05,0,0,0,.49.06,2.45,2.45,0,0,0,1.28-.36l.1-.06h0l3.67-2.12,109-62.79a8.51,8.51,0,0,0,3.85-6.67V145.62A3.64,3.64,0,0,0,177.68,145.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.44,143.06a2.79,2.79,0,0,0-2.58.33L61.1,208.3A8.51,8.51,0,0,0,57.24,215v7.46l-4.76-2.79v-7.37a8.51,8.51,0,0,1,3.84-6.66l112.78-64.9a2.66,2.66,0,0,1,2.79-.23C172.58,140.89,175.62,142.63,176.44,143.06Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.7,145.59c0-2.43-1.73-3.41-3.85-2.19L61.09,208.3A8.52,8.52,0,0,0,57.25,215v7.47L177.7,153.1Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.85,143.4,61.1,208.3a8,8,0,0,0-2.71,2.86l-4.74-2.74a7.65,7.65,0,0,1,2.68-2.81L169.09,140.7a2.72,2.72,0,0,1,2.8-.23c.69.43,3.73,2.15,4.54,2.59A2.77,2.77,0,0,0,173.85,143.4Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.48,219.66v-7.4a8,8,0,0,1,1.17-3.84l4.75,2.72A7.83,7.83,0,0,0,57.25,215v7.47Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.53,153.49a3.87,3.87,0,0,0-1.46,3.1c0,1.24.65,1.87,1.46,1.41a3.87,3.87,0,0,0,1.46-3.1C164,153.66,163.34,153,162.53,153.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.8,150.45a3.84,3.84,0,0,0-1.47,3.09c0,1.25.66,1.88,1.47,1.41a3.88,3.88,0,0,0,1.46-3.09C169.26,150.61,168.6,150,167.8,150.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.06,147.4a3.87,3.87,0,0,0-1.46,3.1c0,1.24.65,1.87,1.46,1.41a3.87,3.87,0,0,0,1.46-3.1C174.52,147.57,173.87,146.94,173.06,147.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.63,294.65l-.2-.11-3.91-2.26a4.1,4.1,0,0,1-2-3,5.4,5.4,0,0,1,0-.56v-69.1l4.76,2.79v69.89a2.53,2.53,0,0,0,1.2,2.18,1,1,0,0,0,.13.09s0,0,0,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.53,258.25l5-2.87c.5-.29.9-.06.9.52v1.83a2,2,0,0,1-.9,1.57l-5,2.87c-.5.29-.91.06-.91-.52v-1.83A2,2,0,0,1,64.53,258.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.53,265.54l5-2.88c.5-.29.9-.05.9.52V265a2,2,0,0,1-.9,1.57l-5,2.88c-.5.29-.91.05-.91-.53V267.1A2,2,0,0,1,64.53,265.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.53,272.82l5-2.87c.5-.29.9-.06.9.52v1.83a2,2,0,0,1-.9,1.57l-5,2.87c-.5.29-.91.06-.91-.52v-1.83A2,2,0,0,1,64.53,272.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.53,280.11l5-2.88c.5-.28.9-.05.9.53v1.83a2,2,0,0,1-.9,1.56l-5,2.88c-.5.29-.91.05-.91-.52v-1.83A2,2,0,0,1,64.53,280.11Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.53,225.76l5-2.88c.5-.28.9,0,.9.53v1.83a2,2,0,0,1-.9,1.56l-5,2.88c-.5.29-.91,0-.91-.52v-1.83A2,2,0,0,1,64.53,225.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.53,233.05l5-2.88c.5-.29.9,0,.9.52v1.83a2,2,0,0,1-.9,1.57l-5,2.88c-.5.28-.91.05-.91-.53v-1.83A2,2,0,0,1,64.53,233.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.53,240.33l5-2.87c.5-.29.9-.06.9.52v1.83a2,2,0,0,1-.9,1.57l-5,2.87c-.5.29-.91.06-.91-.52V241.9A2,2,0,0,1,64.53,240.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.53,247.62l5-2.88c.5-.29.9-.05.9.53v1.83a2,2,0,0,1-.9,1.56l-5,2.88c-.5.29-.91.05-.91-.52v-1.83A2,2,0,0,1,64.53,247.62Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.43,219.71l27.86-16.12c.51-.29.92-.08.92.46a2,2,0,0,1-.92,1.52L77.43,221.7c-.5.29-.91.08-.91-.47A2,2,0,0,1,77.43,219.71Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4,243.68l42.73-24.74c.51-.29.92-.08.92.46a2,2,0,0,1-.92,1.53L77.4,245.67c-.51.29-.92.08-.92-.47A2,2,0,0,1,77.4,243.68Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.84,201.54l11.85-6.83c.51-.29.92-.09.92.46a2,2,0,0,1-.92,1.52l-11.85,6.84c-.51.29-.92.08-.92-.47A2,2,0,0,1,108.84,201.54Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.43,225.41l10-5.83c.51-.29.92-.08.92.46a2,2,0,0,1-.92,1.52l-10,5.83c-.5.29-.91.09-.91-.46A2,2,0,0,1,77.43,225.41Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.43,225.41l10-5.83c.51-.29.92-.08.92.46a2,2,0,0,1-.92,1.52l-10,5.83c-.5.29-.91.09-.91-.46A2,2,0,0,1,77.43,225.41Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.43,231.07l11-6.32c.51-.3.92-.09.92.46a2,2,0,0,1-.92,1.52l-11,6.33c-.5.29-.91.08-.91-.47A2,2,0,0,1,77.43,231.07Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.43,231.07l11-6.32c.51-.3.92-.09.92.46a2,2,0,0,1-.92,1.52l-11,6.33c-.5.29-.91.08-.91-.47A2,2,0,0,1,77.43,231.07Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,217.53l8.33-4.84c.5-.29.91-.08.91.46a2,2,0,0,1-.91,1.52L91,219.52c-.5.29-.91.08-.91-.47A2,2,0,0,1,91,217.53Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,217.53l8.33-4.84c.5-.29.91-.08.91.46a2,2,0,0,1-.91,1.52L91,219.52c-.5.29-.91.08-.91-.47A2,2,0,0,1,91,217.53Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,252.44l33.73-19.67c.51-.29.92-.09.92.46a2,2,0,0,1-.92,1.52L87,254.43c-.5.29-.91.08-.91-.47A2,2,0,0,1,87,252.44Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,246.78l33.73-19.7c.51-.29.92-.09.92.46a2,2,0,0,1-.92,1.52L87,248.76c-.5.3-.91.09-.91-.46A2,2,0,0,1,87,246.78Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.36,223.07l9.82-5.76c.51-.29.92-.08.92.47a2,2,0,0,1-.92,1.52l-9.82,5.75c-.5.29-.91.09-.91-.46A2,2,0,0,1,91.36,223.07Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.36,223.07l9.82-5.76c.51-.29.92-.08.92.47a2,2,0,0,1-.92,1.52l-9.82,5.75c-.5.29-.91.09-.91-.46A2,2,0,0,1,91.36,223.07Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.73,215.26l15.42-8.7c.51-.29.92-.08.92.46a2,2,0,0,1-.92,1.52l-15.42,8.71c-.5.29-.91.08-.91-.47A2,2,0,0,1,104.73,215.26Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.73,215.26l15.42-8.7c.51-.29.92-.08.92.46a2,2,0,0,1-.92,1.52l-15.42,8.71c-.5.29-.91.08-.91-.47A2,2,0,0,1,104.73,215.26Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4,237.06l23.78-13.67c.51-.29.92-.08.92.47a2,2,0,0,1-.92,1.52L77.4,239c-.51.29-.92.08-.92-.46A2,2,0,0,1,77.4,237.06Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4,237.06l23.78-13.67c.51-.29.92-.08.92.47a2,2,0,0,1-.92,1.52L77.4,239c-.51.29-.92.08-.92-.46A2,2,0,0,1,77.4,237.06Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.73,221.34l15.42-8.7c.51-.29.92-.08.92.46a2,2,0,0,1-.92,1.52l-15.42,8.71c-.5.29-.91.08-.91-.47A2,2,0,0,1,104.73,221.34Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.73,221.34l15.42-8.7c.51-.29.92-.08.92.46a2,2,0,0,1-.92,1.52l-15.42,8.71c-.5.29-.91.08-.91-.47A2,2,0,0,1,104.73,221.34Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,258.18l33.73-19.54c.51-.29.92-.08.92.46a2,2,0,0,1-.92,1.52L87,260.16c-.5.29-.91.08-.91-.46A2,2,0,0,1,87,258.18Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,263.85l33.73-19.53c.51-.3.92-.09.92.46a2,2,0,0,1-.92,1.52L87,265.84c-.5.29-.91.08-.91-.47A2,2,0,0,1,87,263.85Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,269.53,120.69,250c.51-.29.92-.08.92.47a2,2,0,0,1-.92,1.52L87,271.51c-.5.29-.91.09-.91-.46A2,2,0,0,1,87,269.53Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.62,251.37l4.24-2.43c.5-.29.91-.09.91.46a2,2,0,0,1-.91,1.52l-4.24,2.43c-.5.3-.91.09-.91-.46A2,2,0,0,1,77.62,251.37Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.62,251.37l4.24-2.43c.5-.29.91-.09.91.46a2,2,0,0,1-.91,1.52l-4.24,2.43c-.5.3-.91.09-.91-.46A2,2,0,0,1,77.62,251.37Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.62,263.58l4.24-2.44c.5-.29.91-.08.91.46a2,2,0,0,1-.91,1.52l-4.24,2.44c-.5.29-.91.08-.91-.46A2,2,0,0,1,77.62,263.58Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.62,263.58l4.24-2.44c.5-.29.91-.08.91.46a2,2,0,0,1-.91,1.52l-4.24,2.44c-.5.29-.91.08-.91-.46A2,2,0,0,1,77.62,263.58Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.62,269.25l4.24-2.43c.5-.29.91-.09.91.46a2,2,0,0,1-.91,1.52l-4.24,2.44c-.5.29-.91.08-.91-.47A2,2,0,0,1,77.62,269.25Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.62,269.25l4.24-2.43c.5-.29.91-.09.91.46a2,2,0,0,1-.91,1.52l-4.24,2.44c-.5.29-.91.08-.91-.47A2,2,0,0,1,77.62,269.25Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.62,274.93l4.24-2.44c.5-.29.91-.08.91.47a2,2,0,0,1-.91,1.52l-4.24,2.43c-.5.29-.91.09-.91-.46A2,2,0,0,1,77.62,274.93Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.62,274.93l4.24-2.44c.5-.29.91-.08.91.47a2,2,0,0,1-.91,1.52l-4.24,2.43c-.5.29-.91.09-.91-.46A2,2,0,0,1,77.62,274.93Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.81,166.32,132.08,187a5.32,5.32,0,0,0-2.4,4.16v53.81c0,1.53,1.08,2.15,2.4,1.38l35.73-20.62a5.33,5.33,0,0,0,2.4-4.16V167.71C170.21,166.18,169.13,165.56,167.81,166.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.49,207.22l-3.29,1.9a2.6,2.6,0,0,0-1.21,2c0,.73.54,1,1.21.62l3.29-1.9a2.62,2.62,0,0,0,1.22-2C165.71,207.1,165.16,206.83,164.49,207.22Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.49,207.22l-3.29,1.9a2.6,2.6,0,0,0-1.21,2c0,.73.54,1,1.21.62l3.29-1.9a2.62,2.62,0,0,0,1.22-2C165.71,207.1,165.16,206.83,164.49,207.22Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.49,173.43l-3.29,1.9a2.61,2.61,0,0,0-1.21,2c0,.73.54,1,1.21.61l3.29-1.9a2.6,2.6,0,0,0,1.22-2C165.71,173.32,165.16,173,164.49,173.43Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.49,173.43l-3.29,1.9a2.61,2.61,0,0,0-1.21,2c0,.73.54,1,1.21.61l3.29-1.9a2.6,2.6,0,0,0,1.22-2C165.71,173.32,165.16,173,164.49,173.43Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.87,182.84l-3.29,1.9a2.61,2.61,0,0,0-1.21,2c0,.73.54,1,1.21.62l3.29-1.91a2.59,2.59,0,0,0,1.21-2C161.08,182.73,160.54,182.46,159.87,182.84Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.87,182.84l-3.29,1.9a2.61,2.61,0,0,0-1.21,2c0,.73.54,1,1.21.62l3.29-1.91a2.59,2.59,0,0,0,1.21-2C161.08,182.73,160.54,182.46,159.87,182.84Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.87,189.58l-3.29,1.9a2.61,2.61,0,0,0-1.21,2c0,.73.54,1,1.21.61l3.29-1.9a2.59,2.59,0,0,0,1.21-2C161.08,189.47,160.54,189.19,159.87,189.58Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.87,189.58l-3.29,1.9a2.61,2.61,0,0,0-1.21,2c0,.73.54,1,1.21.61l3.29-1.9a2.59,2.59,0,0,0,1.21-2C161.08,189.47,160.54,189.19,159.87,189.58Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.49,193.7l-3.29,1.9a2.61,2.61,0,0,0-1.21,2c0,.72.54,1,1.21.61l3.29-1.9a2.62,2.62,0,0,0,1.22-2C165.71,193.59,165.16,193.31,164.49,193.7Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.49,193.7l-3.29,1.9a2.61,2.61,0,0,0-1.21,2c0,.72.54,1,1.21.61l3.29-1.9a2.62,2.62,0,0,0,1.22-2C165.71,193.59,165.16,193.31,164.49,193.7Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.87,203.11,156.58,205a2.59,2.59,0,0,0-1.21,2c0,.73.54,1,1.21.62l3.29-1.9a2.61,2.61,0,0,0,1.21-2C161.08,203,160.54,202.73,159.87,203.11Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.87,203.11,156.58,205a2.59,2.59,0,0,0-1.21,2c0,.73.54,1,1.21.62l3.29-1.9a2.61,2.61,0,0,0,1.21-2C161.08,203,160.54,202.73,159.87,203.11Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.49,178.63l-20.09,11.6a2.62,2.62,0,0,0-1.22,2c0,.73.55,1,1.22.61l20.09-11.59a2.61,2.61,0,0,0,1.21-2C156.7,178.52,156.16,178.25,155.49,178.63Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.49,178.63l-20.09,11.6a2.62,2.62,0,0,0-1.22,2c0,.73.55,1,1.22.61l20.09-11.59a2.61,2.61,0,0,0,1.21-2C156.7,178.52,156.16,178.25,155.49,178.63Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.49,212.42,135.4,224a2.6,2.6,0,0,0-1.22,2c0,.73.55,1,1.22.62l20.09-11.6a2.61,2.61,0,0,0,1.21-2C156.7,212.31,156.16,212,155.49,212.42Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.49,212.42,135.4,224a2.6,2.6,0,0,0-1.22,2c0,.73.55,1,1.22.62l20.09-11.6a2.61,2.61,0,0,0,1.21-2C156.7,212.31,156.16,212,155.49,212.42Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.86,188l-15.46,9a2.62,2.62,0,0,0-1.22,2c0,.72.55,1,1.22.61l15.46-8.94a2.62,2.62,0,0,0,1.22-2C152.08,187.93,151.53,187.66,150.86,188Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.86,188l-15.46,9a2.62,2.62,0,0,0-1.22,2c0,.72.55,1,1.22.61l15.46-8.94a2.62,2.62,0,0,0,1.22-2C152.08,187.93,151.53,187.66,150.86,188Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.86,194.8l-15.46,8.95a2.6,2.6,0,0,0-1.22,2c0,.73.55,1,1.22.62l15.46-8.95a2.6,2.6,0,0,0,1.22-2C152.08,194.69,151.53,194.41,150.86,194.8Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.86,194.8l-15.46,8.95a2.6,2.6,0,0,0-1.22,2c0,.73.55,1,1.22.62l15.46-8.95a2.6,2.6,0,0,0,1.22-2C152.08,194.69,151.53,194.41,150.86,194.8Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.49,198.91,135.4,210.5a2.62,2.62,0,0,0-1.22,2c0,.73.55,1,1.22.61l20.09-11.59a2.61,2.61,0,0,0,1.21-2C156.7,198.79,156.16,198.52,155.49,198.91Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.49,198.91,135.4,210.5a2.62,2.62,0,0,0-1.22,2c0,.73.55,1,1.22.61l20.09-11.59a2.61,2.61,0,0,0,1.21-2C156.7,198.79,156.16,198.52,155.49,198.91Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.86,208.32l-15.46,8.94a2.62,2.62,0,0,0-1.22,2c0,.72.55,1,1.22.61L150.86,211a2.62,2.62,0,0,0,1.22-2C152.08,208.21,151.53,207.93,150.86,208.32Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.86,208.32l-15.46,8.94a2.62,2.62,0,0,0-1.22,2c0,.72.55,1,1.22.61L150.86,211a2.62,2.62,0,0,0,1.22-2C152.08,208.21,151.53,207.93,150.86,208.32Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.49,220.8l-3.29,1.91a2.59,2.59,0,0,0-1.21,2c0,.73.54,1,1.21.62l3.29-1.91a2.6,2.6,0,0,0,1.22-2C165.71,220.69,165.16,220.42,164.49,220.8Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.49,220.8l-3.29,1.91a2.59,2.59,0,0,0-1.21,2c0,.73.54,1,1.21.62l3.29-1.91a2.6,2.6,0,0,0,1.22-2C165.71,220.69,165.16,220.42,164.49,220.8Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.87,216.7l-3.29,1.9a2.61,2.61,0,0,0-1.21,2c0,.73.54,1,1.21.62l3.29-1.91a2.59,2.59,0,0,0,1.21-2C161.08,216.59,160.54,216.32,159.87,216.7Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.87,216.7l-3.29,1.9a2.61,2.61,0,0,0-1.21,2c0,.73.54,1,1.21.62l3.29-1.91a2.59,2.59,0,0,0,1.21-2C161.08,216.59,160.54,216.32,159.87,216.7Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.49,226,135.4,237.6a2.62,2.62,0,0,0-1.22,2c0,.73.55,1,1.22.62l20.09-11.6a2.61,2.61,0,0,0,1.21-2C156.7,225.89,156.16,225.62,155.49,226Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.49,226,135.4,237.6a2.62,2.62,0,0,0-1.22,2c0,.73.55,1,1.22.62l20.09-11.6a2.61,2.61,0,0,0,1.21-2C156.7,225.89,156.16,225.62,155.49,226Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.86,221.91l-15.46,8.94a2.62,2.62,0,0,0-1.22,2c0,.73.55,1,1.22.62l15.46-8.94a2.62,2.62,0,0,0,1.22-2C152.08,221.79,151.53,221.52,150.86,221.91Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.86,221.91l-15.46,8.94a2.62,2.62,0,0,0-1.22,2c0,.73.55,1,1.22.62l15.46-8.94a2.62,2.62,0,0,0,1.22-2C152.08,221.79,151.53,221.52,150.86,221.91Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Image--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--image--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M282.14,211l73.65-42.53c.53-.3,1-.06,1,.55v66.73a2.09,2.09,0,0,1-1,1.65L282.14,280c-.52.3-.95.05-.95-.55V212.66A2.11,2.11,0,0,1,282.14,211Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M362.4,172.42a1.24,1.24,0,0,0-1.12.16l-72.21,41.69a3.73,3.73,0,0,0-1.67,2.91v65.19a1.22,1.22,0,0,0,.45,1.07c-.28-.18-2.82-1.62-3.13-1.8a1.2,1.2,0,0,1-.48-1.08v-65.2a3.68,3.68,0,0,1,1.68-2.9l72.21-41.71a1.18,1.18,0,0,1,1.2-.1C359.6,170.81,361.8,172.06,362.4,172.42Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.4,172.42c-.6-.36-2.8-1.61-3.07-1.77a1.18,1.18,0,0,0-1.2.1l-72.21,41.71a3.32,3.32,0,0,0-1.18,1.25l3.15,1.82a3.42,3.42,0,0,1,1.18-1.26l72.21-41.69A1.24,1.24,0,0,1,362.4,172.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M289.07,214.27l72.21-41.69c.92-.54,1.68-.11,1.68,1v65.2a3.74,3.74,0,0,1-1.68,2.91l-72.21,41.69c-.93.54-1.68.11-1.68-1v-65.2A3.72,3.72,0,0,1,289.07,214.27Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.07,214.27l72.21-41.69c.92-.54,1.68-.11,1.68,1v65.2a3.74,3.74,0,0,1-1.68,2.91l-72.21,41.69c-.93.54-1.68.11-1.68-1v-65.2A3.72,3.72,0,0,1,289.07,214.27Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M287.89,215.53l-3.15-1.82a3.36,3.36,0,0,0-.5,1.65v65.2a1.2,1.2,0,0,0,.48,1.08c.31.18,2.85,1.62,3.13,1.8a1.22,1.22,0,0,1-.45-1.07V217.18A3.31,3.31,0,0,1,287.89,215.53Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.89,215.53l-3.15-1.82a3.36,3.36,0,0,0-.5,1.65v65.2a1.2,1.2,0,0,0,.48,1.08c.31.18,2.85,1.62,3.13,1.8a1.22,1.22,0,0,1-.45-1.07V217.18A3.31,3.31,0,0,1,287.89,215.53Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.66,235.9l5.71,8-25.8-23.47-27.18,46v15.89c0,1.07.75,1.5,1.68,1l72.21-41.69a3.74,3.74,0,0,0,1.68-2.91V230l-19.24-13.84Z",
    style: {
      fill: "#fafafa",
      opacity: 0.9500000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.67,206.74c3.37-1.94,6.1-.36,6.1,3.53a13.46,13.46,0,0,1-6.1,10.55c-3.37,2-6.1.37-6.1-3.52A13.49,13.49,0,0,1,331.67,206.74Z",
    style: {
      fill: "#fafafa",
      opacity: 0.9500000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,173.12c.15,0,.15.38.15.42v65.2a2.94,2.94,0,0,1-1.29,2.24l-72.21,41.69a.68.68,0,0,1-.36.13c-.15,0-.15-.38-.15-.42v-65.2a2.94,2.94,0,0,1,1.29-2.24l72.21-41.69a.68.68,0,0,1,.36-.13m0-.77a1.47,1.47,0,0,0-.75.23l-72.21,41.69a3.72,3.72,0,0,0-1.68,2.91v65.2c0,.75.38,1.19.93,1.19a1.47,1.47,0,0,0,.75-.23l72.21-41.69a3.74,3.74,0,0,0,1.68-2.91v-65.2c0-.75-.38-1.19-.93-1.19Z",
    style: {
      fill: "#0C0C0C"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-2--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--donut-chart--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256.22,87.08l64.55-37.24c.63-.36,1.13-.07,1.13.65v83.8a2.47,2.47,0,0,1-1.13,2l-64.55,37.24c-.62.36-1.13.07-1.13-.65V89A2.51,2.51,0,0,1,256.22,87.08Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M319.17,55,259.32,89.53a2.77,2.77,0,0,0-1.25,2.16v81.62a2.73,2.73,0,0,0,1.26,2.14l2.37,1.35a2.82,2.82,0,0,0,2.5,0l59.85-34.51a2.76,2.76,0,0,0,1.24-2.16V58.51A2.72,2.72,0,0,0,324,56.36L321.67,55A2.82,2.82,0,0,0,319.17,55Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.2,176.79a2.85,2.85,0,0,1-2.5,0l-2.37-1.35a2.73,2.73,0,0,1-1.26-2.14V91.69a2.59,2.59,0,0,1,.4-1.27l4.85,2.81a2.46,2.46,0,0,0-.36,1.23v81.6C263,176.79,263.47,177.21,264.2,176.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.28,58.28c-.1-.63-.61-.85-1.23-.49L264.21,92.3a2.57,2.57,0,0,0-.89.93l-4.85-2.81a2.51,2.51,0,0,1,.85-.89L319.17,55a2.82,2.82,0,0,1,2.5,0L324,56.36A2.74,2.74,0,0,1,325.28,58.28Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M324.05,57.79,264.2,92.3A2.75,2.75,0,0,0,263,94.46v81.61c0,.79.56,1.11,1.24.72l59.85-34.51a2.76,2.76,0,0,0,1.24-2.16V58.51C325.29,57.71,324.74,57.39,324.05,57.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.3,58.79v81.33a1.77,1.77,0,0,1-.75,1.29L264,175.78V94.46a1.79,1.79,0,0,1,.75-1.3l59.6-34.37m.31-1.17a1.09,1.09,0,0,0-.56.17L264.2,92.3A2.75,2.75,0,0,0,263,94.46v81.61c0,.56.28.89.69.89a1.19,1.19,0,0,0,.55-.17l59.85-34.51a2.76,2.76,0,0,0,1.24-2.16V58.51c0-.57-.28-.89-.68-.89Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.38,96.65v8.61c-3.73,2.15-6.75,7.92-6.75,12.89l-6.46,3.73C270.17,112.15,276.08,100.86,283.38,96.65Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.53,123.3,273.88,132c-2.43-2-3.71-5.42-3.71-10.09l6.46-3.73C276.63,120.57,277.35,122.36,278.53,123.3Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.58,106.63c0,9.72-5.91,21-13.2,25.23-3.8,2.19-6.87,2.22-9.5.11l4.65-8.67c1.22,1,2.94,1,4.85,0,3.72-2.16,6.74-7.92,6.74-12.89s-3-7.25-6.74-5.1V96.65C290.67,92.44,296.58,96.91,296.58,106.63Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.58,106.63c0,9.72-5.91,21-13.2,25.23-3.8,2.19-6.87,2.22-9.5.11l4.65-8.67c1.22,1,2.94,1,4.85,0,3.72-2.16,6.74-7.92,6.74-12.89s-3-7.25-6.74-5.1V96.65C290.67,92.44,296.58,96.91,296.58,106.63Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M286.89,119.89a11.72,11.72,0,0,1-3.51,3.36c-1.91,1.1-3.63,1-4.85,0s-1.9-2.73-1.9-5.15l-6.46,3.73c0,4.67,1.28,8.13,3.71,10.09,2.63,2.11,5.7,2.08,9.5-.11a23.19,23.19,0,0,0,7-6.72Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.89,119.89a11.72,11.72,0,0,1-3.51,3.36c-1.91,1.1-3.63,1-4.85,0s-1.9-2.73-1.9-5.15l-6.46,3.73c0,4.67,1.28,8.13,3.71,10.09,2.63,2.11,5.7,2.08,9.5-.11a23.19,23.19,0,0,0,7-6.72Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.7,91.3l-3.85,2.22a.2.2,0,0,0-.08.14V98.1a.05.05,0,0,0,.08.05l3.85-2.22a.2.2,0,0,0,.08-.14V91.35A.05.05,0,0,0,304.7,91.3Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.7,91.3l-3.85,2.22a.2.2,0,0,0-.08.14V98.1a.05.05,0,0,0,.08.05l3.85-2.22a.2.2,0,0,0,.08-.14V91.35A.05.05,0,0,0,304.7,91.3Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.54,91.25a.27.27,0,0,1-.24-.14.28.28,0,0,1,.1-.39l10.78-6.19a.28.28,0,0,1,.39.1.28.28,0,0,1-.11.39l-10.78,6.19A.23.23,0,0,1,307.54,91.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.54,93.7a.27.27,0,0,1-.24-.14.28.28,0,0,1,.1-.39L318.18,87a.29.29,0,0,1,.39.1.28.28,0,0,1-.11.39l-10.78,6.19A.23.23,0,0,1,307.54,93.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.7,100.39l-3.85,2.22a.2.2,0,0,0-.08.14v4.44a.05.05,0,0,0,.08,0L304.7,105a.2.2,0,0,0,.08-.14v-4.44A.05.05,0,0,0,304.7,100.39Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.54,100.34a.27.27,0,0,1-.24-.14.28.28,0,0,1,.1-.39l10.78-6.19a.28.28,0,0,1,.39.1.28.28,0,0,1-.11.39l-10.78,6.19A.23.23,0,0,1,307.54,100.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.54,102.79a.27.27,0,0,1-.24-.14.28.28,0,0,1,.1-.39l10.78-6.19a.29.29,0,0,1,.39.1.28.28,0,0,1-.11.39l-10.78,6.19A.23.23,0,0,1,307.54,102.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.7,109.48l-3.85,2.22a.2.2,0,0,0-.08.14v4.44a.05.05,0,0,0,.08,0l3.85-2.22a.2.2,0,0,0,.08-.14v-4.44A.05.05,0,0,0,304.7,109.48Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.7,109.48l-3.85,2.22a.2.2,0,0,0-.08.14v4.44a.05.05,0,0,0,.08,0l3.85-2.22a.2.2,0,0,0,.08-.14v-4.44A.05.05,0,0,0,304.7,109.48Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.54,109.43a.26.26,0,0,1-.24-.15.27.27,0,0,1,.1-.38l10.78-6.19a.28.28,0,0,1,.39.1.28.28,0,0,1-.11.39l-10.78,6.19A.23.23,0,0,1,307.54,109.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.54,111.88a.27.27,0,0,1-.24-.14.28.28,0,0,1,.1-.39l10.78-6.19a.29.29,0,0,1,.39.1.28.28,0,0,1-.11.39l-10.78,6.19A.23.23,0,0,1,307.54,111.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.17,150.72a.27.27,0,0,1-.24-.15.29.29,0,0,1,.1-.39l48.15-27.76a.29.29,0,0,1,.39.11.29.29,0,0,1-.11.39l-48.14,27.76A.42.42,0,0,1,270.17,150.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.17,155.69a.28.28,0,0,1-.24-.14.29.29,0,0,1,.1-.39l48.15-27.76a.29.29,0,0,1,.39.1.28.28,0,0,1-.11.39l-48.14,27.76A.28.28,0,0,1,270.17,155.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.17,160.67a.27.27,0,0,1-.24-.15.29.29,0,0,1,.1-.39l48.15-27.76a.29.29,0,0,1,.28.5l-48.14,27.76A.42.42,0,0,1,270.17,160.67Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Browser--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--browser--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--donut-chart--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3,130,187.16,36.76c.62-.36,1.13-.07,1.13.66V61a2.53,2.53,0,0,1-1.13,2L25.3,156.11c-.62.36-1.13.07-1.13-.65V131.91A2.51,2.51,0,0,1,25.3,130Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M185.55,42,28.4,132.4a2.77,2.77,0,0,0-1.25,2.16v21.37a2.73,2.73,0,0,0,1.26,2.14l2.37,1.35a2.82,2.82,0,0,0,2.5,0L190.43,69a2.75,2.75,0,0,0,1.25-2.16V45.43a2.7,2.7,0,0,0-1.26-2.15l-2.37-1.35A2.79,2.79,0,0,0,185.55,42Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.28,159.41a2.85,2.85,0,0,1-2.5,0l-2.37-1.35a2.73,2.73,0,0,1-1.26-2.14V134.56a2.59,2.59,0,0,1,.4-1.27l4.85,2.81a2.46,2.46,0,0,0-.36,1.23v21.35C32,159.41,32.55,159.83,33.28,159.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.66,45.2c-.1-.63-.61-.85-1.23-.49L33.29,135.17a2.57,2.57,0,0,0-.89.93l-4.85-2.81a2.51,2.51,0,0,1,.85-.89L185.55,41.94a2.82,2.82,0,0,1,2.5,0l2.37,1.35A2.76,2.76,0,0,1,191.66,45.2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M190.43,44.71,33.28,135.17A2.73,2.73,0,0,0,32,137.33v21.36c0,.79.55,1.11,1.24.72L190.43,69a2.75,2.75,0,0,0,1.25-2.16V45.43C191.68,44.63,191.12,44.31,190.43,44.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.68,45.72V66.79a1.79,1.79,0,0,1-.75,1.3L33,158.4V137.33a1.79,1.79,0,0,1,.75-1.3l156.9-90.31m.31-1.18a1.09,1.09,0,0,0-.56.17L33.28,135.17A2.73,2.73,0,0,0,32,137.33v21.36c0,.56.28.89.69.89a1.19,1.19,0,0,0,.55-.17L190.43,69a2.75,2.75,0,0,0,1.25-2.16V45.43c0-.57-.28-.89-.69-.89Z",
    style: {
      fill: "#0C0C0C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.26,133.3c-2.76,1.59-5,5.88-5,9.55a5.67,5.67,0,0,0,.74,3l-2.3,4.39c-.46.88-.46,1.87,0,2.22a.74.74,0,0,0,.83,0,2.36,2.36,0,0,0,.83-.94l2.3-4.39a3.55,3.55,0,0,0,2.6-.52c2.76-1.59,5-5.88,5-9.55S47,131.71,44.26,133.3Zm0,10.19c-1.46.85-2.65-.05-2.65-2a6.37,6.37,0,0,1,2.65-5.06c1.46-.84,2.65.06,2.65,2A6.34,6.34,0,0,1,44.26,143.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.24,110.06l-50.8,29.33c-2.66,1.53-4.82-.1-4.82-3.65h0c0-3.54,2.16-7.66,4.82-9.2l50.8-29.33c2.66-1.54,4.81.1,4.81,3.64h0C114.05,104.4,111.9,108.52,109.24,110.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.82,68l-59.65,34.36c-2.66,1.54-4.82-.09-4.82-3.64h0c0-3.55,2.16-7.67,4.82-9.2l59.65-34.36c2.66-1.54,4.82.09,4.82,3.64h0C186.64,62.3,184.48,66.42,181.82,68Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-1--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Computer--inject-73"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "176.26 443.36 172.35 441.11 172.35 373.17 176.26 375.43 176.26 443.36",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.62 326.07 257.71 323.81 172.35 373.17 176.26 375.43 261.62 326.07",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.62 394 176.26 443.36 176.26 375.43 261.62 326.07 261.62 394",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.26 375.43 172.36 373.18 172.37 264.97 176.27 267.23 176.26 375.43",
    style: {
      fill: "#0C0C0C",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.27 267.23 261.67 217.87 257.77 215.62 172.37 264.97 176.27 267.23",
    style: {
      fill: "#0C0C0C",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.67 217.87 261.67 326.07 176.26 375.43 176.27 267.23 261.67 217.87",
    style: {
      fill: "#0C0C0C",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.67 217.87 261.67 326.07 176.26 375.43 176.27 267.23 261.67 217.87",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ultrasound--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.21,340.85a1.11,1.11,0,0,0-.64-.89l-16.95-9.78a3.39,3.39,0,0,0-3.07,0L199,354.67a1.09,1.09,0,0,0-.63.89v86.35a1.08,1.08,0,0,0,.64.89L216,452.58a3.41,3.41,0,0,0,3.08,0l42.54-24.42a1.13,1.13,0,0,0,.64-.89Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,366.16,199,356.44a.93.93,0,0,1,0-1.77l42.54-24.49a3.39,3.39,0,0,1,3.07,0L261.57,340a.94.94,0,0,1,0,1.78L219,366.16A3.41,3.41,0,0,1,216,366.16Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.39,366.53v86.41a3.07,3.07,0,0,1-1.44-.36L199,442.8a1.08,1.08,0,0,1-.64-.89V355.55a1.08,1.08,0,0,0,.64.89L216,366.17A3.19,3.19,0,0,0,217.39,366.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.62,341.1a1.09,1.09,0,0,0-.63-.89l-25.28-14.64a3.39,3.39,0,0,0-3.07,0l-58.94,34a1.08,1.08,0,0,0-.64.89v2.76a1.07,1.07,0,0,0,.64.89L215,378.73a3.41,3.41,0,0,0,3.08,0l59-33.91a1.09,1.09,0,0,0,.63-.89C277.63,343.61,277.62,341.42,277.62,341.1Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,375.9,189.7,361.33a.94.94,0,0,1,0-1.78l58.94-34a3.39,3.39,0,0,1,3.07,0L277,340.21a.94.94,0,0,1,0,1.78L218,375.9A3.41,3.41,0,0,1,215,375.9Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,375.9,189.7,361.33a.94.94,0,0,1,0-1.78l58.94-34a3.39,3.39,0,0,1,3.07,0L277,340.21a.94.94,0,0,1,0,1.78L218,375.9A3.41,3.41,0,0,1,215,375.9Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.4,376.27v2.82a3.07,3.07,0,0,1-1.44-.36L189.7,364.09a1.08,1.08,0,0,1-.63-.88v-2.77a1.08,1.08,0,0,0,.63.88L215,375.9A3.2,3.2,0,0,0,216.4,376.27Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.4,376.27v2.82a3.07,3.07,0,0,1-1.44-.36L189.7,364.09a1.08,1.08,0,0,1-.63-.88v-2.77a1.08,1.08,0,0,0,.63.88L215,375.9A3.2,3.2,0,0,0,216.4,376.27Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Keyboard--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--keyboard--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.22,341.6a.61.61,0,0,0-.36-.5l-14.4-8.32a1.93,1.93,0,0,0-1.72,0l-44,25.39a.61.61,0,0,0-.36.49v1.52a.6.6,0,0,0,.36.49l14.4,8.32a1.93,1.93,0,0,0,1.72,0l44-25.35a.6.6,0,0,0,.36-.49Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.22,341.6a.61.61,0,0,0-.36-.5l-14.4-8.32a1.93,1.93,0,0,0-1.72,0l-44,25.39a.61.61,0,0,0-.36.49v1.52a.6.6,0,0,0,.36.49l14.4,8.32a1.93,1.93,0,0,0,1.72,0l44-25.35a.6.6,0,0,0,.36-.49Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.16,367.44l-14.4-8.28a.52.52,0,0,1,0-1l44-25.39a1.93,1.93,0,0,1,1.72,0l14.4,8.32a.52.52,0,0,1,0,1l-44,25.35A1.93,1.93,0,0,1,218.16,367.44Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.16,367.44l-14.4-8.28a.52.52,0,0,1,0-1l44-25.39a1.93,1.93,0,0,1,1.72,0l14.4,8.32a.52.52,0,0,1,0,1l-44,25.35A1.93,1.93,0,0,1,218.16,367.44Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,367.64v1.55a1.9,1.9,0,0,1-.81-.2l-14.4-8.32a.61.61,0,0,1-.35-.49v-1.52a.62.62,0,0,0,.35.5l14.4,8.28A1.65,1.65,0,0,0,219,367.64Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.15,366.11h0l-1.43-.83,1.94-1.11,1.47.83-1.93,1.11Zm-2.23-1.29h0l-1.42-.82,1.52-.88,1.47.83-1.52.87Zm4.93-.27h0l-1.43-.83,1.52-.87,1.48.83-1.52.87Zm-7.17-1h0l-1.42-.82,2.45-1.42,1.48.83-2.46,1.41Zm4.52,0h0l-1.42-.82,1.2-.7,1.48.83-1.21.69Zm4.94-.27h0l-1.43-.83,1.52-.87,1.47.83-1.51.87Zm-3-.87h0l-1.43-.83,1.21-.69,1.47.83-1.2.69Zm-8.73-.11h0l-1.43-.82,1.94-1.12,1.47.83-1.93,1.12Zm14-.34h0l-1.42-.83,11-6.34,1.48.83-11,6.34Zm-8.51-.23h0l-1.42-.82,1.21-.7,1.47.83-1.21.69Zm5.24-.46h0l-1.42-.83,1.2-.69,1.48.83-1.21.69ZM210.22,361h0l-1.43-.82,1.21-.7,1.47.83-1.2.7Zm4.93-.27h0l-1.42-.82,1.2-.7,1.48.83-1.21.7Zm4.73-.16h0l-1.43-.82,1.21-.7,1.48.83-1.21.69Zm5.25-.45h0l-1.43-.83,1.21-.69,1.47.83-1.2.69Zm-12.93-.26h0l-1.42-.82,1.2-.7,1.48.83-1.21.7Zm4.93-.27h0l-1.43-.82,1.21-.7,1.47.83-1.2.69Zm4.73-.15h0l-1.43-.82,1.21-.7,1.47.83-1.21.69Zm-14.35,0h0l-1.43-.83,1.52-.87,1.48.83-1.52.87Zm19.59-.45h0l-1.43-.83,1.21-.69,1.48.83-1.21.69Zm-12.93-.26h0l-1.43-.82,1.21-.7,1.47.83-1.2.7Zm4.94-.27h0l-1.42-.82,1.2-.7,1.48.83-1.21.69Zm4.72-.16h0l-1.43-.82,1.21-.7,1.48.83-1.21.69Zm5.25-.45h0l-1.43-.83,1.21-.69,1.47.83-1.2.69Zm-18.42-.22h0l-1.43-.82,1.21-.7,1.47.83-1.21.7Zm5.49,0h0l-1.42-.82,1.2-.7,1.48.83-1.21.7Zm4.93-.27h0l-1.43-.82,1.21-.7,1.47.83-1.2.69Zm4.73-.16h0l-1.42-.82,1.21-.7,1.47.83-1.21.69Zm5.24-.45h0l-1.43-.83,1.21-.69,1.48.83-1.21.69Zm-18.42-.22h0l-1.43-.82,1.21-.7,1.48.83-1.21.7Zm5.49,0h0l-1.43-.82,1.21-.7,1.47.83-1.2.7Zm4.94-.27h0l-1.42-.82,1.2-.7,1.48.83-1.21.69Zm4.72-.16h0l-1.43-.83,1.21-.69,1.48.83-1.21.69Zm5.25-.45h0l-1.43-.83,1.21-.69,1.47.82-1.2.7Zm-18.42-.22h0l-1.42-.82,1.21-.7,1.47.83-1.21.7Zm5.48,0h0l-1.42-.82,1.2-.7,1.48.83-1.21.7Zm18.08-.13h0l-1.43-.82,1.52-.87,1.48.82-1.52.88ZM225,355h0l-1.43-.82,1.21-.7,1.47.83-1.2.69Zm4.73-.16h0L228.3,354l1.21-.69,1.47.83-1.21.69Zm5.24-.45h0l-1.43-.83,1.21-.69,1.48.83-1.21.69Zm-18.42-.22h0l-1.43-.82,1.21-.7,1.48.83-1.21.7Zm5.49,0h0l-1.43-.82,1.21-.7,1.47.83-1.2.69Zm4.93-.27h0l-1.42-.82,1.2-.7,1.48.83-1.21.69Zm13.46,0h0L239,353l1.52-.88,1.47.83-1.51.88Zm-8.73-.12h0l-1.43-.83,1.21-.69L233,353l-1.2.69Zm5.25-.45h0l-1.42-.83,1.21-.69,1.47.82-1.2.7ZM224,353h0l-1.42-.82,1.2-.7,1.48.83-1.21.69Zm4.94-.28h0l-1.43-.82,1.21-.7,1.47.83-1.2.69Zm4.73-.15h0l-1.42-.83,1.21-.69,1.47.83-1.21.69Zm-14.29,0h0l-1.42-.82,1.21-.7,1.47.83-1.21.7Zm23.32,0h0l-1.42-.82,1.52-.88,1.47.83-1.52.88ZM239,352.1h0l-1.43-.83,1.21-.69,1.48.82-1.21.7ZM226,351.84h0l-1.43-.82,1.21-.7,1.47.83-1.2.69Zm4.93-.28h0l-1.42-.82,1.2-.7,1.48.83-1.21.69Zm4.73-.15h0l-1.43-.83,1.21-.69,1.47.83-1.2.69Zm-14.29,0h0l-1.43-.82,1.21-.7,1.47.83-1.2.7Zm23.64-.21h0l-1.43-.82,1.94-1.12,1.47.83-1.93,1.12Zm-4.1-.21h0l-1.43-.83,3.81-2.2,1.47.83L241,351ZM228,350.7h0l-1.42-.82,1.2-.7,1.48.83-1.21.69Zm4.94-.28h0l-1.43-.82,1.21-.7,1.47.83-1.2.69Zm4.73-.15h0l-1.42-.83,1.21-.69,1.47.83-1.21.69Zm-14.29,0h0l-1.42-.82,1.2-.7,1.48.83-1.21.7Zm6.6-.68h0l-1.43-.82,1.21-.7,1.47.83-1.2.69Zm18.18-.19h0l-1.43-.82,1.21-.7,1.47.83-1.2.7Zm-13.25-.09h0l-1.42-.83,1.2-.69,1.48.83-1.21.69Zm4.73-.15h0l-1.43-.83,1.11-.63a.25.25,0,0,0,.12-.2.23.23,0,0,0-.13-.21l-1.87-1.09,1.41-.81,3.71,2.11-2.87,1.66Zm-14.29,0s0,0,0,0l-1.43-.82,1.21-.7,1.47.83-1.2.7Zm6.6-.68h0l-1.42-.82,1.2-.7,1.48.83-1.21.69Zm18.18-.19h0l-1.42-.82,1.2-.7,1.48.83-1.21.7Zm-13.24-.09h0l-1.43-.83,1.21-.69,1.47.83-1.2.69Zm-8.7-.68h0l-1.42-.83,1.2-.69,1.48.83-1.21.69Zm5.74-.18h0l-1.43-.82,1.21-.7,1.47.83-1.2.69Zm18.18-.19h0l-1.43-.82,1.21-.7,1.47.83-1.2.7Zm-4.21-.15h0l-1.43-.82,1.21-.7,1.48.83-1.21.7Zm-17.74-.62h0l-1.43-.83,1.21-.69,1.47.83-1.2.69Zm5.74-.18h0l-1.42-.82,2.14-1.24,1.47.83-2.14,1.23Zm18.6-.43h0l-1.43-.82,3.18-1.84,1.48.83-3.18,1.84Zm-13-.21h0l-1.43-.83,1.21-.69,1.48.83-1.21.69Zm-9.32-.32h0l-1.42-.83,1.2-.69,1.48.83-1.21.69Zm20.13-.76h0l-1.43-.82,1.21-.7,1.47.83-1.2.7Zm-8.83-.06h0l-1.43-.83,1.21-.69,1.47.83-1.2.69Zm-4.21-.15h0l-1.43-.82,1.21-.7,1.47.83-1.2.69ZM234.1,344h0l-1.43-.83,1.21-.69,1.47.83-1.2.69Zm24.34-.61h0L257,342.6l1.21-.7,1.47.83-1.2.7Zm-4.21-.15h0l-1.43-.82,1.21-.7,1.48.83-1.21.7Zm-8.83-.06h0l-1.43-.83,1.21-.69,1.48.83-1.21.69Zm4.63-.09h0l-1.42-.83,1.2-.69,1.48.82-1.21.7Zm-8.83-.06h0l-1.42-.82,1.2-.7,1.48.83-1.21.69Zm-4.69-.42h0l-1.43-.82,1.21-.7,1.48.83-1.21.7Zm23.91-.36h0l-3.66-2.11,1.21-.7,3.71,2.12-1.21.7Zm-4.21-.15h0l-1.42-.82,1.21-.7,1.47.83-1.2.7ZM252,342h0l-1.43-.82,1.21-.69,1.47.82-1.2.7Zm-8.83-.06h0l-1.43-.83,1.21-.69,1.47.83-1.2.69Zm4.62-.09h0l-1.42-.83,1.2-.69,1.48.83-1.21.69Zm-9.3-.33h0l-1.42-.82,1.21-.7,1.47.83-1.2.7Zm15.49-.66h0l-1.42-.82,1.2-.7,1.48.83-1.21.7Zm-4.21-.15h0l-1.43-.83,1.21-.69L251,340l-1.2.69Zm-4.21-.15h0l-1.43-.82,1.21-.7,1.47.83-1.2.69Zm-5.1-.18h0l-1.43-.82,1.21-.7,1.47.83-1.2.7Zm15.49-.66h0l-3.66-2.11,1.21-.69,3.7,2.11-1.2.7Zm-4.21-.15h0l-1.43-.83,1.21-.69,1.48.83-1.21.69Zm-4.2-.15h0l-1.43-.83,1.21-.69,1.47.83-1.21.69Zm-5.26-.75h0l-.62-.35,1.2-.69.67.35-1.2.7Zm7.23-.39h0l-1.43-.83,1.21-.69,1.47.83-1.2.69Zm-5.26-.75h0l-.62-.35,1.21-.69.66.35-1.2.7Zm7.24-.39h0L250,336.3l1.21-.69,1.47.83-1.21.69Zm-5.26-.75h0l-.62-.35,1.2-.69.67.35-1.2.7Zm2-1.14h0l-.62-.35,1.21-.69.66.35-1.2.7Z",
    style: {
      fill: "#fafafa"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bar-graph--inject-73"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "237.47 318.19 237.47 270.37 233.2 267.9 233.2 315.73 237.47 318.19",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.47 318.19 237.47 270.37 233.2 267.9 233.2 315.73 237.47 318.19",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.47 318.19 249.85 311.04 249.85 263.22 237.47 270.37 237.47 318.19",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.85 263.22 245.59 260.75 233.2 267.9 237.47 270.37 249.85 263.22",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.85 263.22 245.59 260.75 233.2 267.9 237.47 270.37 249.85 263.22",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86,263.22l-12.39,7-4.27-2.28,4.1,2.74c-.1,1.39,0,46.13.17,47.55.18-1.42.26-46.25.17-47.6Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.25 331.6 214.25 293.19 209.98 290.72 209.98 329.13 214.25 331.6",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.25 331.6 214.25 293.19 209.98 290.72 209.98 329.13 214.25 331.6",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.25 331.6 226.63 324.45 226.63 286.04 214.25 293.19 214.25 331.6",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.25 331.6 226.63 324.45 226.63 286.04 214.25 293.19 214.25 331.6",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.63 286.04 222.37 283.57 209.98 290.72 214.25 293.19 226.63 286.04",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.63 286.04 222.37 283.57 209.98 290.72 214.25 293.19 226.63 286.04",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.41,293.28,226.63,286l-12.38,7c-1.35-.76-4.27-2.28-4.27-2.28s2.73,1.75,4.11,2.55c-.05,1.45.06,36.85.16,38.33C214.34,330.12,214.45,294.68,214.41,293.28Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.03 345 191.03 312.76 186.76 310.3 186.76 342.54 191.03 345",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.03 345 191.03 312.76 186.76 310.3 186.76 342.54 191.03 345",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.03 345 203.41 337.85 203.41 305.61 191.03 312.76 191.03 345",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.03 345 203.41 337.85 203.41 305.61 191.03 312.76 191.03 345",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.41 305.61 199.15 303.15 186.76 310.3 191.03 312.76 203.41 305.61",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.41 305.61 199.15 303.15 186.76 310.3 191.03 312.76 203.41 305.61",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.41,305.61l-12.38,7-4.27-2.28,4.1,2.67s0,31.16.17,32c.18-.87.18-32,.18-32Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrow--inject-73"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "248.01 236.38 246.92 235.74 237.41 239.16 239.51 241.12 212.61 269.85 207.01 264.56 205.91 263.92 184.92 286.34 187.44 288.7 188.53 289.34 206.81 269.82 212.03 274.61 213.67 275.57 242.91 244.35 244.13 245.45 245.22 246.09 248.01 236.38",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.01 236.38 246.92 235.74 237.41 239.16 239.51 241.12 212.61 269.85 207.01 264.56 205.91 263.92 184.92 286.34 187.44 288.7 188.53 289.34 206.81 269.82 212.03 274.61 213.67 275.57 242.91 244.35 244.13 245.45 245.22 246.09 248.01 236.38",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.01 236.38 245.22 246.09 243.12 244.12 213.67 275.57 207.17 269.44 188.53 289.34 186.01 286.98 207.01 264.56 213.51 270.69 240.6 241.76 238.51 239.8 248.01 236.38",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.17 269.44 206.81 269.82 212.03 274.61 213.67 275.57 207.17 269.44",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.17 269.44 206.81 269.82 212.03 274.61 213.67 275.57 207.17 269.44",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.51 241.12 240.6 241.76 238.51 239.8 237.41 239.16 239.51 241.12",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.51 241.12 240.6 241.76 238.51 239.8 237.41 239.16 239.51 241.12",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.91 244.35 243.12 244.12 245.22 246.09 244.13 245.45 242.91 244.35",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.91 244.35 243.12 244.12 245.22 246.09 244.13 245.45 242.91 244.35",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.92 286.34 186.01 286.98 188.53 289.34 187.44 288.7 184.92 286.34",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.92 286.34 186.01 286.98 188.53 289.34 187.44 288.7 184.92 286.34",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.93 279.59 207.01 265.02 213.51 270.69 207.01 264.56 192.93 279.59",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.93 257.44 240.92 241.76 238.9 239.9 248.01 236.38 238.51 239.8 240.6 241.76 225.93 257.44",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.91,420.35c-.48-.1-.58,1.35-.48,2s1.85,2.93,5.28,4.05,8.36,1,10.45,1.14,5.16,1.5,7.17,2.15c4.66,1.52,7.52.09,8.88-.95a2.12,2.12,0,0,0,.7-1.66c.11-1.38,0-1.68-.14-1.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.62,420.89a26,26,0,0,1,.44,2.94c.11,1.19.17,2.71-.72,3.55a6.62,6.62,0,0,1-4.93,1.65,14.62,14.62,0,0,1-6-1.33,13.44,13.44,0,0,0-5.13-1.57,52,52,0,0,1-7.28-.53,17.5,17.5,0,0,1-5.2-1.73,6.7,6.7,0,0,1-2.89-3.26,4.89,4.89,0,0,1,3.28-4.52,11,11,0,0,1,5.53-.51c2,.25,3.53.7,5.34.78a8.83,8.83,0,0,0,3.68-.44,3.53,3.53,0,0,0,1.31-1.47c.37-.61.54-1.16,1.12-1.16,0,0,9.5,1.06,10.36,1.21s.7,1.48.66,2.19,0,.63,0,1.25a8.46,8.46,0,0,0,.29,2.06C330.49,420.3,330.56,420.59,330.62,420.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.51,415.83a1.19,1.19,0,0,0-.42-.21c-.81-.22-1.53.51-2,1.11a5,5,0,0,0-.57,1.18,2.85,2.85,0,0,0-.22,1.6c0,.14.11.31.25.29s.18-.17.21-.29a6.15,6.15,0,0,1,.87-2.1,2.6,2.6,0,0,1,.59-.73,2.56,2.56,0,0,1,.88-.42c.13,0,.68,0,.58-.22a.29.29,0,0,0-.1-.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.89,416.11a1.52,1.52,0,0,0-1.12.18,2.29,2.29,0,0,0-.78,1,3.41,3.41,0,0,0-.38,2.76c.12.27.36.16.47-.05a3.4,3.4,0,0,0,.2-.85,7.56,7.56,0,0,1,.72-1.77,3.29,3.29,0,0,1,.42-.63,1.31,1.31,0,0,1,.4-.3,1.09,1.09,0,0,1,.24-.07h.23c0-.11-.11-.2-.22-.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.37,415.7a1.51,1.51,0,0,0-.75.39,2.15,2.15,0,0,0-.41.7,7.71,7.71,0,0,0-.54,1.77,2.3,2.3,0,0,0,.17,1.27c.07.16.22.32.39.27s.19-.33.22-.49.07-.58.11-.87a5.15,5.15,0,0,1,1.32-2.86s.08-.08.07-.14-.12-.09-.2-.09A2.47,2.47,0,0,0,316.37,415.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,415.77c-.83-.11-2.73.83-3.88,3.31a14.77,14.77,0,0,0-1,5.78,8.31,8.31,0,0,1-4.41-2.73,5.12,5.12,0,0,1-1-1.61,5.18,5.18,0,0,1,1.31-3.83c1.39-1.32,3.38-2.06,6.37-1.88,3.35.2,3.53,1.12,3.53,1.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.54,399.85s-1.83,13.23-2.1,15.95c-.12,1.16-2.68,2.43-6.22,2.08-2.49-.25-4-1.75-4.26-3S318,398,318,398Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.45,400.52l-4-12.78L352.5,390s7.28,13.78,8.23,15C362.29,407.06,368.45,400.52,368.45,400.52Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.12,404.3a9.77,9.77,0,0,1-.17,3.57c-.16,1.19-.33,2.35-.42,3.54a14.21,14.21,0,0,1-.3,2.16,13.23,13.23,0,0,0-.1,2.6c0,.9,0,1.81-.05,2.72a4.58,4.58,0,0,0,0,1.17c.09.38-5.76,3.73-8.13,5l-.42.2a3.73,3.73,0,0,1-3.84-.9,6.51,6.51,0,0,1,1.59-7.17s.3,0,.24-2.3c0-1.64,0-3.32-.17-4.95a10.77,10.77,0,0,0-.78-3,7.29,7.29,0,0,1-1-2.78,4.17,4.17,0,0,1,.92-1.93,9.88,9.88,0,0,1,4.29-3.39c.87-.39,2.28-.81,3.17-.27.49.29.71.86,1.06,1.3a6.68,6.68,0,0,0,1.53,1.27A6,6,0,0,1,373,404,2.29,2.29,0,0,1,373.12,404.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.28,417.22a7.73,7.73,0,0,0-.76,1.1h0a8.26,8.26,0,0,0-.82,6.07c-4.14-.37-5.22-2.76-5.22-2.76a4,4,0,0,1,2.15-3.57,6.47,6.47,0,0,1,.9-.47l0,0A6,6,0,0,1,361.28,417.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.08,404.94c1.09.42.81,3.41.12,6.29s-1.06,3.87-.71,6.27.55,3.46-.42,4.34-8.74,4.5-8.74,4.5a28.68,28.68,0,0,0,1.74-9c.2-5.3.56-8.71,3-11.12A4.66,4.66,0,0,1,374.08,404.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.46,421.62a14.45,14.45,0,0,0,6.48,2.83c3.46.39,3.63-.94,4-5s.5-9.77,2.12-12.27,4.33-3.61,5.4-3.35c.22-.12,1.28.68,1.62,1.15a5.93,5.93,0,0,0-4.53,1.82c-2.16,2.11-2.55,6.58-2.65,10.63s-.28,8.76-3.51,9.25a11.71,11.71,0,0,1-8.8-2.68A1.64,1.64,0,0,1,354.46,421.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.53,415.71a1.14,1.14,0,0,0-.48.75,2.31,2.31,0,0,0,1.17,2.13c.44.25.81.15.11-.71A4.44,4.44,0,0,1,361.53,415.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.46,412.85a1,1,0,0,0-.29.62,3.56,3.56,0,0,0,1.42,2.24c.76.34.35-.5,0-.89A15.27,15.27,0,0,1,361.46,412.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.27,409.71a.7.7,0,0,0-.36.51c0,.33,1.54,1.5,2,1.46s.61-.2,0-.61A21.11,21.11,0,0,1,361.27,409.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.45,399.91s-9.18-16.7-14.67-28c-1.89-3.87-2.74-5.54-3.32-8.52s-2.82-11.16-2.82-11.16l-3,17.34a58.06,58.06,0,0,1,1.37,9.61c.18,3.64-.4,7.88-1.7,15.82-1.87,11.45-2.69,14.26-2.69,14.26-.82.62-2.92.75-5,.84-4.89.23-7.24-2.06-7.24-2.06s-1.29-20.16-1.73-24.79c-1.51-15.8-1.61-22.49-1.25-40.92.31-15.71,2-34.61,2-34.61l34.93-8.38s6.43,11.23,5.78,22.23c-.71,12-1.09,38.31-1.09,38.31,1.89,3.08,3.57,6.23,5.35,13.8,1,4.43,3.07,14,4.51,21A10.65,10.65,0,0,0,357.45,399.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.64,352.27l4.45-24.57s4.78-.56,11.08-6.09c0,0-.43,4.31-8.8,8l-4.79,21.83.88,12Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-73"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "328.98 255.97 330.25 269.68 341.83 268.86 339.93 253.62 328.98 255.97",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,241.79s-3.26,3.87-3,4.3a7.73,7.73,0,0,0,2.26,1Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.58,230.45c-2.53,1.06-6.91,3-8.7,11.89-1.84,9.09-.91,12.39.24,13.7.78.88,6.77,1.86,8.51,1.54,2.94-.53,9.11-3.7,12.38-8.21,3.84-5.3,5.14-12.67,1.45-15.89C339.27,228.94,332.72,229.55,330.58,230.45Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.14,257.71l-.14-1.43a11.41,11.41,0,0,1-3.72.1,8.18,8.18,0,0,1-3.49-.79,4.38,4.38,0,0,0,.33.45C322.78,256.78,326.74,257.66,329.14,257.71Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.87,258.27A8.47,8.47,0,0,1,331.6,256c-1-1.09-2.23-5.36-2-6.46.05,0,1.46,1.36,3.82-.37s2.94-5.5.19-6.67c-2-.84-3.59.55-4.6,2.06-.16.24-.37.51-.66.54-.45,0-.71-.5-.82-.94a3.67,3.67,0,0,0-.51-1.48,3.87,3.87,0,0,1-.85-2.51,8.81,8.81,0,0,1,.51-2.26,7.74,7.74,0,0,0-2.49,2.69,4.82,4.82,0,0,1,.64-4.29,8.31,8.31,0,0,0-2.49,3.6,4.38,4.38,0,0,1-1-2.92A9.48,9.48,0,0,1,325,229.7a16.43,16.43,0,0,1,7.65-3.23,21.9,21.9,0,0,1,8.07.15c5.65,1.12,8.36,4.31,9.1,5.46a8.39,8.39,0,0,1,.91,4.07c3.19,2.2,2.7,6.5,1.48,9.66-1.06,2.77-3.33,5.1-5.49,7.08-1.12,1-2.28,2-3.37,3.1a15.41,15.41,0,0,0-1.51,1.62c-.68.91-1.18,1.7-1.18,1.7A17.88,17.88,0,0,1,334.87,258.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,262.26c4.85-.57,8.34,1.13,11.77,7.69,3.24,6.2,7.81,15.17,9.57,19.71.86,2.22,2.29,4.17-1.66,8.45a67,67,0,0,1-12.32,10.15l-4.88-8.81,5.41-7.17-2.57-5.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.86,292.28a11.78,11.78,0,0,0,5,3.39c-1.84.58-5.12-1.09-5.83-2.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.9,267.35c-.9-3.5-2.06-5.78-8.69-5.48l-.92,0c-2.36.34-5.67.54-11.73,1-.76.14-8,1.38-9.21,1.54,0,0-5.42,3.23-8.11,14.66-.76,3.24-.38,6.65,3.62,9.75-.1,3.29.63,6.14.22,9.3a134,134,0,0,0-1.28,15.48s8.27,4.07,22,2.74c8.43-.81,16.46-5.48,18.05-7a87.32,87.32,0,0,0-5.87-14.24C352.27,283.8,356,279.33,352.9,267.35Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296,281.7a63.81,63.81,0,0,1-5.27-4.79,4.59,4.59,0,0,1-.63-2.64c-.06-2.45-1.31-4.26-2-6.55-.18-.57-.47-1.59-1.11-1.47a1.35,1.35,0,0,0-.78.39,2,2,0,0,0-.41.8,4.27,4.27,0,0,0,.1,2.1c.07.27.67,1.62.35,1.81-.11.06-.26,0-.37-.08a12.17,12.17,0,0,1-1.61-1.25c-.49-.45-1-1-1.49-1.46a23.53,23.53,0,0,1-3-3.64c-.82-1-1.45-1.21-2.06-.87s.15,1.8.15,1.8a6.63,6.63,0,0,0-1.64-1.73c-.86-.41-1.82-.24-1.76.49a7.08,7.08,0,0,0,.23.87,1.74,1.74,0,0,0-.49,2.51s-1.05.18-.16,2.45a23.17,23.17,0,0,0,7.85,10.17,22.76,22.76,0,0,1,4.11,3.86c3.29,3.79,6.58,7.75,10,11.55Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.88,265.93a14.9,14.9,0,0,0,3.89,5.61C280.38,269.72,279.09,267.87,277.88,265.93Zm-3.2-.45c1.2,3.14,2.9,6.3,5.58,8.41A35.26,35.26,0,0,1,274.68,265.48Zm3.53,9.13a30.25,30.25,0,0,1-4-6.62A13.7,13.7,0,0,0,278.21,274.61Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.35,264.44c-4.36.72-7.44,4.52-8.68,6.23-4,5.51-11.09,14.63-11.09,14.63l-8.32-5.4s-1.41.22-3.24,2.8-1.56,6.42-1.56,6.42,6.23,6.88,7.47,8.11c5.68,5.65,8.78,3.81,10.55,2.38,5.65-4.6,13.49-14.63,15-16.2C325.42,280.37,326.51,269.38,322.35,264.44Z",
    style: {
      fill: "#37474f"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-73"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "409.29 268.63 406.97 267.64 409.17 266.88 409.29 268.63",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.08,274.09s26-13.64,26.46-11.84a2.91,2.91,0,0,1,0,1.09l.06-.11-.3,3.41a7.94,7.94,0,0,1-4.06,2c0-.17-.08-1.17-.12-1.75a14.3,14.3,0,0,0-2.29,1.39c-1.65,1.24-2.64,3.3-4.32,5.72-1.23,1.76-3.55,2.68-7,3.38-3.73.75-7.09.21-8.08-.76A2.7,2.7,0,0,1,387.08,274.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.77,273.28a33.62,33.62,0,0,1,2.36-2.62,48.11,48.11,0,0,1,3.67-3.52,34.51,34.51,0,0,0,3.06-3.35,29.82,29.82,0,0,0,3.28-5.5c.37-1,.63-2.06.41-5.53-.31-4.84-.5-5.93-.73-9.62l13.49-.9c-.26,2.07-.83,5-1.11,7.76-.37,3.53-1.51,3.93.06,7.38a10.65,10.65,0,0,1,1.24,3.09c.18,1.8-1.14,3.45-2.67,4.42-1.27.81-2.76,1.21-4,2.06a13.32,13.32,0,0,0-3.14,3.47c-.84,1.21-1.48,2.62-2.7,3.5a11.43,11.43,0,0,1-4.26,1.76,22.93,22.93,0,0,1-5.83.63C388.13,276.25,386,275.35,387.77,273.28Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.9,267.3a5,5,0,0,0-4.17-.14c-1.88,1.68-3.43,3.16-4.53,4.2-1.33,1.26-2.49,2.41-2.36,3.76.2,2.12,8.44,2.3,12.91,0a5.71,5.71,0,0,0,3.08-3S402,269.17,397.9,267.3Zm15.16-8.51c-.78-1.33-1.09-2-1.09-2a8.46,8.46,0,0,0-2.59,9.08,6.11,6.11,0,0,0,3.87-3A3.87,3.87,0,0,0,413.06,258.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.91,260c-.68,1.22.63,7.2.7,10.3.06,2.81.07,7.86,1.22,10.53,1.36,3.18,3.89,6.77,7.79,3.3,2.41-2.14,3.69-4.75,3.71-8.81,0-2.82-1.49-6.58-2.8-9.92-1.52-3.9-2.15-6-2.15-6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.14,240.4c.82,6.5.83,10.22,1.12,14.41a53.65,53.65,0,0,0,1,6.5c.57,2.67,1.71,6.25,2.27,7.94.78,2.36,1.35,3.85.67,6.64a2.65,2.65,0,0,1-.25.64c-1.07,2.35-4.12,4.35-5.17,4.17a1.85,1.85,0,0,1-1.74.76,2.11,2.11,0,0,1-.35,0,2.25,2.25,0,0,1-.35-.09,3.27,3.27,0,0,1-1.86-1.89,4.37,4.37,0,0,1-.21-.58,21.84,21.84,0,0,1-1-6.77c-.05-1.53-.28-4.19-.62-6.62s-2.18-9.1-3.19-12.76c-.83-3-2.46-9.23-2.46-9.23Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.42,272.34c-2.59-.79-10.08-.11-11,3.3.22,3.11.56,5.09,2.88,7.59,3.09,3.33,6.45-.83,7.66-3.38A11.81,11.81,0,0,0,447.42,272.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.88,154.47c2.62,6.4,5.1,13.44,5.51,27,.54,17.86,1.37,24.32,1.55,26.46.3,3.67,1.87,7,3.58,17.53s.8,29.86.8,29.86a12.63,12.63,0,0,1-6.52,3c-3.72.55-5.35-.91-5.35-.91s-7.08-28.5-8.86-34.8-7.09-27-7.09-27L414.39,213s2.11,5.5,1.5,14.85S412,254.75,412,254.75s-2,1.51-6,1.31-5.62-1.59-5.62-1.59-3.61-34.73-4.21-45.26-2.07-38.24,1.77-54.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.79,171.55c1.83,4.26,7.79,7,10.36,7.44l3.93,16.44L414.39,213l2.11-17.44L412,175.52S404.94,175.42,400.79,171.55Zm26-5c.34,1.73.64,3.47,1,5.21s.64,3.48,1,5.23a34.1,34.1,0,0,0-.11-5.35c-.15-1.78-.4-3.54-.72-5.3a48.57,48.57,0,0,0-1.29-5.19,25.19,25.19,0,0,0-2.07-4.94c.45,1.73.85,3.44,1.22,5.16S426.51,164.8,426.83,166.53Zm3-4.18c.51,1.07,1,2.15,1.48,3.22l1.42,3.29a14.5,14.5,0,0,0-.6-3.58,22.82,22.82,0,0,0-1.28-3.4,25.88,25.88,0,0,0-1.77-3.17,19.11,19.11,0,0,0-2.24-2.85c.46,1.13,1,2.21,1.48,3.28S429.38,161.28,429.87,162.35Zm-2.21,50.48c-1.33-5.39-2.37-10.87-3.4-16.35s-2-11-3.1-16.45c.66,5.55,1.37,11.08,2.24,16.6s1.85,11,3.16,16.47,2.78,10.81,4.24,16.2,2.95,10.76,4.53,16.11q-1.74-8.19-3.68-16.33C430.36,223.65,429,218.22,427.66,212.83ZM400,196l.25-14.58c-.53,4.84-.89,9.69-1.13,14.55s-.41,9.71-.21,14.62c.39,4.88,1,9.69,1.59,14.52s1.32,9.63,2.1,14.44q-.52-7.29-1.23-14.54l-.69-7.25c-.23-2.41-.49-4.84-.65-7.24s-.11-4.82-.11-7.24S400,198.46,400,196Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363,115.69c-.74-.15-.88.56-.41,1.08,1.1,1.25,3.14,1.16,4.12,1.68.22.15,2.95,2.59,3,3.35-.77-.33-3.1-1.57-3.88-1.86-.23-.08-.87-.2-2.85-.54a2.85,2.85,0,0,0-1-.08c-.24.07-.48.58,0,1.07.78.88,2.2.83,3.3,1.26a5.23,5.23,0,0,1,2.72,2c-1.63-.46-2.68-.38-5.18-.13-.29,0-.34.18-.32.37a1,1,0,0,0,.56.75,9.85,9.85,0,0,0,2.8.34,7.17,7.17,0,0,1,3.11,1.36,3.15,3.15,0,0,1,.85.93c.27.45.42,1,.65,1.45a5.3,5.3,0,0,0,5.14,3,.67.67,0,0,0,.39-.12.76.76,0,0,0,.2-.67c-.11-2.39-1.3-4.58-2.18-6.81-.29-.74-2.56-6.21-2.68-6.39s-5.8-1.55-6-1.57C364.72,116.05,363.68,115.83,363,115.69Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.8,124.67c-1.22,1.57-6.94,8.85-6.94,8.85s-7.69-3.73-10-5.07a13.55,13.55,0,0,1-5.62-6.41c-1.29-2.84-1.74-3-3.11-3.87-.85-.54-2.76-2.08-2.83-2.13a2.68,2.68,0,0,0-1-.36l-1.13-.26c-1.06-.24-1.72-.33-2.78-.57a4.08,4.08,0,0,0-1-.15.36.36,0,0,0-.21,0,.35.35,0,0,0-.09.38,2.38,2.38,0,0,0,1.21,1.48,8,8,0,0,0,1.85.67c.39.11.61.14,1.39.37a1.88,1.88,0,0,1,.81.55,22.16,22.16,0,0,1,3.08,3.58,7.78,7.78,0,0,1-3.63-2c-.94-.92-1.79.29-.91,1.77,1,1.71,2.52,1.94,3.81,4.24s-.57,4.55,2.42,6.4a44.12,44.12,0,0,1,5.06,3.88c2.6,2.21,9.53,7.2,11.25,8.41,3.66,2.56,5.91,2.28,10.81-3.8,6.49-8.05,7.33-9,7.33-9l-.1-14.44C404.23,117.93,403.07,119.11,398.8,124.67Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.47,121.77a9,9,0,0,1,2.16,1.22c.25.21.16-.54-.89-1.33s-1.93-.7-2.18-1.06Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.88,154.47c1.8-1.07-.55-2.79-.21-5.74.66-5.81,3.25-9.89,4-13.25,1.62-7.3-1.74-14.13-3.36-15.71l-3.86-1.2c-1.26-.4-3.31-.81-5.25-1.22a30,30,0,0,0-7.74-.94c-.81,0-4.64.41-4.64.41-1.17.19-3.29.43-3.3.43a20.74,20.74,0,0,0-6.13,6.17c-2.1,3.21-4.32,5.89-4.41,13.08-.19,14.54-2.61,16.18-.06,18C405.15,159.64,422.74,159.47,432.88,154.47Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.45
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.88,154.47c1.8-1.07-.55-2.79-.21-5.74.66-5.81,3.25-9.89,4-13.25,1.62-7.3-1.74-14.13-3.36-15.71l-3.86-1.2c-1.26-.4-3.31-.81-5.25-1.22a30,30,0,0,0-7.74-.94c-.81,0-4.64.41-4.64.41-1.17.19-3.29.43-3.3.43a20.74,20.74,0,0,0-6.13,6.17c-2.1,3.21-4.32,5.89-4.41,13.08-.19,14.54-2.61,16.18-.06,18C405.15,159.64,422.74,159.47,432.88,154.47Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428,115.44a12.42,12.42,0,0,1-4,.12,20.11,20.11,0,0,0-3.27-.38c-1,0-1.82.39-2.83.35a46.79,46.79,0,0,1-5.54-.54,11.86,11.86,0,0,1-4-1.39,6.88,6.88,0,0,1-1.86-1.38,4.23,4.23,0,0,1-.9-1.55,3.73,3.73,0,0,0,.56,2.65,8.65,8.65,0,0,1-3.58-3.85,7.33,7.33,0,0,1-.36-5.21c.6-1.85,2-3.38,2.49-5.25.7-2.49-.22-5.16,0-7.73a10,10,0,0,1,3-5.93,15,15,0,0,1,5.77-3.42,13.71,13.71,0,0,1,13.59,2.58,9.43,9.43,0,0,0,1.21,1c.44.26.93.43,1.39.65a9.92,9.92,0,0,1,5,5.8,15.07,15.07,0,0,1,.7,5.74c-.11,1.92-.72,3.74-.73,5.67,0,3,1.13,6.13,0,8.93a6,6,0,0,1-2.6,3,2.34,2.34,0,0,0-.18-2.64A5.39,5.39,0,0,1,428,115.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.54,115.09c.06-1.56.25-6.08.25-6.08,0,.48,2.51,2.43,4.88.21s2.82-4.81,1.78-6.63c-1.16-2-4.22-2.28-5.81.59-.64,1.16-2-.28-2.16-1-.33-1.51.68-2.48-.23-3.94A9.35,9.35,0,0,1,424,93.09a7,7,0,0,1-4.18-4.63,9.18,9.18,0,0,1-4.27,1.78A21.84,21.84,0,0,0,411,91.36a5.89,5.89,0,0,0-2.36,1.74,4.29,4.29,0,0,0-.69,3.15,17.13,17.13,0,0,1-.58,4.3c-.85,5.11.9,9.24,2.69,10.94a6.66,6.66,0,0,0,4.85,1.77s0,.58-.05,1.62-.5,1.41-1.58,1.64l-2.55.46s-2.79,3.68,3.82,4.86c10.54,1.9,15.43-3.09,15.43-3.09s-.44-.18-2.08-.71C426.42,117.55,426.49,116.66,426.54,115.09Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.91,113.26c4.61.09,8.91-1.16,10.19-4.44a5.1,5.1,0,0,1-2.68,4.4c-2.64,1.5-7.56,1.66-7.56,1.66Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.31,104.85l-4.06,1.25a2.1,2.1,0,0,0,2.62,1.48A2.23,2.23,0,0,0,418.31,104.85Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,105.78a2.35,2.35,0,0,0-2.35,1.8,2.06,2.06,0,0,0,1.18,0,2.18,2.18,0,0,0,1.48-1.75Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.75,95.87l2.7-1a1.39,1.39,0,0,0-1.82-.87A1.52,1.52,0,0,0,408.75,95.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.18,97.39l-2.53-1.49a1.41,1.41,0,0,1,2-.56A1.54,1.54,0,0,1,421.18,97.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.79,98.84a1.1,1.1,0,0,0,1.11,1.1,1.11,1.11,0,1,0-1.11-1.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.48,98.11a1.11,1.11,0,1,0,1.1-1.11A1.1,1.1,0,0,0,409.48,98.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.03 102.02 415.07 103.57 415.45 96.02 411.03 102.02",
    style: {
      fill: "#af6152"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Glass--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.76,185.64l-.08-.08L363.05,148h0a3.09,3.09,0,0,1-.48-3.1,9.77,9.77,0,0,1,6.4-6.15,3.2,3.2,0,0,1,3.13.56h0l37.21,34.08.07.08.12.11a8.63,8.63,0,0,1-.14,12.32,8.92,8.92,0,0,1-12.49-.18Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,138.79c2.76-.69,4.37,1,3.6,3.66a9.79,9.79,0,0,1-6.39,6.14c-2.76.69-4.38-1-3.61-3.65A9.77,9.77,0,0,1,369,138.79Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.74,175.65l-32.41-30.76a8.2,8.2,0,0,0,1.25-2.44,3.08,3.08,0,0,0-.47-3.09l37.2,34.07.07.08.12.11a8.63,8.63,0,0,1-.14,12.32C410.83,183.56,408,179.72,403.74,175.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.38,132.13a5.93,5.93,0,0,1,3.87-3.72,1.92,1.92,0,0,1,1.89.33h0l12.17,12.32h0a1.88,1.88,0,0,1,.29,1.88,5.92,5.92,0,0,1-3.87,3.71,1.91,1.91,0,0,1-1.89-.33L352.67,134h0A1.85,1.85,0,0,1,352.38,132.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.83,135.52l-4.52-4.58c-1.41,2.19-2.9,4.3-4.44,6.3l4.45,4.5C361.9,139.74,363.4,137.66,364.83,135.52Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.73,79.31,357,74.9c-5.83-3.36-13.91-2.88-22.83,2.26-17.83,10.3-32.28,35.34-32.28,55.93,0,10.3,3.61,17.53,9.46,20.9l7.69,4.4a16.64,16.64,0,0,0,8.41,2.14c4.34,0,9.23-1.41,14.42-4.41,17.83-10.29,32.28-35.33,32.28-55.92C374.17,89.92,370.56,82.69,364.73,79.31ZM323.5,108.23c5.66-9.8,13.1-17.69,20.95-22.22a24.67,24.67,0,0,1,11.6-3.72,12.46,12.46,0,0,1,1.78.08c2.45,3.08,3.8,7.77,3.8,13.73,0,9.07-3.12,19.46-8.77,29.26s-13.1,17.68-20.95,22.21c-4.22,2.44-8.32,3.73-11.86,3.73a12.66,12.66,0,0,1-1.52-.09,13.61,13.61,0,0,1-1.21-1.82c-1.68-3-2.59-7-2.59-11.91C314.73,128.41,317.85,118,323.5,108.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.35,103.08l12.13,7c.33-.61.67-1.22,1-1.82a73.06,73.06,0,0,1,5.84-8.65l-12.16-7A78.22,78.22,0,0,0,310.35,103.08ZM325.05,84c-1.5,1.37-3,2.85-4.36,4.4l12.23,7a55.17,55.17,0,0,1,4.49-4.33Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,158.36,311.37,154c-5.84-3.37-9.46-10.6-9.46-20.9,0-.4,0-.79,0-1.19l7.68,4.39c0,.4,0,.8,0,1.19C309.6,147.75,313.2,155,319,158.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.64,87a10.8,10.8,0,0,0-7.81-4.63c2.45,3.08,3.8,7.77,3.8,13.73,0,9.07-3.12,19.46-8.77,29.26s-13.1,17.68-20.95,22.21c-4.22,2.44-8.32,3.73-11.86,3.73a12.66,12.66,0,0,1-1.52-.09,10.89,10.89,0,0,0,8.28,4.18l.66,0c3.54,0,7.64-1.29,11.86-3.73,7.85-4.53,15.29-12.42,20.95-22.22s8.77-20.19,8.77-29.26C369.05,94.57,367.84,90.08,365.64,87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.89,81.56c-17.83,10.3-32.29,35.34-32.29,55.92s14.46,28.94,32.29,18.64,32.28-35.33,32.28-55.92S359.72,71.27,341.89,81.56Zm-2.56,70.12c-4.23,2.44-8.32,3.73-11.86,3.73a11.11,11.11,0,0,1-10.15-6c-1.69-3-2.59-7-2.59-11.91,0-9.07,3.11-19.46,8.77-29.25S336.6,90.54,344.45,86a24.71,24.71,0,0,1,11.6-3.72h.26c8,0,12.74,6.7,12.74,17.92,0,9.08-3.12,19.47-8.77,29.26S347.18,147.15,339.33,151.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.43,108.62A75.12,75.12,0,0,0,310.88,127a52.38,52.38,0,0,0-1.1,9.67,36,36,0,0,0,1.06,9.65,21.6,21.6,0,0,0,4.28,8.61,15.48,15.48,0,0,0,8.11,5,20.12,20.12,0,0,0,9.63-.15,34.59,34.59,0,0,0,9-3.63,34.63,34.63,0,0,1-9,3.82,20.52,20.52,0,0,1-9.73.21,15.77,15.77,0,0,1-8.29-5.05,21.59,21.59,0,0,1-4.41-8.72,36.3,36.3,0,0,1-1-9.74,52.15,52.15,0,0,1,1.17-9.73,68.22,68.22,0,0,1,2.75-9.39A82,82,0,0,1,317.43,108.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.31,82.28a12.18,12.18,0,0,1,4.73.87A11,11,0,0,1,365,86a14.48,14.48,0,0,1,2.54,4.14,21.88,21.88,0,0,1,1.35,4.69,37.58,37.58,0,0,1,.27,9.71,53.33,53.33,0,0,1-1.8,9.54,62.7,62.7,0,0,1-3.34,9.13,72.57,72.57,0,0,1-4.56,8.58,66.76,66.76,0,0,1-12.38,14.95,46.73,46.73,0,0,1-7.94,5.66,27.28,27.28,0,0,1-9.21,3.32,14.76,14.76,0,0,1-5-.05,11.19,11.19,0,0,1-6.4-3.72,12.53,12.53,0,0,1-1.44-2,17.73,17.73,0,0,1-1.84-4.57,32.43,32.43,0,0,1-.82-9.71A50.14,50.14,0,0,1,316,126a63,63,0,0,1,3.14-9.16,71.9,71.9,0,0,1,4.4-8.61,69.9,69.9,0,0,0-7.05,17.89,50.12,50.12,0,0,0-1.35,9.5,31.75,31.75,0,0,0,.93,9.48,17.28,17.28,0,0,0,1.82,4.34,11.57,11.57,0,0,0,3.06,3.47,10.3,10.3,0,0,0,4.21,1.82,14,14,0,0,0,4.66,0,26.27,26.27,0,0,0,8.86-3.26,46.52,46.52,0,0,0,7.75-5.57,65.7,65.7,0,0,0,12.26-14.67,71.81,71.81,0,0,0,7.93-17.43,52.09,52.09,0,0,0,1.92-9.4,37.3,37.3,0,0,0-.13-9.56,21.08,21.08,0,0,0-1.2-4.62,14.1,14.1,0,0,0-2.39-4.11,10.79,10.79,0,0,0-3.8-2.85A12.43,12.43,0,0,0,356.31,82.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,82.83a12.27,12.27,0,0,0-3.71-.55h-.26A24.67,24.67,0,0,0,344.45,86c-7.85,4.53-15.29,12.42-20.95,22.22s-8.77,20.18-8.77,29.25c0,4.89.91,8.92,2.59,11.91a12.22,12.22,0,0,0,2.81,3.46,12,12,0,0,0,3.71.55c3.54,0,7.64-1.28,11.86-3.72,7.85-4.53,15.29-12.43,20.95-22.22s8.76-20.19,8.76-29.26C365.41,91.06,363.49,85.75,360,82.83Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.62,120.28c-5.22,1.83-8.42,8.75-8.42,8.75l-10.55,15.82s-13,6.06-17.45,7.78c-1.92.73-3.76.35-6.36.41-.67,0-2.86.29-3.46.34l2,2.4c1,.76-1.28,2-4.2,2.6s-6.41.27-7.4,2c-.48.85,0,1.19,1.27,1.39-.1.48.08,1.05,1.47,1.45a4.76,4.76,0,0,0,2.51,1.87,17.08,17.08,0,0,0,8.9-.71c2.91-1.27,4.9-3,8-3.91s13.06-3.25,17-4.8,5.25-2.21,6.83-4.21,10.83-13.37,13.35-18.36C440,127.46,438.8,122.39,433.62,120.28Z",
    style: {
      fill: "#c8856a"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chartacter--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.35,419.28l-1.1-10.19,11.79.77s-.18,5.53-.35,8.66c-.09,1.85,2.43,5.29,2.43,5.29s-5.54,2.93-8.51,1.9a7.73,7.73,0,0,1-4.5-5.47C105.16,419.44,105.35,419.28,105.35,419.28Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.75,435.19a2.52,2.52,0,0,1-.5,2.72,13.26,13.26,0,0,1-9.08,2.07c-4.53-.47-7-1.72-8.84-3.09s-4.4-3.31-6.46-3.69a13.14,13.14,0,0,1-4.6-1.65c-.62-.54-.57-2.95-.57-2.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.35,419.26a.73.73,0,0,0-.68.58c-.12.67-.24,2.61-.52,3.71a18.1,18.1,0,0,0-.35,5.88c.27,1.23,3.38,2,5.37,2.7a25.6,25.6,0,0,1,6.48,3.64,19,19,0,0,0,9.6,3.13c3.49-.08,7.4-1.19,8.28-2.7,1.08-1.88,1.86-4-3.35-6.17-1-.4-4.46-2.23-5.64-2.89-3.2-1.8-5.46-3.45-7-6.7a1.74,1.74,0,0,0-.76-1,1.7,1.7,0,0,0-1-.07,35.22,35.22,0,0,0-5.07,1c-.69.32-1.67.69-1.65,1.51a2.73,2.73,0,0,0,.21.84c.07.16.12.39,0,.49s-.35,0-.48-.12a12.72,12.72,0,0,1-1.42-1.52,5,5,0,0,0-.83-.76,7.84,7.84,0,0,1-.9-.52C105.3,420,105.37,419.65,105.35,419.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.65,435.77c-.91-.67-1.88-1.32-2.85-1.9h0s6.14,3.32,8.57,1.72a2,2,0,0,0,.75-2.62c0-.38,5.5-3.22,7-3.42h0c.43.22.79.39,1,.48,5.21,2.13,4.43,4.29,3.35,6.17-.88,1.51-3.7,2.72-8.21,2.8A19.49,19.49,0,0,1,115.65,435.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.68,431.85c3.23,1.13,1.87,1.71,1,1.85s-6.36-2.7-9.7-5.06c-3.49-2.47-5.71-5.19-7-6.09-.48-.34-1-.75-1.47-1.14.08-.66.13-1.26.19-1.57a.73.73,0,0,1,.68-.58c0,.39,0,.75.27,1a7.84,7.84,0,0,0,.9.52,5,5,0,0,1,.83.76,12.72,12.72,0,0,0,1.42,1.52C111.63,426.34,118.44,430.71,121.68,431.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.42,433.26a.31.31,0,0,1-.21-.06.27.27,0,0,1,0-.41c.89-1.05,5.16-3.56,7.53-3.36a.29.29,0,0,1,.28.32.3.3,0,0,1-.34.27c-2.22-.19-6.26,2.3-7,3.13A.32.32,0,0,1,122.42,433.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.58,431.71a.36.36,0,0,1-.2-.06.27.27,0,0,1,0-.41c.89-1.05,5.15-3.56,7.52-3.36a.3.3,0,0,1,.29.32.31.31,0,0,1-.34.27c-2.22-.18-6.27,2.3-7,3.13A.33.33,0,0,1,119.58,431.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.75,430.25a.31.31,0,0,1-.2-.07.27.27,0,0,1,0-.41c.89-1,5.15-3.56,7.52-3.36a.3.3,0,1,1-.06.59c-2.21-.18-6.26,2.31-7,3.14A.36.36,0,0,1,116.75,430.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.12,428.56a.36.36,0,0,1-.2-.06.27.27,0,0,1,0-.41c.89-1,5.16-3.56,7.52-3.36a.3.3,0,0,1,.29.32.32.32,0,0,1-.35.27c-2.21-.18-6.26,2.3-7,3.13A.36.36,0,0,1,114.12,428.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.54,426.88a.35.35,0,0,1-.19-.06.29.29,0,0,1-.06-.42c1.22-1.47,5.7-3.59,8.07-3.39a.29.29,0,0,1,.28.32.31.31,0,0,1-.34.27c-2.14-.18-6.42,1.85-7.51,3.16A.3.3,0,0,1,111.54,426.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,424.84l2.7-9.65-12-1.84-.54,9.34s-1.27,3.33-.54,4.56,8.71,2.62,9.46,1.82S82,424.84,82,424.84Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8,445.88c-.39,3-1,4.92-2.39,6.52s-3.66,1.85-6,1-5.2-2.62-5.7-5.31a14.57,14.57,0,0,1,.45-7.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.18,422.69c-1-.07-.77,4-1.58,8-.87,4.27-2.47,5.87-3.22,9.36-.87,4-.74,5.84.73,8.53s7.07,5.87,10.13,2.73c2.5-2.57,2.8-5.74,2.85-9.84a90.74,90.74,0,0,1,.44-10.38c.38-3,1.31-5.7.5-6.15-.09.43-.19,1-.29,1.43s-.27,2-.81,1.91a4.91,4.91,0,0,1,.06-1.15,1.28,1.28,0,0,0-.2-1,4.52,4.52,0,0,0-1.54-.8c-.94-.3-2.61-.67-3.57-.87-.47-.1-1-.19-1.43-.25a4.23,4.23,0,0,0-1.23,0,.74.74,0,0,0-.54.34,1.17,1.17,0,0,0-.08.46,2.87,2.87,0,0,1-.18.82c0,.12-.14.25-.28.2a.26.26,0,0,1-.14-.26c0-.5.12-.84.18-1.41,0-.27.11-.62.13-.88S72.15,423,72.18,422.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.67,438.94c-.13.58-1,4.39.22,5.25s2.17-2,2.17-2,3.11-.41,7.46,1.9c-.26.6.29,2.78,1.54,2.5s2-4.67,2-4.72c-.06,3.92-.41,7-2.84,9.48-3.06,3.14-8.66-.05-10.13-2.73s-1.6-4.54-.73-8.53A11.63,11.63,0,0,1,67.67,438.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.39,442.48c-.11,1.47-1.74.75-1.68-1.34s1.67-6.85,1.89-10.43c.34-4.91.62-8.09,1.58-8,0,.05,0,.1,0,.15l-.26,2a8.13,8.13,0,0,0-.11.88c-.21,3-.33,8.83-.8,11.53A41.39,41.39,0,0,0,70.39,442.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,444a40.65,40.65,0,0,0,1.24-5c.51-2.68,2.21-8,3-10.9a6.27,6.27,0,0,0,.44-1.63c.09-.41.18-.92.27-1.34a.29.29,0,0,0,0-.09c.59.34.35,2.66,0,3.86s-.73,2.49-1.14,4.21c-1,3.39-1.21,8.5-1.88,10.45S76.6,445.37,77,444Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.61,444.21a.38.38,0,0,1-.13-.06,13.34,13.34,0,0,0-7.35-1.67.39.39,0,0,1-.42-.28.29.29,0,0,1,.27-.35,14,14,0,0,1,7.87,1.79.32.32,0,0,1,.12.45A.36.36,0,0,1,77.61,444.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.62,441.12l-.12-.05a16.54,16.54,0,0,0-8.24-1.87.38.38,0,0,1-.41-.29.3.3,0,0,1,.29-.34,17.14,17.14,0,0,1,8.7,2A.31.31,0,0,1,79,441,.34.34,0,0,1,78.62,441.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.69,436.2a.39.39,0,0,1-.29-.25.29.29,0,0,1,.25-.37c4.39-.69,8.52,1.8,8.69,1.91a.31.31,0,0,1,.13.44A.38.38,0,0,1,79,438s-4.06-2.45-8.14-1.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.12,433.37a.4.4,0,0,1-.29-.24.28.28,0,0,1,.24-.37,12.91,12.91,0,0,1,8.87,1.9.31.31,0,0,1,.1.45.38.38,0,0,1-.5,0,12.34,12.34,0,0,0-8.26-1.76A.42.42,0,0,1,71.12,433.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.61,430.2a.4.4,0,0,1-.28-.24.29.29,0,0,1,.23-.38c4.53-.86,8.76,1.88,8.93,2a.31.31,0,0,1,.11.44.37.37,0,0,1-.5.05S76,429.4,71.78,430.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.53,322.92c-2.74,22.84-5,55.63-5,55.63-.2,1.79-1.51,4.85-2.52,13.72C70.92,401.62,70.45,426,70.45,426c1.11,3.59,9.86,5.33,12.55,1.88,0,0,8-29.22,10.54-40.31,2.56-11.38,5.29-28.26,5.29-28.26l1.48,16.92s-.51,5.8-.4,10.53c.14,5.5,4.24,36.8,4.24,36.8s8.46,2.08,14-2c0,0,1.53-37.72,1.8-44.33.53-13-1.32-39.62-1.49-56.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.83,359.3l3-16.81s6.36-.82,9.66-3.73c0,0-2.17,3.88-8.17,5.3l-3,15.31,0,16.85Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.18,297c-1.53,1.25-3.1,3.19-5.71,5.41s-6.54,6.11-10.34,8.47-5.69,3.32-10.58-1.55a133.21,133.21,0,0,1-12.37-14.91l-.28-18.35c4.06,1.14,6.43,3.25,9,7,4.85,7.1,8.13,11.68,10.94,15.78,0,0,11.19-6.89,12.64-8a6.08,6.08,0,0,0,2.25-3.28,27.2,27.2,0,0,1,1.08-3.23c.43-1.13.59-1.55,1.09-3s.85-3.77,1-4.29c.32-.6,1.19-.57,2,.85a5.63,5.63,0,0,1,.4,2.83c0,.85-.25,1.9,0,2s1.47-.53,2.69-.85,2.28-.88,3.65-.5a1.61,1.61,0,0,1,1.17,2.09,2,2,0,0,1-.71.84,1.74,1.74,0,0,1,1.32.37,1.89,1.89,0,0,1,.09,2.38,1.07,1.07,0,0,1,1.07.91c.17.8.1,1.6-.7,1.93,0,0,.67.14.72.53a1.93,1.93,0,0,1-.57,1.79,6.19,6.19,0,0,1-2.29.6s-.11.29-.87.71a20.37,20.37,0,0,1-2.52,1.45A16,16,0,0,0,150.18,297Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.84,298.87a8.92,8.92,0,0,0-3.73,6,6.84,6.84,0,0,1,3.19-6.77Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.9,276a12.8,12.8,0,0,1,6.07,3.37c1.73,1.67,4.87,6.46,6.74,9.12s3.87,5.45,3.87,5.45.23,7-8.49,10.86l-8.2-10.14Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.85,291.14a3.86,3.86,0,0,0,1-.36,10.09,10.09,0,0,1,1-.28c.67-.16,1.35-.31,2-.49-.69.06-1.38.15-2.06.27a6.15,6.15,0,0,0-1,.24,4.09,4.09,0,0,1-1,.32,2.18,2.18,0,0,1-.93-.22,2.29,2.29,0,0,1-.84-.48,1.89,1.89,0,0,1-.2-.43.52.52,0,0,1,.09-.43,1.07,1.07,0,0,1,.58-.4,3.6,3.6,0,0,0,.73.13,3.39,3.39,0,0,0,1.15-.32q.53-.22,1-.48c.68-.33,1.37-.67,2-1-.72.25-1.43.54-2.14.83a7.61,7.61,0,0,1-2.11.71,2.87,2.87,0,0,1-1.06-.22,5.86,5.86,0,0,1-1-.52.94.94,0,0,1-.48-.87.86.86,0,0,1,.28-.53l.26-.05c.42-.08.87-.11,1.31-.19a4.6,4.6,0,0,0,1.3-.42,10.78,10.78,0,0,0,2.22-1.49,8.12,8.12,0,0,1-1.13.69c-.39.21-.78.43-1.18.6a5.09,5.09,0,0,1-1.25.36c-.43.07-.87.09-1.33.16-.22,0-.44.1-.64.13s-.29,0-.4-.21a1.13,1.13,0,0,1,.24-1.1,4.12,4.12,0,0,1,2.11-1.43h0v0a1.66,1.66,0,0,1,.27-.53,3.47,3.47,0,0,1,.4-.46,2.55,2.55,0,0,0-.45.42,1.89,1.89,0,0,0-.33.5,4,4,0,0,0-2.27,1.39,2.34,2.34,0,0,0-.32.63,1,1,0,0,0,.05.75.8.8,0,0,0,.27.32h.06a5.05,5.05,0,0,1-.22,4.14,4.89,4.89,0,0,1-1.95,2,5.62,5.62,0,0,0,2.25-1.56,4.7,4.7,0,0,0,1.1-2l.25.36a1.09,1.09,0,0,0,0,.18,1.75,1.75,0,0,0,.2.52,2,2,0,0,0,.91.6,3.55,3.55,0,0,0,.65.22.57.57,0,0,0-.08.28.87.87,0,0,0,.13.45,3.07,3.07,0,0,0,.59.65,3.32,3.32,0,0,0,.36.26,1.12,1.12,0,0,0,.43.16,3.55,3.55,0,0,0,.86,0l-.8-.27a1.07,1.07,0,0,1-.34-.16l-.32-.26a5.18,5.18,0,0,1-.59-.55.69.69,0,0,1-.18-.58A2,2,0,0,0,155.85,291.14Zm-3-4.54h0l0,0Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.93,274.42c-2.36.49-5.36,1.1-8.37,1.94a30.57,30.57,0,0,0-7.73,2.88,121.77,121.77,0,0,0,2.29,21.87c.51,2.4,2.26,9,2.56,14.09A81.53,81.53,0,0,1,79.25,331s7.82,5.8,24.51,4.54c13.11-1,14.81-5.82,14.81-5.82s-.24-21.85-.58-31.51c-.44-12.7-4.29-20-7.12-22.25l-8.6-1.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,275.43l11.15.12,8.26,1.38c2.18,1.89,6.1,8.52,6.55,21.33.32,9,.55,28.86.58,31.26-.42.72-3,4.22-13.88,5-1.55.12-3.09.18-4.58.18-11,0-17.14-3.22-18.8-4.23a81.31,81.31,0,0,0,.37-15.37,82.34,82.34,0,0,0-2.2-12.57c-.16-.67-.29-1.24-.38-1.67a121.43,121.43,0,0,1-2.26-21.07,31,31,0,0,1,6.82-2.47l.17,0c2.87-.8,5.74-1.39,8-1.86l.15,0m-.1-1c-2.36.49-5.36,1.1-8.37,1.94a30.57,30.57,0,0,0-7.73,2.88,121.77,121.77,0,0,0,2.29,21.87c.51,2.4,2.26,9,2.56,14.09A81.53,81.53,0,0,1,79.25,331s6.36,4.72,19.86,4.72q2.2,0,4.65-.18c13.11-1,14.81-5.82,14.81-5.82s-.24-21.85-.58-31.51c-.44-12.7-4.29-20-7.12-22.25l-8.6-1.43-11.34-.13Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.18,247a4.69,4.69,0,0,0-3.44,2.78c-.69,1.31-1.18,3.71.7,10.57a27.26,27.26,0,0,0,3.3,7.57,3.36,3.36,0,0,0,2,1.57l-.14-5.27-.2-3.67s3-2.69,3.22-5.33a8.45,8.45,0,0,0-1-5.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.46,247.17c.51-3,4.27-6.51,11.52-6.89,6-.32,9.3,2.8,11.37,6.26a6.93,6.93,0,0,1,.34,6.6l-18.18-.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.75,265.75c2.73,1.33,4-.83,4-.83l0,11.13c5.25,7,19.68,4.23,13.94-1v-2.48a16.76,16.76,0,0,0,2.37-.23,5.11,5.11,0,0,0,4.64-4.13,33.2,33.2,0,0,0,.82-5.5c.16-2.75.19-5.28-.5-7.18-.48-1.35.09-3.12-.28-4.79a4.53,4.53,0,0,0-2-3.24c-2.9-1.44-5.58.63-9.63,2.21-1.67.65-5.74.94-6.81.43,1.41,1.56,1.4,6.48-.68,8.48a4.49,4.49,0,0,1-1,1.36c-.88.77-1.61-1.22-2.35-2a3,3,0,0,0-4.74,1.1A5,5,0,0,0,83.75,265.75Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.63,272.54a21.93,21.93,0,0,1-7.86-1.2c-1.88-.79-3.54-3.32-4.08-5.84,0,2,.89,5.61,3.72,7.1s6.15,1.57,8.23,1.62Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.62,254l-2.68,1.13a1.53,1.53,0,0,1,.81-2A1.41,1.41,0,0,1,96.62,254Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.61,254.37l-2.73-1.08a1.41,1.41,0,0,1,1.86-.85A1.54,1.54,0,0,1,107.61,254.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.48,257.19a1.2,1.2,0,0,0,1.23,1.15,1.18,1.18,0,0,0,1.14-1.23A1.17,1.17,0,0,0,96.63,256,1.18,1.18,0,0,0,95.48,257.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.63,256.71a1.2,1.2,0,0,0,1.23,1.14,1.19,1.19,0,0,0-.08-2.37A1.19,1.19,0,0,0,104.63,256.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.59,255l1,7.55,4-1.48A17.61,17.61,0,0,0,100.59,255Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3,263.57l4.3.75a2.14,2.14,0,0,1-2.47,1.85A2.29,2.29,0,0,1,98.3,263.57Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.84,264.25a2.33,2.33,0,0,0-.53,0,2.27,2.27,0,0,0,1.82,1.89,2.05,2.05,0,0,0,.7,0A2,2,0,0,0,98.84,264.25Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "132.71 306.66 106.32 313.42 96.57 343.25 97.09 343.91 122.23 336.98 133.22 307.32 132.71 306.66",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.83 314.08 97.09 343.91 96.57 343.25 106.32 313.42 106.83 314.08",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.22 307.32 106.83 314.08 97.09 343.91 122.23 336.98 133.22 307.32",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125,312.87s.14-.44.3-1-1.36-.39-3.41.37l-4.74,1c-2,.75-4,1.28-4.14,1.83l-.3,1Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M126.89,308.39c.11-.35-.48-.32-1.32-.18l-1.52.37s.74-1.43-2.84-.79c-3.93.7-4.18,2.61-4.18,2.61a19.6,19.6,0,0,1-1.9.51c-1.31.3-1.48.53-1.61.88l-.25.63L126.72,309Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.35,310.23c-1.26.44-1.78.66-2,1.51s-.37,1.39-.37,1.39l-7,2.08s.5-1.43.64-1.91-.77-.56-2-.12l.38-1.2,10.92-3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.31,312.92s.14-.45.3-1-1.36-.39-3.41.36l-4.74,1c-2,.76-4,1.29-4.14,1.84l-.3,1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.48,291.24c2.4-9.63,5.11-11.82,10.58-12.83,4.87,7.78,2.09,19.9,2.09,19.9l-3.31,14.76c.9.78,14.41,9.45,16.8,10.29a6.79,6.79,0,0,0,3.39-.28c2.35-.74,4-.47,6.23-.32l-1,3.2a14.68,14.68,0,0,0,2.91.73,17.42,17.42,0,0,0,4.73.06c1.43-.14,3-.41,4.19.38.29.18.56.5.46.83a1.11,1.11,0,0,1-.5.48,2.92,2.92,0,0,0-1.07,1.38A4.85,4.85,0,0,1,111,332.4a16.7,16.7,0,0,1-2.4,1.6,16.87,16.87,0,0,1-4.81,1.35,8.3,8.3,0,0,1-1.79.18A26.53,26.53,0,0,1,95.28,334c-2.72-.82-4.28-1.54-6.48-2.26-1.48-.49-4.31-1.53-5.76-2.08-8.46-3.17-20-7.31-20.55-11.37S65,301.18,67.48,291.24Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,277.76c-6.22,1.9-7.45,2.78-9.24,7.73A214,214,0,0,0,63,308.82c2.86,2.81,11.59,4.6,14.69,2.56l2.94-12.81C81.6,294.27,83.61,284.53,78,277.76Z",
    style: {
      fill: "#37474f"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.65,89.45l2.48-4.66-2-5.75V75.51l6.1,3.53v3.52l-2.63,4.54a.33.33,0,0,1-.17.16h0Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.65,89.45l2.48-4.66-2-5.75V75.51l6.1,3.53v3.52l-2.63,4.54a.33.33,0,0,1-.17.16h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.57,43.17A4.07,4.07,0,0,1,422.4,40l1.49-.86a4.07,4.07,0,0,1,3.66,0L457.9,56.7a4,4,0,0,1,1.83,3.17V85a4,4,0,0,1-1.83,3.17l-1.49.86a4.07,4.07,0,0,1-3.66,0l-7.34-4.24-2.62,4.53a.39.39,0,0,1-.71-.07l-2.76-8-16.92-9.8a4,4,0,0,1-1.83-3.16Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.73,85a4,4,0,0,1-1.83,3.17l-1.49.86a4.11,4.11,0,0,1-3.35.15c.86.32,1.52-.16,1.52-1.21V62.84A3.68,3.68,0,0,0,454,61l5.15-3a3.78,3.78,0,0,1,.54,1.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.63,42.65c.21-.77.92-1,1.77-.54l30.35,17.56A3.56,3.56,0,0,1,454,61l5.15-3a3.8,3.8,0,0,0-1.29-1.37L427.55,39.15a4.07,4.07,0,0,0-3.66,0L422.4,40A4,4,0,0,0,420.63,42.65Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.06,57.74a.86.86,0,0,1,.12-.53.88.88,0,0,1,.34-.23L431.9,54H432l.07,0a.65.65,0,0,1,.24.29,1,1,0,0,1,.09.42v4c0,.33-.06.53-.18.62a1.3,1.3,0,0,1-.33.17l-2.79,1.06,2.79,4.32a4.21,4.21,0,0,1,.33.53,1.69,1.69,0,0,1,.18.82v4a.44.44,0,0,1-.09.31.19.19,0,0,1-.24,0l-.07,0-.11-.13-6.38-10.31a5.12,5.12,0,0,1-.34-.63,1.71,1.71,0,0,1-.12-.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,56.32a1.08,1.08,0,0,1,.24-.37c.11-.09.26-.08.46,0l2.14,1.23a.67.67,0,0,1,.25.31,1,1,0,0,1,.1.44.75.75,0,0,1,0,.2l-5.39,16.76a.77.77,0,0,1-.23.36c-.1.1-.26.09-.47,0L434,74.05a.59.59,0,0,1-.25-.3,1,1,0,0,1-.11-.44.79.79,0,0,1,0-.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.7,73.58a.84.84,0,0,1-.12.53.9.9,0,0,1-.34.24l-6.39,2.94h-.1l-.07,0a.59.59,0,0,1-.24-.29,1,1,0,0,1-.1-.42v-4c0-.33.07-.53.19-.61a1,1,0,0,1,.32-.15l2.8-1.1-2.8-4.28c-.09-.14-.2-.32-.32-.55a1.75,1.75,0,0,1-.19-.83v-4a.42.42,0,0,1,.1-.31.18.18,0,0,1,.24,0l.07.05.1.12,6.39,10.32a4,4,0,0,1,.34.63,1.67,1.67,0,0,1,.12.67Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--SEO--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.84,189.75c0-13,8.51-28.88,18.48-34.64,4.48-2.58,8.62-2.82,11.84-1.15-1.39-.81-4.64-2.67-5.51-3.19-3.28-1.94-7.6-1.8-12.28.9-10,5.76-18.48,21.61-18.48,34.64,0,7,2.46,12,6.28,14.23.91.54,4.29,2.49,5.68,3.28C246.18,201.52,243.84,196.59,243.84,189.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.79,163a13.32,13.32,0,0,1,1.42,6.4c0,8.11-5,17.86-10.84,21.25a8.4,8.4,0,0,1-3.4,1.16c1.88,3.45,5.42,4.55,9.35,2.28,5.88-3.4,10.84-13.14,10.84-21.24C273.16,166.43,270,162.59,265.79,163Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.84,189.75c0-13,8.51-28.88,18.49-34.64s18.48.27,18.48,13.3-8.41,28.89-18.48,34.71S243.84,202.78,243.84,189.75Zm29.32-16.93c0-8-5-12-10.83-8.66s-10.79,13.11-10.79,21.15,5,12.12,10.79,8.76S273.16,180.92,273.16,172.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.68,152.9v.73c6.32,0,10.4,5.8,10.4,14.78,0,12.8-8.3,28.4-18.12,34.07a13.89,13.89,0,0,1-6.91,2.08c-6.36,0-10.48-5.81-10.48-14.81,0-12.76,8.3-28.34,18.12-34a14.11,14.11,0,0,1,7-2.11v-.73M258.33,196a8.69,8.69,0,0,0,4.36-1.29c6.07-3.5,11.21-13.52,11.21-21.88,0-6.34-3-10.6-7.52-10.6a8.92,8.92,0,0,0-4.42,1.3c-6,3.49-11.15,13.47-11.15,21.79,0,6.39,3,10.68,7.52,10.68m11.35-43.09a14.84,14.84,0,0,0-7.35,2.21c-10,5.76-18.49,21.61-18.49,34.64,0,9.69,4.7,15.54,11.21,15.54a14.75,14.75,0,0,0,7.28-2.17c10.07-5.82,18.48-21.68,18.48-34.71,0-9.67-4.63-15.51-11.13-15.51Zm-11.35,42.36c-3.93,0-6.79-3.8-6.79-9.95,0-8,5-17.79,10.79-21.15a8.15,8.15,0,0,1,4.05-1.21c3.93,0,6.78,3.78,6.78,9.87,0,8.1-5,17.86-10.83,21.25a8.07,8.07,0,0,1-4,1.19Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.24,189.2v9.25l17.47-10.09v9l-17.47,10.09v10.19l19.3-11.14v9l-26.79,15.47V184.54l26.79-15.46v9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.8,170.35v7.28l-18.92,10.93-.37.21v10.95l1.1-.64L237,189.63v7.29l-17.1,9.87-.37.21v11.89l1.1-.63,18.19-10.51V215l-25.32,14.62V185l25.32-14.62m.74-1.27-26.79,15.46v46.39l26.79-15.47v-9l-19.3,11.14V207.43l17.47-10.09v-9l-17.47,10.09V189.2l19.3-11.14v-9Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.75 230.93 206.79 227.49 206.79 181.1 212.75 184.54 212.75 230.93",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.54 169.08 233.58 165.64 206.79 181.1 212.75 184.54 239.54 169.08",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.76 184.92 220.24 191.57 220.24 198.45 237.72 188.36 231.76 184.92",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.58 203.04 220.24 210.75 220.24 217.62 239.54 206.48 233.58 203.04",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.87,209.83c-2.17-1.41-5.62-.93-9.9.27l-1.35.36a10.85,10.85,0,0,1,14.9-7.25l3.9-9.41c-2-1.13-6-3.44-6-3.44-3.54-2-8-1.82-13.62,1.45-7.59,4.39-12.86,13.3-12.86,21.88,0,3.82.94,6,2.59,7,1.06.68,5.18,3,6.1,3.52,2.23,1.32,5.69.76,9.82-.38l1.24-.32a11,11,0,0,1-5.52,7.06c-4.41,2.54-8.15,2.41-11.44.53l-4.31,9.31c2,1.29,6,3.43,6,3.43,4.05,2.66,9.41,2.26,15.44-1.22a26.41,26.41,0,0,0,13.52-22.52c0-3.75-.95-5.88-2.65-6.92C203.69,212.57,199.73,210.38,198.87,209.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.42,243.86l4.3-9.3c3.29,1.88,7,2,11.44-.53,3.75-2.17,5.68-5.57,5.68-8.48,0-3.3-2-3.15-7.35-1.7-7.34,2-12.56,2.26-12.56-6.72,0-8.58,5.27-17.49,12.87-21.88,5.67-3.27,10.07-3.45,13.62-1.45l-3.9,9.41a10.23,10.23,0,0,0-9.93.6c-3.19,1.84-5.11,5.18-5.11,7.95,0,3.37,2.08,3.26,7.44,1.78,7.5-2.1,12.46-2,12.46,6.58a26.41,26.41,0,0,1-13.52,22.52C187.83,246.12,182.47,246.52,178.42,243.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.44,193.23a9.17,9.17,0,0,1,4.05.91l-3.36,8.09a10.27,10.27,0,0,0-3.9-.77,12,12,0,0,0-6,1.71c-3.23,1.87-5.48,5.4-5.48,8.59,0,2.35,1,3.5,3.14,3.5a22,22,0,0,0,5.23-1,24.32,24.32,0,0,1,6.23-1.1c2.62,0,5.3.83,5.3,7,0,8.82-5,17.2-13.16,21.89a18.55,18.55,0,0,1-9.11,2.85,10.06,10.06,0,0,1-5-1.28l3.71-8a10.68,10.68,0,0,0,4.71,1.12,13.54,13.54,0,0,0,6.76-2c3.67-2.11,6-5.69,6-9.11,0-2.29-1-3.41-3.06-3.41a21.65,21.65,0,0,0-5.21,1,25.16,25.16,0,0,1-6.33,1.12c-2.62,0-5.3-.85-5.3-7.14,0-8.26,5.14-17,12.49-21.24a17,17,0,0,1,8.28-2.66m0-.73a17.58,17.58,0,0,0-8.64,2.75c-7.6,4.39-12.87,13.3-12.87,21.88,0,6,2.32,7.87,6,7.87a26.16,26.16,0,0,0,6.52-1.15,21.84,21.84,0,0,1,5-1c1.63,0,2.33.75,2.33,2.68,0,2.91-1.93,6.31-5.68,8.48a12.76,12.76,0,0,1-6.39,1.93,10,10,0,0,1-5.05-1.4l-4.3,9.3a10.59,10.59,0,0,0,6,1.73,19.29,19.29,0,0,0,9.48-3,26.41,26.41,0,0,0,13.52-22.52c0-5.79-2.26-7.72-6-7.72a24.89,24.89,0,0,0-6.43,1.14,21.71,21.71,0,0,1-5,1c-1.69,0-2.41-.77-2.41-2.76,0-2.77,1.92-6.11,5.11-7.95a11.25,11.25,0,0,1,5.64-1.61,9.55,9.55,0,0,1,4.29,1l3.9-9.41a10,10,0,0,0-5-1.3Z",
    style: {
      fill: "#0C0C0C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.72 234.56 176.76 231.12 172.46 240.43 178.42 243.86 182.72 234.56",
    style: {
      fill: "#263238"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeo2);
export default __webpack_public_path__ + "static/media/seo2.9100d453f5b35d11477e748de220a539.svg";
export { ForwardRef as ReactComponent };